webpackJsonp([105,103],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _vue = __webpack_require__(81);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(1317);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueBus = __webpack_require__(1074);
	
	var _vueBus2 = _interopRequireDefault(_vueBus);
	
	var _elementUi = __webpack_require__(927);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(944);
	
	__webpack_require__(1047);
	
	__webpack_require__(113);
	
	var _routes = __webpack_require__(690);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _chedai = __webpack_require__(1075);
	
	var _chedai2 = _interopRequireDefault(_chedai);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueBus2.default);
	_vue2.default.use(_elementUi2.default);
	
	global.title = document.title;
	
	var el = '#page',
	    mode = 'history',
	    render = function render(h) {
		return h(_chedai2.default);
	},
	    router = new _vueRouter2.default({ mode: mode, routes: _routes2.default }),
	    methods = {
		pushRoute: function pushRoute(key) {
			router.push(key);
		}
	},
	    vm = new _vue2.default({
		el: el, router: router, render: render, methods: methods,
		created: function created() {
			global.$bus = this.$bus.on('push-router', this.pushRoute);
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			next(function (vm) {
				console.log([to, vm.areaName]);
			});
		},
		beforeDestroy: function beforeDestroy() {
			this.$bus.off('push-router');
			global.$bus = undefined;
		}
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "城市地区选择",
		props: { label: "name", value: "id", children: "childrens" },
		getProvinceList: function getProvinceList(vm) {
			var u = _p.getApiUrl("address/province"),
			    storeList = _p.getStoredProp("_/cityCache/province"),
			    func = function func(callback, reject) {
				if (!_p.isNull(storeList)) {
					return callback(_p.clone(storeList));
				}
	
				_jquery2.default.get(u, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;else reject(new Error(json.msg));
								break;
						}
						return;
					} else {
						var provList = _p.clone(json.data);
	
						storeList = provList.map(function (item) {
							return _jquery2.default.extend({ childrens: [] }, item);
						});
	
						_p.setStoredProp("_/cityCache/province", storeList);
						return callback(storeList);
					}
				});
			};
			return new _promise2.default(func);
		},
		getCitys: function getCitys(pid) {
			var u = _p.getApiUrl("address/city"),
			    storeList = _p.getStoredProp("_/cityCache/city_" + pid),
			    func = function func(cb, reject) {
				if (!_p.isNull(storeList)) {
					return cb(_p.clone(storeList));
				}
				_jquery2.default.get(u, { pid: pid }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						reject(json);
					} else {
						var data = _p.clone(json.data);
						_p.setStoredProp("_/cityCache/city_" + pid, data);
						cb(data);
					}
				});
			};
			return new _promise2.default(func);
		},
		getDistricts: function getDistricts(pid) {
			var u = _p.getApiUrl("address/district"),
			    storeList = _p.getStoredProp("_/cityCache/district_" + pid),
			    func = function func(cb, reject) {
				_jquery2.default.get(u, { pid: pid }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						reject(json);
					} else {
						var data = json.data;
						_p.setStoredProp("_/cityCache/district_" + pid, data);
						cb(data);
					}
				});
			};
			return new _promise2.default(func);
		},
		getCityList: function getCityList(vm, pid, type) {
			console.log(vm.cities);
			var target = vm.cities.list.find(function (item) {
				return pid == item.id;
			});
	
			if (target["childrens"] && target.childrens.length > 1) {
				return;
			}
			_this.getCitys(pid).then(function (arr) {
				var data = arr.map(function (o) {
					return type === 2 ? _jquery2.default.extend({ childrens: [] }, o) : o;
				});
				_this.fillCityList(vm, pid, data, type > 0);
			}, function (json) {
				switch (status) {
					default:
						if (_p.checkAjaxStatus(vm, json, _this.title)) break;
						vm.$alert(json.msg, _this.title);
						break;
				}
			});
		},
		parseAddr: function parseAddr(vm, str) {
			var arr = /(\D*)\((\d{6})\)([\D\da-zA-Z\-_]*)/.exec(str);
	
			if (arr && arr.length > 3) {
				var addr = arr[3],
				    cityId = _this.getAddrValue(vm, arr[2]);
				return { cityId: cityId, addr: addr };
			} else {
				return { addr: str };
			}
		},
		getDistrictList: function getDistrictList(vm, val) {
			var cid = val[1],
			    pid = val[0],
			    targetP = vm.cities.list.find(function (item) {
				return pid == item.id;
			}),
			    ecb = function ecb(json) {
				switch (status) {
					default:
						if (_p.checkAjaxStatus(vm, json, _this.title)) break;
						vm.$alert(json.msg, _this.title);
						break;
				}
			};
	
			if (targetP.childrens && targetP.childrens.length > 1) {
				var target = targetP.childrens.find(function (item) {
					return cid == item.id;
				});
				if (target.childrens && target.childrens.length > 0) {
					return;
				} else {
					_this.getDistricts(cid).then(function (arr) {
						_this.fillDistrictList(vm, pid, cid, arr);
					}).catch(ecb);
					return;
				}
			}
	
			_this.getCitys(pid).then(function (arr) {
				var data = arr.map(function (o) {
					return _jquery2.default.extend({ childrens: [] }, o);
				});
				_this.fillCityList(vm, pid, data, true);
	
				_this.getDistricts(cid).then(function (arr) {
					_this.fillDistrictList(vm, pid, cid, arr);
				}).catch(ecb);
			}).catch(ecb);
		},
		fillDistrictList: function fillDistrictList(vm, pid, cid, items) {
			var targetP = vm.cities.list.find(function (item) {
				return pid == item.id;
			}),
			    target = targetP.childrens.find(function (item) {
				return cid == item.id;
			});
	
			target.childrens = items;
		},
		fillCityList: function fillCityList(vm, pid, cities, addArea) {
			var target = vm.cities.list.find(function (item) {
				return pid == item.id;
			}),
			    arr = [];
			arr.push({ "id": pid, "name": "全区域", "disabled": addArea });
			target.childrens = arr.concat(cities);
		},
		parseCityId: function parseCityId(cityId) {
			var province_id = 0,
			    city_id = undefined;
			switch (cityId.length) {
				case 2:
					city_id = cityId[1];
				case 1:
					province_id = cityId[0];
					break;
				default:
					break;
			}
			return { province_id: province_id, city_id: city_id };
		},
		getCityValue: function getCityValue(vm, pid, cid) {
			if (cid) _this.getCityList(vm, pid, 1);
			return _this.toCityId(pid, cid);
		},
		getAddrValue: function getAddrValue(vm, did, type) {
			did = did.toString();
			var trimSix = function trimSix(val) {
				return parseInt((val + "000000").substr(0, 6));
			},
			    pid = trimSix(did.substr(0, 2)),
			    cid = trimSix(did.substr(0, 4));
	
			did = parseInt(did);
			if (0 !== did % 1e2) _this.getDistrictList(vm, [pid, cid]);else if (0 !== did % 1e4) _this.getCityList(vm, pid, type);
	
			return _this.toCityId(pid, cid, did);
		},
		toCityId: function toCityId(pid, cid, did) {
			if (did) return [pid, cid, did];else return [pid, cid];
		},
		toCityName: function toCityName(vm, cityId) {
			var name = "",
			    code = "",
			    arr = [],
			    func = function func(arr, id) {
				if (_p.isNull(arr)) return "";
				var val = arr.find(function (o) {
					return id == o.id;
				});
				return val;
			};
			_jquery2.default.each(cityId, function (k, v) {
				if (_p.isNull(v)) return false;else arr.push(v);
			});
			switch (arr.length) {
				case 1:
					{
						var objP = func(vm.cities.list, arr[0]);
						name = objP.name;
						code = objP.id;
					}
					break;
				case 2:
					{
						var _objP = func(vm.cities.list, arr[0]),
						    objC = func(_objP.childrens, arr[1]);
						name = _objP.name + objC.name;
						code = objC.id;
					}
					break;
				case 3:
					{
						var _objP2 = func(vm.cities.list, arr[0]),
						    _objC = func(_objP2.childrens, arr[1]),
						    objD = func(_objC.childrens, arr[2]);
						name = _objP2.name + _objC.name + objD.name;
						code = objD.id;
					}
					break;
				default:
					return "";
	
			}
			return _util2.default.format("%s(%s)", name, code);
		}
	};
	
	exports.default = _this;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(1053);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _default = __webpack_require__(1054);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _validator = __webpack_require__(688);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	global.config = global.config || _jquery2.default.extend({ "apidomain": ("https://api.fzsf-data.com") }, _config2.default);
	if (false) {
		global.config.version = _config2.default.version + " (test)" + process.env.COMPILE_DATE;
		global.config.debug = true;
	} else {}
	
	console.info(_util2.default.format("Version.%s - Compile:%s", _config2.default.version, ("2026/10/17 08:50:48")));
	
	var _this = {
		loadCounter: 0,
		config: global.config,
		getApiUrl: function getApiUrl(method, ext) {
			var extStr = (ext || "").toString();
			if (_jquery2.default.isPlainObject(ext)) {
				extStr = _jquery2.default.param(ext);
			}
	
			return _util2.default.format("%s/%s?_var=%s&%s", global.config.apidomain, method, _config2.default.version, extStr);
		},
	
		ajaxCfg: {
			crossDomain: true,
			xhrFields: { "withCredentials": true },
			beforeSend: function beforeSend() {
				_this.loading(true);
			},
	
			timeout: 20 * 1000,
			complete: function complete() {
				_this.loading();
			}
		},
		getAjaxData: function getAjaxData(vm, url, data, title) {
			return new _promise2.default(function (resolve, reject) {
				_jquery2.default.post(url, data).then(function (json) {
					var status = void 0;
					if (!json.status) json = JSON.parse(json);
					status = parseInt(json.status);
					if (status !== 200) {
						switch (status) {
							default:
								if (_this.checkAjaxStatus(vm, json, title)) break;else reject(json.msg);
						}
					} else {
						resolve(json.data);
					}
				});
			});
		},
		isNull: function isNull(val) {
			return "" === val || null === val || undefined === val || ("number" !== typeof val ? _jquery2.default.isEmptyObject(val) : false);
		},
		isEmptyObject: function isEmptyObject(obj, arr) {
			var empty = true;
			if (arr) {
				_jquery2.default.each(arr, function (k, v) {
					if (!_this.isNull(obj[v])) {
						empty = false;
						return false;
					}
				});
			} else {
				_jquery2.default.each(obj, function (k, v) {
					if (!_this.isNull(v)) {
						empty = false;
						return false;
					}
				});
			}
			return empty;
		},
		clone: function clone(data) {
			if (_jquery2.default.isArray(data)) {
				var arr = data.map(function (o) {
					return _jquery2.default.isPlainObject(o) ? _this.clone(o) : o;
				});
				return arr;
			} else {
				var obj = new Object();
				for (var key in data) {
					if (_jquery2.default.isArray(data[key]) || _jquery2.default.isPlainObject(data[key])) {
						obj[key] = _this.clone(data[key]);
					} else {
						obj[key] = data[key];
					}
				}
				return obj;
			}
		},
		cleanProp: function cleanProp(data, arr) {
			var temp = _this.clone(data);arr.forEach(function (item) {
				delete temp[item];
			});return temp;
		},
		removeEmptyValue: function removeEmptyValue(d, c) {
			_jquery2.default.each(c, function (k, v) {
				if (d[k] === v) d[k] = null;
			});
			return d;
		},
		getMoney: function getMoney(val) {
			val = val.toString();
			if (val.indexOf(",") != -1) {
				var arr = val.split(","),
				    str = arr.join("");
				return parseFloat(str);
			} else {
				return parseFloat(val);
			}
		},
		loading: function loading(b) {
			if (b) {
				(0, _jquery2.default)("#loading").attr("class", "animated slideInDown");
				_this.loadCounter++;
			} else {
				(0, _jquery2.default)("#loading").attr("class", "animated slideOutUp").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
					if (--_this.loadCounter < 1) (0, _jquery2.default)(this).attr("class", "hidden");
				});
			}
		},
		getBankFixed: function getBankFixed(val, len) {
			if (undefined === len) len = 2;
			var old = val,
			    pow = Math.pow(10, len),
			    a1 = pow * old;
			a1 = Math.round(a1);
			var oldstr = old.toString(),
			    start = oldstr.indexOf("."),
			    partstr = oldstr.split(".");
			if (start > 0 && partstr[1].length > len) {
				if (oldstr.substr(start + len + 1, 1) == 5) {
					var flag = oldstr.substr(start + len, 1) - 0;
					if (partstr[1].length > len + 1) {} else if (flag % 2 == 0) {
						a1 -= 1;
					}
				}
			}
			return a1 / pow;
		},
		getIDCardInfo: function getIDCardInfo(num) {
			var birthday = void 0,
			    sex = void 0,
			    y = void 0,
			    m = void 0,
			    d = void 0;
			if (num.length === 15) {
				y = "19" + num.substr(6, 2);
				m = num.substr(8, 2);
				d = num.substr(10, 2);
	
				sex = parseInt(num.substr(-1)) % 2 ? 1 : 2;
			} else if (num.length === 18) {
				y = num.substr(6, 4);
				m = num.substr(10, 2);
				d = num.substr(12, 2);
				sex = parseInt(num.substr(-2, 1)) % 2 ? 1 : 2;
			} else {
				return false;
			}
			birthday = new Date(y, parseInt(m) - 1, d);
			return { birthday: birthday, sex: sex };
		},
		getStoredApiProp: function getStoredApiProp(key) {
			var func = function func(callback, reject) {
				var val = _this.getStoredProp(key);
				if (!!val) {
					callback(val);
					return;
				} else {
					var u = _this.getApiUrl(key);
	
					_jquery2.default.get(u, function (json) {
						var status = parseInt(json.status);
						if (200 !== status) {
							reject(json);
							return;
						} else {
							val = json.data;
							_this.setStoredProp(key, val);
							callback(val);
						}
					}, "JSON");
				}
			};
			return new _promise2.default(func);
		},
		removeStoredProp: function removeStoredProp(key) {
			if (key) {
				delete window.xwStored[key];
			} else {
				delete window.xwStored;
			}
		},
		getStoredProp: function getStoredProp(key) {
			if (!window.xwStored) return undefined;
			if (_this.isNull(window.xwStored[key])) {
				return undefined;
			} else {
				return _this.clone(window.xwStored[key]);
			}
		},
		setStoredProp: function setStoredProp(key, val) {
			if (!window.xwStored) window.xwStored = {};
			if (_jquery2.default.isPlainObject(key)) {
				_jquery2.default.extend(window.xwStored, _this.clone(key));
			} else {
				window.xwStored[key] = _this.clone(val);
			}
		},
		promiseErrorChecker: function promiseErrorChecker(vm, json, title) {
			title = title || "错误提示";
			if (json instanceof Error) {
				vm.$alert(json.message, title, {
					confirmButtonText: "刷新",
					callback: function callback() {
						location.reload(true);
					}
				});
			} else {
				var status = parseInt(json.status);
				switch (status) {
					default:
						if (_this.checkAjaxStatus(vm, json, title)) break;else {
							vm.$alert(json.msg, {
								confirmButtonText: "刷新",
								callback: function callback() {
									location.reload(true);
								}
							});
						}
						break;
				}
			}
		},
		Storage: function Storage(key, value) {
			if (arguments.length == 1) {
				return JSON.parse(sessionStorage[key]);
			} else if (arguments.length == 2) {
				sessionStorage[key] = (0, _stringify2.default)(value);
			}
		},
		checkAjaxStatus: function checkAjaxStatus(vm, json, title) {
			title = title || "错误提示";
			var status = parseInt(json.status);
			switch (status) {
				case 500:
	
					vm.$alert(json.msg, "请抓图并提交给相关人员处理！", {
						confirmButtonText: "刷新",
						callback: function callback() {
							location.reload(true);
						}
					});
					return true;
				case 1000:
					vm.$emit("loading", false);
					vm.$alert("抱歉！您没有权限请求或提交此数据。", title, {
						confirmButtonText: "刷新",
						callback: function callback() {
							location.reload(true);
						}
					});
					return true;
				case 1001:
					vm.$bus.emit("loading", false);
					vm.$bus.emit("needLogin", false);
	
					return true;
			}
			return false;
		},
		setTitle: function setTitle(str) {
			document.title = _util2.default.format("%s - %s", str, global.title);
			(0, _jquery2.default)("body").trigger("resize");
		},
		checkPermission: function checkPermission(name, any) {
			if (_jquery2.default.isArray(name)) {
				var counter = 0;
				_jquery2.default.each(name, function () {
					if (_jquery2.default.inArray(name, global.user.apiPermission) > -1) counter++;
				});
				if (any && counter > 0) return true;
				return counter === name.length;
			} else return _jquery2.default.inArray(name, global.user.apiPermission) > -1;
		},
		date: function date(fmt, da) {
			var d = da instanceof Date ? da : da === undefined ? new Date() : new Date(da);
			if (d.getFullYear().toString() === "NaN") {
				da = da.replace(/-/g, "/");
				d = new Date(da);
			}
			if (!fmt) return d;
			var o = {
				"M+": d.getMonth() + 1,
				"d+": d.getDate(),
				"h+": d.getHours(),
				"m+": d.getMinutes(),
				"s+": d.getSeconds(),
				"q+": Math.floor((d.getMonth() + 3) / 3),
				"S": d.getMilliseconds() };
			if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
			for (var k in o) {
				if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
			}return fmt;
		},
		getYearRate: function getYearRate($rate, $period) {
			var $step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
			var $precise = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000000000000;
	
			console.log($rate, $period);
	
			var $left = $rate + 1 / $period;
			var $prev = 0;
			var $curr = 0;
			var $middle = 0;
			var $start = $rate * $precise;
			var $end = $step * $precise;
	
			while ($start <= $end) {
				$middle = ($start + $end) / 2;
				var $x = $middle / $precise;
				$curr = $x + $x / (Math.pow(1 + $x, $period) - 1);
				if ($left < $curr) {
					$end = $middle - 1;
				} else if ($left > $curr) {
					$start = $middle + 1;
				} else {
					return ($middle * 12 / $precise).toFixed(10);
				}
			}
	
			return ($middle * 12 / $precise).toFixed(10);
		},
		getMonthRate: function getMonthRate(yearRate) {
			return yearRate / 12;
		},
		getMonthPrincipal: function getMonthPrincipal($debt, $monthRate, $period, $month) {
			var $capital = $debt * $monthRate * Math.pow(1 + $monthRate, $month - 1) / (Math.pow(1 + $monthRate, $period) - 1);
	
			return this.getBankFixed($capital, 5);
		},
		getMonthInterest: function getMonthInterest($debt, $monthRate, $period, $month) {
			var $interest = $debt * $monthRate * (Math.pow(1 + $monthRate, $period) - Math.pow(1 + $monthRate, $month - 1)) / (Math.pow(1 + $monthRate, $period) - 1);
	
			return this.getBankFixed($interest, 5);
		},
		getCurrentPrincipal: function getCurrentPrincipal($argument) {
			console.log($argument);
			var $actual = this.getYearRate($argument['_interest_rate'] / 100, $argument['_period']);
			console.log($actual);
			return this.getBankFixed(this.getMonthPrincipal($argument['_loan'], $actual / 12, $argument['_period'], 1));
		},
		getCurrentInterest: function getCurrentInterest($argument) {
			var $actual = this.getYearRate($argument['_interest_rate'] / 100, $argument['_period']);
	
			return this.getBankFixed(this.getMonthInterest($argument['_loan'], $actual / 12, $argument['_period'], 1));
		}
	};
	
	_this.setStoredProp(_default2.default);
	
	window.xwCommon = _jquery2.default.extend(_this, { validator: _validator2.default });
	
	exports.default = _this;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(542),
	  /* template */
	  __webpack_require__(1253),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		userCheck: function userCheck() {
			var u = _p.getApiUrl("staff/currentQuery"),
			    func = function func(callback, reject) {
				_jquery2.default.get(u, function (json) {
					var status = parseInt(json.status);
	
					switch (status) {
						case 200:
							callback(json.data);
							break;
						case 1001:
							callback(false);
	
							break;
						case 1000:
							reject(new Error("您暂时没有权限使用本系统，请联系管理员！"));
							break;
						default:
							reject(json);
							break;
					}
				});
			};
			return new _promise2.default(func);
		},
		getUserInfo: function getUserInfo(staff_id) {
			var u = _p.getApiUrl("staff/query"),
			    func = function func(callback, reject) {
				_jquery2.default.get(u, { staff_id: staff_id }, function (json) {
					var status = parseInt(json.status);
					switch (status) {
						case 200:
							callback(json.data);
							break;
						default:
							reject(json);
							break;
					}
				});
			};
			return new _promise2.default(func);
		},
		getVerifyImg: function getVerifyImg() {
			return _p.getApiUrl("login/verifyCode", { "_t": _jquery2.default.now() });
		},
		userSignIn: function userSignIn(data, self) {
			var u = _p.getApiUrl("login/in"),
			    func = function func(callback, reject) {
	
				var md5 = __webpack_require__(452);
				data.password = md5(data.password);
				_jquery2.default.post(u, data, function (json) {
					var status = parseInt(json.status);
					switch (status) {
						case 200:
							callback(json);
							self.isLoginBack == true ? localStorage.companyName = "HaoChengDa" : localStorage.removeItem("companyName");
							break;
						default:
							reject(json);
							break;
					}
				});
			};
	
			return new _promise2.default(func);
		},
		userSignOut: function userSignOut() {
			var u = _p.getApiUrl("login/out"),
			    func = function func(callback, reject) {
				_jquery2.default.get(u, function (json) {
					var status = parseInt(json.status);
					switch (status) {
						case 200:
							callback(true);
							break;
						default:
							reject(json);
							break;
					}
				});
			};
			return new _promise2.default(func);
		}
	};
	exports.default = _this;

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
	  title: "消息中心",
	  name: "car_user_msg",
	  readList: function readList(vm, p, s) {
	    var url = _p.getApiUrl("push/list"),
	        page = p || vm.currentPage,
	        page_size = s || vm.pageSize,
	        paging = true,
	        is_read = vm.msgType > -1 ? vm.msgType : undefined;
	    vm.loading = true;
	    _jquery2.default.post(url, { page: page, page_size: page_size, paging: paging, is_read: is_read }, function (json) {
	      return _this.fillData(vm, json);
	    });
	  },
	  fillData: function fillData(vm, json) {
	    var status = parseInt(json.status);
	    if (200 !== status) {
	      switch (status) {
	        default:
	          if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	          vm.$alert(json.msg, _this.title);
	          break;
	      }
	      return;
	    } else {
	      vm.$nextTick(function () {
	        vm.tableData = json.data.data;
	        vm.currentPage = parseInt(json.data.current_page);
	        vm.totalRow = parseInt(json.data.total);
	        vm.pageSize = parseInt(json.data.per_page);
	        vm.loading = false;
	      });
	    }
	  },
	  showMsgWin: function showMsgWin(vm, obj) {
	    var func = function func() {
	      vm.$set(vm.msgDialog, "msg", obj.msg_content);
	      vm.$set(vm.msgDialog, "visible", true);
	    };
	    if (obj.is_read == 0) {
	      _this.setRead(vm, obj.push_msg_id).then(function () {
	        func();
	        _this.readList(vm);
	      }, function (json) {
	        return _p.promiseErrorChecker(vm, json, _this.title);
	      });
	    } else {
	      func();
	    }
	  },
	  setRead: function setRead(vm, push_msg_id) {
	    var u = _p.getApiUrl("push/setRead"),
	        user = _p.getStoredProp("staff/query"),
	        staff_id = user.staff_id,
	        func = function func(callback, reject) {
	      _jquery2.default.get(u, { push_msg_id: push_msg_id, staff_id: staff_id }, function (json) {
	        var status = parseInt(json.status);
	        switch (status) {
	          case 200:
	            callback(json.data);
	            break;
	          default:
	            reject(json);
	            break;
	        }
	      });
	    };
	    return new _promise2.default(func);
	  },
	  showNotifyMsg: function showNotifyMsg(vm, obj, title) {
	    var content = obj,
	        icon = "/static/img/avatar.png",
	        shown = false;
	    if (_jquery2.default.isPlainObject(obj)) {
	      content = obj.msg;
	    }
	    if (_p.isNull(title)) {
	      title = "推送消息";
	    }
	    if (window.webkitNotifications) {
	      if (window.webkitNotifications.checkPermission() == 0) {
	        var msgWin = window.webkitNotifications.createNotification(icon, title, content);
	        msgWin.onclick = function () {
	          _this.msgJumpTo(vm, obj);msgWin.cancel();
	        };
	        msgWin.replaceId = 'Meteoric';
	        msgWin.show();
	        shown = true;
	      }
	    } else if ("Notification" in window) {
	      if (Notification.permission === "granted") {
	        var _msgWin = new Notification(title, { icon: icon, "body": content });
	        _msgWin.onclick = function (e) {
	          _this.msgJumpTo(vm, obj);_msgWin.close();
	        };
	        shown = true;
	      }
	    }
	
	    if (shown) {
	      var notifyCheck = sessionStorage.getItem('NotifyGranted');
	      notifyCheck = _p.isNull(notifyCheck) ? 0 : parseInt(notifyCheck);
	      sessionStorage.setItem('NotifyGranted', notifyCheck);
	    } else {
	      var _msgWin2 = vm.$notify({
	        title: title, message: content, duration: 0, onClick: function onClick() {
	          _this.msgJumpTo(vm, obj);_msgWin2.close();
	        }
	      });
	    }
	  },
	  msgJumpTo: function msgJumpTo(vm, obj) {
	    vm.$bus.emit('push-router', { name: "car_user_msg" });
	  },
	  checkMsg: function checkMsg(vm) {
	    var u = _p.getApiUrl("push/lastEst"),
	        user = _p.getStoredProp("staff/query"),
	        staff_id = user.staff_id;
	    _jquery2.default.get(u, { staff_id: staff_id }, function (json) {
	      var status = parseInt(json.status);
	      if (200 !== status) {
	        switch (status) {
	          default:
	            if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
	            vm.login = false;
	
	            window.location.reload;
	            break;
	        }
	        return;
	      } else {
	        if (json.data && json.data.msg) {
	          vm.$bus.emit("receiveMsg", json.data);
	        }
	      }
	    });
	  },
	  stop: function stop(vm) {
	    clearInterval(_p.notifyTimer);
	    vm.$bus.off("receiveMsg");
	  },
	  start: function start(vm) {
	    var noCheck = parseInt(sessionStorage.getItem('noNotifyCheck')),
	        noTimer = parseInt(sessionStorage.getItem('noNotifyTimer')),
	        func = function func(ret) {
	      if (ret == "granted") {
	        vm.$message('桌面推送功能已启动！');
	      } else {
	        if (window.webkitNotifications && window.webkitNotifications.checkPermission() == 0) {
	          vm.$notify({ title: "启用桌面推送", "message": "桌面推送功能已启动！" });
	          sessionStorage.setItem('NotifyGranted', 1);
	        } else {
	          vm.$alert("您拒绝了桌面推送功能，相关推送消息将显示在本页面右侧！", "启用桌面推送");
	          sessionStorage.setItem('noNotifyCheck', 1);
	        }
	      }
	    };
	    if (noTimer != 1) {
	      vm.$bus.on("receiveMsg", function (msg) {
	        alert(msg);
	        _this.showNotifyMsg(vm, msg);
	      });
	      _this.checkMsg(vm);
	      _p.notifyTimer = setInterval(function () {
	        return _this.checkMsg(vm);
	      }, _p.config.checkTimer * 1000);
	    }
	    if (noCheck == 1) {
	      return;
	    }
	    if (window.webkitNotifications) {
	      if (window.webkitNotifications.checkPermission() != 0) {
	        vm.$alert('您尚未启用桌面推送功能，请关闭此窗口后根据上方弹窗提示操作！', '启用桌面推送', {
	          callback: function callback() {
	            window.webkitNotifications.requestPermission(func);
	          }
	        });
	      } else {
	        sessionStorage.setItem('NotifyGranted', 1);
	      }
	    } else if ("Notification" in window) {
	      if (Notification.permission != "granted") {
	        Notification.requestPermission().then(func);
	      } else {
	        sessionStorage.setItem('NotifyGranted', 1);
	      }
	    }
	    var notifyCheck = parseInt(sessionStorage.getItem('NotifyGranted'));
	    if (notifyCheck > 0) {
	      vm.$message('桌面推送功能已启动！');
	    }
	  }
	};
	
	exports.default = _this;

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(953)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(560),
	  /* template */
	  __webpack_require__(1203),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(697);
	
	__webpack_require__(1051);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _login = __webpack_require__(1185);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _menu = __webpack_require__(1186);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _createWin = __webpack_require__(1184);
	
	var _createWin2 = _interopRequireDefault(_createWin);
	
	var _user = __webpack_require__(404);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _msg2 = __webpack_require__(405);
	
	var _msg3 = _interopRequireDefault(_msg2);
	
	var _createFile = __webpack_require__(1077);
	
	var _createFile2 = _interopRequireDefault(_createFile);
	
	__webpack_require__(681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    methods = {
	    ready: function ready(loginPage) {
	        var _this2 = this;
	
	        _user2.default.userCheck(this).then(function (data) {
	            if (!data) {
	                _this2.showPage(false);
	                _this2.fullscreenLoading = false;
	                return;
	            } else {
	                _this2.LoginCompany = localStorage.companyName;
	                if (_this2.LoginCompany == 'HaoChengDa') {
	                    global.title = "HR融担平台";
	                }
	                _p.setStoredProp("staff/currentQuery", data);
	
	                var carMenu = _lodash2.default.find(data.menu, function (o) {
	                    return o.ref == "car";
	                }),
	                    chedaiMenu = _lodash2.default.find(data.menu, function (o) {
	                    return o.ref == "chedai";
	                });
	
	                _user2.default.getUserInfo(data.staff_id).then(function (user) {
	
	                    _p.setStoredProp("staff/query", user);
	                    _this2.user = user;
	                    _this2.setMenu(data.menu);
	                    _this2.showPage(true);
	                    _this2.fullscreenLoading = false;
	
	
	                    _this2.role_oper_type = user.role_oper_type;
	
	                    if (loginPage == true || _this2.$route.path == "/") {
	                        if (user.role_oper_type == 2 || user.role_oper_type == 3) {
	
	                            if (!carMenu && chedaiMenu) {
	                                _this2.$bus.emit('push-router', "/homePage/system");
	                            } else {
	                                _this2.$bus.emit('push-router', "/homePage");
	                            }
	                        } else {
	                            if (carMenu) {
	                                _this2.$bus.emit('push-router', "/user/taskTodo");
	                            }
	                            if (!carMenu && chedaiMenu) {
	                                _this2.$bus.emit('push-router', "/system/update/1");
	                            }
	                        }
	                    }
	                }, function (json) {
	                    return _p.promiseErrorChecker(_this2, json, "获取用户信息");
	                });
	            }
	        }, function (json) {
	            return _p.promiseErrorChecker(_this2, json, "获取权限信息");
	        });
	    },
	    showPage: function showPage(b) {
	        if (b) {
	            this.login = b;
	            (0, _jquery2.default)("body").addClass("skin-blue fixed");
	        } else {
	            this.login = b;
	            (0, _jquery2.default)("body").removeClass("skin-blue fixed");
	        }
	        this.show = true;
	        this.setAreaActive(this.$route.name);
	    },
	    setMenu: function setMenu(appMenu) {
	        var obj = {
	            "topTodo": "top_todo",
	            "topNewOrder": "top_new_order",
	            "topSystemTab": "folder_admin",
	            "topCarTab": "car",
	            "topAdminTab": "admin",
	            "topMsg": "top_user_msg",
	            "topFastDebit": "top_csd",
	            "top_chedaiTab": "chedai"
	        },
	            vm = this;
	        _jquery2.default.each(obj, function (k, v) {
	            vm[k] = _lodash2.default.find(appMenu, function (o) {
	                return o.ref == v;
	            });
	        });
	        _p.setStoredProp("topCarTab", this.topCarTab);
	    },
	    userSignOut: function userSignOut() {
	        var _this3 = this;
	
	        var url = _p.getApiUrl("login/out");
	        this.$confirm("确认要退出？", "退出登录", {
	            confirmButtonText: '确定',
	            cancelButtonText: '取消',
	            type: 'warning'
	        }).then(function () {
	            _this3.fullscreenLoading = true;
	            _user2.default.userSignOut().then(function () {
	                _this3.showPage(false);
	                _msg3.default.stop(_this3);
	                _this3.fullscreenLoading = false;
	                _this3.$message({ type: 'success', message: '已退出系统!' });
	                localStorage.companyName == "HaoChengDa" ? _this3.$bus.emit('push-router', "/login") : _this3.$bus.emit('push-router', "/");
	                window.location.reload;
	            }, function (json) {
	                return _p.promiseErrorChecker(_this3, json, "退出登录");
	            });
	        });
	    },
	    backLogin: function backLogin() {
	        this.showPage(false);
	        this.$message.error('请重新登录!');
	    },
	    setAreaActive: function setAreaActive(name) {
	        if (name === undefined) this.areaName = '';else if ('default' === name) this.areaName = "home";else if (name.indexOf('car') === 0) this.areaName = "car";else if (name.indexOf('chedai') === 0) this.areaName = "chedai";else this.areaName = "";
	    },
	    loadingPage: function loadingPage(b) {
	        this.fullscreenLoading = b;
	        if (!b) (0, _jquery2.default)("body").css({ "overflow": "auto", "padding-right": 0 });
	    },
	    resetMsg: function resetMsg() {
	        sessionStorage.removeItem('noNotifyCheck');
	    },
	    reload: function reload() {
	        this.isRouterAlive = false;
	        this.$nextTick(function () {
	            this.isRouterAlive = true;
	        });
	    }
	};
	
	exports.default = {
	    name: 'layout', methods: methods,
	    components: { loginArea: _login2.default, sidebarArea: _menu2.default, createWin: _createWin2.default, createFile: _createFile2.default },
	    provide: function provide() {
	        return {
	            reload: this.reload
	        };
	    },
	    data: function data() {
	        return {
	            login: false,
	            show: false,
	            areaName: "",
	            topCarTab: false,
	            topAdminTab: false,
	            topSystemTab: false,
	            topBackTab: false,
	            isRouterAlive: false,
	            taskCount: "",
	            msgCount: "",
	            priceCount: "",
	            topNewOrder: false,
	            topTodo: false,
	            topNotify: false,
	            topMsg: false,
	            fullscreenLoading: true,
	            showCreateWin: false,
	            showCreateFile: false,
	            user: {},
	            version: global.config.version,
	            viewVer: global.config.verInfo,
	            year: new Date().getFullYear(),
	            role_oper_type: "",
	            LoginCompany: ""
	        };
	    },
	
	    watch: {
	        '$route': function $route(to) {
	            this.setAreaActive(to.name);
	        }
	    },
	    mounted: function mounted() {
	        var _this4 = this;
	
	        this.fullscreenLoading = true;
	        _jquery2.default.ajaxSetup(_jquery2.default.extend({
	            error: function error(err) {
	                _this4.fullscreenLoading = false;
	                var desc = "因为下面的原因，您的请求没有响应！请检查网络情况，或联系管理员处理！";
	                desc += "错误编号：AJAX-" + err.status;
	                desc += " （" + err.statusText + "）";
	                if (false) {
	                    console.error(err);
	                    _this4.$alert(desc, "网络错误");
	                } else {
	                    _this4.$alert(desc, "断网了？", {
	                        confirmButtonText: "刷新",
	                        type: "error",
	                        callback: function callback() {
	                            location.reload(true);
	                        }
	                    });
	                }
	            }
	        }, _p.ajaxCfg));
	        this.$bus.on("loginOK", this.ready).on("needLogin", this.backLogin).on("loading", this.loadingPage).on("resetMsg", this.resetMsg);
	        this.ready();
	    },
	    beforeDestroy: function beforeDestroy() {
	        delete window.xwCommon;
	        delete window.xwStored;
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createFile = __webpack_require__(625);
	
	var _createFile2 = _interopRequireDefault(_createFile);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    name = _createFile2.default.name;
	exports.default = {
	    name: name,
	    props: { "visible": { type: Boolean, default: false } },
	    data: function data() {
	        var rules = _createFile2.default.rules;
	        return {
	            fileForm: {},
	            applyPurpose: [{ label: '资金周转', value: '0' }, { label: '购物', value: '1' }, { label: '其他', value: '2' }],
	            pageTitle: _createFile2.default.title,
	            treeLoading: false,
	            loading: false,
	            showDialog: false,
	            currDept: undefined,
	            loanTypeOnly: false,
	            submitLoading: false,
	            cities: { list: [], props: _p.getStoredProp("_/cities/props") },
	            userSexItem: _p.getStoredProp("_/default/sex"),
	            productSearchItem: [],
	            productSearchProps: { "label": "product_name", "value": "product_id", "children": "childrens" },
	            orderType: [],
	            rules: rules,
	            StoreByArea: [],
	            props: {
	                value: "id",
	                label: "name",
	                children: "children"
	            }
	        };
	    },
	
	    methods: {
	        citiesItemChange: function citiesItemChange(val, isUser) {
	            switch (val.length) {
	                case 2:
	                    _createFile2.default.getDistrictList(this, val);
	                    return;
	                case 1:
	                    _createFile2.default.getCityList(this, val[0], 2);
	                    return;
	                default:
	                    this.$alert("无效的选项信息", pageTitle);
	                    return;
	            }
	        },
	        handleOptionData: function handleOptionData(val) {
	            switch (val.length) {
	                case 2:
	                    _createFile2.default.getApplyPrice(this, val);
	                    return;
	                default:
	                    return;
	            }
	        },
	        disProduct: function disProduct(val) {
	            var _this2 = this;
	
	            _lodash2.default.forEach(this.productSearchItem, function (childrens, k) {
	                _lodash2.default.forEach(childrens.childrens, function (j) {
	                    if (val == 4) {
	                        if (j.product_name == "小微速贷D11_NEW") {
	                            j.disabled = true;
	                            _this2.fileForm.product_id = [];
	                        }
	                        if (j.product_name == "小微速贷D11_OLD") {
	                            j.disabled = false;
	                        }
	                    } else if (val == 1) {
	                        if (j.product_name == "小微速贷D11_OLD") {
	                            j.disabled = true;
	                            _this2.fileForm.product_id = [];
	                        }
	                        if (j.product_name == "小微速贷D11_NEW") {
	                            j.disabled = false;
	                        }
	                    }
	                });
	            });
	        },
	        idCardChange: function idCardChange(val) {
	            this.$set(this.fileForm, "idcard", val.toLocaleUpperCase());
	            var info = _p.getIDCardInfo(val);
	            if (info) {
	                this.$set(this.fileForm, "sex", info.sex);
	                this.$set(this.fileForm, "birthday", info.birthday);
	            }
	        },
	        submit: function submit() {
	            var _this3 = this;
	
	            this.$refs['fileForm'].validate(function (val) {
	                if (val) {
	                    _createFile2.default.submit(_this3).then(function (json) {
	                        _this3.$emit('closed');
	                    }).catch(function (err) {
	                        _this3.loading = false;
	                        _this3.$alert(err.toString(), _this3.pageTitle);
	                    });
	                } else {
	                    _this3.$alert('表单存在错误', _this3.pageTitle);
	                }
	            });
	        }
	    },
	    watch: {
	        visible: function visible(val) {
	            if (val) {
	                _createFile2.default.initWin(this);
	            } else this.showDialog = false;
	        },
	        showDialog: function showDialog(val) {
	            if (!val) this.$emit('closed');
	        }
	    },
	    mounted: function mounted() {}
	};

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _storeReviewWin = __webpack_require__(632);
	
	var _storeReviewWin2 = _interopRequireDefault(_storeReviewWin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _storeReviewWin2.default.title,
	    name = _storeReviewWin2.default.name,
	    methods = {
	    submit: function submit() {
	        var _this2 = this;
	
	        this.$refs["reviewForm"].validate(function (valid) {
	            if (valid) _storeReviewWin2.default.submit(_this2);else _this2.$alert("表单存在错误，请修正后再保存！", pageTitle);
	        });
	    }
	};
	
	exports.default = {
	    name: name, methods: methods,
	    props: {
	        "visible": { type: Boolean, default: false },
	        "info": { type: Object, required: true },
	        "node": { type: Object, required: true }
	    },
	    data: function data() {
	        return {
	            pageTitle: pageTitle, showDialog: false, submitLoading: false,
	            reviewType: _p.getStoredProp("_/default/judge/reviewType"),
	            backNodeList: [], reviewForm: {}, error: {}, rules: _storeReviewWin2.default.rules
	        };
	    },
	    watch: {
	        visible: function visible(val) {
	            if (val) {} else this.showDialog = false;
	        },
	        showDialog: function showDialog(val) {
	            if (!val) this.$emit('closed');
	        }
	    },
	    mounted: function mounted() {
	        _storeReviewWin2.default.initWin(this);
	    }
	};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _popup = __webpack_require__(641);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _storeReviewWin = __webpack_require__(1098);
	
	var _storeReviewWin2 = _interopRequireDefault(_storeReviewWin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _popup2.default.title,
	    name = _popup2.default.name,
	    methods = {
	    closeWin: function closeWin() {
	        this.showDialog = false;
	    }
	};
	
	exports.default = {
	    name: name, methods: methods,
	    components: { store_review: _storeReviewWin2.default },
	    props: {
	        "visible": { type: Boolean, default: false },
	        "info": { type: Object, required: true }
	    },
	    computed: {
	        popupInfo: function popupInfo() {
	            return this.info;
	        }
	    },
	    data: function data() {
	        return {
	            pageTitle: pageTitle, showDialog: false, popupItem: null
	        };
	    },
	    watch: {
	        visible: function visible(val) {
	            var _this2 = this;
	
	            if (val) {
	                _popup2.default.initWin(this).catch(function (err) {
	                    if (err) _this2.$alert(err.toString(), pageTitle);
	                });
	            } else this.showDialog = false;
	        },
	        showDialog: function showDialog(val) {
	            if (!val) this.$emit('closed');
	        }
	    },
	    mounted: function mounted() {}
	};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _chargeOrder = __webpack_require__(644);
	
	var _chargeOrder2 = _interopRequireDefault(_chargeOrder);
	
	var _popup = __webpack_require__(176);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _chargeOrder2.default.title,
	    name = _chargeOrder2.default.name,
	    tableData = [],
	    methods = {
	    rowActionHandle: function rowActionHandle(e, a, obj) {
	
	        switch (a) {
	            case "goto":
	                switch (obj.open) {
	                    case "popup":
	                        this.popupWinInfo = obj;
	                        this.showPopupWin = true;
	                        break;
	                    default:
	                        var _params = { node: obj.order_node_id, id: obj.order_id };
	                        this.$bus.emit('push-router', { name: "order_chargeFlow", params: _params });
	                        break;
	                }
	
	                break;
	            case "view":
	                var params = { id: obj.order_id, node: obj.order_node_id };
	                this.$bus.emit('push-router', { name: "car_view_page", params: params });
	                break;
	            case "showMsg":
	                this.backMsgDialog.last_msg = obj.last_msg;
	                this.backMsgDialog.visible = true;
	                break;
	            case "showChargeType":
	                this.chargeMsgDialog.visible = true;
	                this.chargeMsgDialog.data = obj.postDebit.post_item;
	                break;
	            case "showChoice":
	                _chargeOrder2.default.showChoiceWin(this, obj.order_node_id);
	                break;
	            default:
	                console.log(arguments);
	                break;
	        }
	    },
	    pageActionHandle: function pageActionHandle(e, a, obj) {
	        switch (a) {
	            case "choiceForm":
	                if (_p.isNull(obj.staff_id)) {
	                    vm.$set(vm.error, "staff_id", "请选择一个用户");
	                } else {
	                    _chargeOrder2.default.submitChoice(this, obj.order_node_id, obj.staff_id);
	                }
	
	                break;
	        }
	    },
	    sizeChangeHandle: function sizeChangeHandle(s) {
	        _chargeOrder2.default.readList(this, null, s);
	    },
	    pageChangeHandle: function pageChangeHandle(p) {
	        _chargeOrder2.default.readList(this, p);
	    },
	    setClassName: function setClassName(row, column, rowIndex, columnIndex) {
	        console.log(row, column, rowIndex, columnIndex);
	    },
	    red: function red(differ) {
	        var time = differ.split("小时");
	        if (time.length > 1) return false;else {
	            time = differ.split("分钟");
	            if (Number(time[0]) > 30) return false;else return true;
	        }
	    }
	};
	
	exports.default = {
	    name: name, methods: methods,
	    components: { popupWin: _popup2.default },
	    props: ['isHomePageSub'],
	    data: function data() {
	        return {
	            pageTitle: pageTitle, tableData: tableData, loading: true, staffChoiceList: [],
	            showPopupWin: false, popupWinInfo: {},
	            currentPage: 1, totalRow: 0, pageSize: 20, error: {},
	            backMsgDialog: { "title": "退回原因", "ref": "backForm", "visible": false },
	            choiceDialog: { "title": "分配任务", "ref": "choiceForm", "visible": false, "staff_id": null },
	            chargeMsgDialog: { "title": '扣款列表', "visible": false, "data": [] }
	        };
	    },
	    mounted: function mounted() {
	        var _this2 = this;
	
	        _p.setTitle(pageTitle);
	        _chargeOrder2.default.readList(this);
	        this.$bus.on('reloadTodo', function () {
	            _chargeOrder2.default.readList(_this2);
	        });
	    }
	};

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _refundOrder = __webpack_require__(645);
	
	var _refundOrder2 = _interopRequireDefault(_refundOrder);
	
	var _popup = __webpack_require__(176);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _refundOrder2.default.title,
	    name = _refundOrder2.default.name,
	    tableData = [],
	    methods = {
	  rowActionHandle: function rowActionHandle(e, a, obj) {
	
	    switch (a) {
	      case "goto":
	        switch (obj.open) {
	          case "popup":
	            this.popupWinInfo = obj;
	            this.showPopupWin = true;
	            break;
	          default:
	            var _params = { id: obj.order_id, node: obj.order_node_id, group: obj.group_id };
	            this.$bus.emit('push-router', { name: "order_refundFlow", params: _params });
	            break;
	        }
	
	        break;
	      case "view":
	        var params = { id: obj.order_id, node: obj.order_node_id };
	        this.$bus.emit('push-router', { name: "car_view_page", params: params });
	        break;
	      case "showMsg":
	        this.backMsgDialog.last_msg = obj.last_msg;
	        this.backMsgDialog.visible = true;
	        break;
	      case "showChargeType":
	        this.chargeMsgDialog.visible = true;
	        this.chargeMsgDialog.data = obj.orderRefund.refund_item;
	        break;
	      case "showChoice":
	        _refundOrder2.default.showChoiceWin(this, obj.order_node_id);
	        break;
	      default:
	        console.log(arguments);
	        break;
	    }
	  },
	  pageActionHandle: function pageActionHandle(e, a, obj) {
	    switch (a) {
	      case "choiceForm":
	        if (_p.isNull(obj.staff_id)) {
	          vm.$set(vm.error, "staff_id", "请选择一个用户");
	        } else {
	          _refundOrder2.default.submitChoice(this, obj.order_node_id, obj.staff_id);
	        }
	
	        break;
	    }
	  },
	  sizeChangeHandle: function sizeChangeHandle(s) {
	    _refundOrder2.default.readList(this, null, s);
	  },
	  pageChangeHandle: function pageChangeHandle(p) {
	    _refundOrder2.default.readList(this, p);
	  },
	  setClassName: function setClassName(row, column, rowIndex, columnIndex) {
	    console.log(row, column, rowIndex, columnIndex);
	  },
	  red: function red(differ) {
	    var time = differ.split("小时");
	    if (time.length > 1) return false;else {
	      time = differ.split("分钟");
	      if (Number(time[0]) > 30) return false;else return true;
	    }
	  }
	};
	
	exports.default = {
	  name: name, methods: methods,
	  components: { popupWin: _popup2.default },
	  props: ['isHomePageSub'],
	  data: function data() {
	    return {
	      pageTitle: pageTitle, tableData: tableData, loading: true, staffChoiceList: [],
	      showPopupWin: false, popupWinInfo: {},
	      currentPage: 1, totalRow: 0, pageSize: 20, error: {},
	      backMsgDialog: { "title": "退回原因", "ref": "backForm", "visible": false },
	      choiceDialog: { "title": "分配任务", "ref": "choiceForm", "visible": false, "staff_id": null },
	      chargeMsgDialog: { "title": '扣款列表', "visible": false, "data": [] }
	    };
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _p.setTitle(pageTitle);
	    _refundOrder2.default.readList(this);
	    this.$bus.on('reloadTodo', function () {
	      _refundOrder2.default.readList(_this2);
	    });
	  }
	};

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _settleOrder = __webpack_require__(646);
	
	var _settleOrder2 = _interopRequireDefault(_settleOrder);
	
	var _popup = __webpack_require__(176);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _settleOrder2.default.title,
	    name = _settleOrder2.default.name,
	    tableData = [],
	    methods = {
	  rowActionHandle: function rowActionHandle(e, a, obj) {
	
	    switch (a) {
	      case "goto":
	        switch (obj.open) {
	          case "popup":
	            this.popupWinInfo = obj;
	            this.showPopupWin = true;
	            break;
	          default:
	            var _params = { id: obj.order_id, node: obj.order_node_id, group: obj.group_id };
	            this.$bus.emit('push-router', { name: "order_settleFlow", params: _params });
	            break;
	        }
	
	        break;
	      case "view":
	        var params = { id: obj.order_id, node: obj.order_node_id };
	        this.$bus.emit('push-router', { name: "car_view_page", params: params });
	        break;
	      case "showMsg":
	        this.backMsgDialog.last_msg = obj.last_msg;
	        this.backMsgDialog.visible = true;
	        break;
	      case "showChoice":
	        _settleOrder2.default.showChoiceWin(this, obj.order_node_id);
	        break;
	      default:
	        console.log(arguments);
	        break;
	    }
	  },
	  pageActionHandle: function pageActionHandle(e, a, obj) {
	    switch (a) {
	      case "choiceForm":
	        if (_p.isNull(obj.staff_id)) {
	          vm.$set(vm.error, "staff_id", "请选择一个用户");
	        } else {
	          _settleOrder2.default.submitChoice(this, obj.order_node_id, obj.staff_id);
	        }
	
	        break;
	    }
	  },
	  sizeChangeHandle: function sizeChangeHandle(s) {
	    _settleOrder2.default.readList(this, null, s);
	  },
	  pageChangeHandle: function pageChangeHandle(p) {
	    _settleOrder2.default.readList(this, p);
	  },
	  setClassName: function setClassName(row, column, rowIndex, columnIndex) {
	    console.log(row, column, rowIndex, columnIndex);
	  },
	  red: function red(differ) {
	    var time = differ.split("小时");
	    if (time.length > 1) return false;else {
	      time = differ.split("分钟");
	      if (Number(time[0]) > 30) return false;else return true;
	    }
	  }
	};
	
	exports.default = {
	  name: name, methods: methods,
	  components: { popupWin: _popup2.default },
	  props: ['isHomePageSub'],
	  data: function data() {
	    return {
	      pageTitle: pageTitle, tableData: tableData, loading: true, staffChoiceList: [],
	      showPopupWin: false, popupWinInfo: {},
	      currentPage: 1, totalRow: 0, pageSize: 20, error: {},
	      backMsgDialog: { "title": "退回原因", "ref": "backForm", "visible": false },
	      choiceDialog: { "title": "分配任务", "ref": "choiceForm", "visible": false, "staff_id": null }
	    };
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _p.setTitle(pageTitle);
	    _settleOrder2.default.readList(this);
	    this.$bus.on('reloadTodo', function () {
	      _settleOrder2.default.readList(_this2);
	    });
	  }
	};

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _todo = __webpack_require__(648);
	
	var _todo2 = _interopRequireDefault(_todo);
	
	var _popup = __webpack_require__(176);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _todo2.default.title,
	    name = _todo2.default.name,
	    tableData = [],
	    methods = {
	  rowActionHandle: function rowActionHandle(e, a, obj) {
	
	    switch (a) {
	      case "goto":
	        switch (obj.open) {
	          case "popup":
	            this.popupWinInfo = obj;
	            this.showPopupWin = true;
	            break;
	          default:
	            var _params = { id: obj.order_id, node: obj.order_node_id };
	            if (obj.product_type == "车贷") this.$bus.emit('push-router', { name: "car_order_page", params: _params });else if (obj.product_type == "普惠") this.$bus.emit('push-router', { name: "puhui_finacial_order_page", params: _params });
	            break;
	        }
	
	        break;
	      case "view":
	        var params = { id: obj.order_id, node: obj.order_node_id };
	        this.$bus.emit('push-router', { name: "car_view_page", params: params });
	        break;
	      case "showMsg":
	        this.backMsgDialog.last_msg = obj.last_msg;
	        this.backMsgDialog.visible = true;
	        break;
	      case "showChoice":
	        _todo2.default.showChoiceWin(this, obj.order_node_id);
	        break;
	      default:
	        console.log(arguments);
	        break;
	    }
	  },
	  pageActionHandle: function pageActionHandle(e, a, obj) {
	    switch (a) {
	      case "choiceForm":
	        if (_p.isNull(obj.staff_id)) {
	          vm.$set(vm.error, "staff_id", "请选择一个用户");
	        } else {
	          _todo2.default.submitChoice(this, obj.order_node_id, obj.staff_id);
	        }
	
	        break;
	    }
	  },
	  sizeChangeHandle: function sizeChangeHandle(s) {
	    _todo2.default.readList(this, null, s);
	  },
	  pageChangeHandle: function pageChangeHandle(p) {
	    _todo2.default.readList(this, p);
	  },
	  setClassName: function setClassName(row, column, rowIndex, columnIndex) {
	    console.log(row, column, rowIndex, columnIndex);
	  },
	  red: function red(differ) {
	    var time = differ.split("小时");
	    if (time.length > 1) return false;else {
	      time = differ.split("分钟");
	      if (Number(time[0]) > 30) return false;else return true;
	    }
	  }
	};
	
	exports.default = {
	  name: name, methods: methods,
	  components: { popupWin: _popup2.default },
	  props: ['isHomePageSub'],
	  data: function data() {
	    return {
	      pageTitle: pageTitle, tableData: tableData, loading: true, staffChoiceList: [],
	      showPopupWin: false, popupWinInfo: {},
	      currentPage: 1, totalRow: 0, pageSize: 20, error: {},
	      backMsgDialog: { "title": "退回原因", "ref": "backForm", "visible": false },
	      choiceDialog: { "title": "分配任务", "ref": "choiceForm", "visible": false, "staff_id": null }
	
	    };
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    _p.setTitle(pageTitle);
	    _todo2.default.readList(this);
	    this.$bus.on('reloadTodo', function () {
	      _todo2.default.readList(_this2);
	    });
	  }
	};

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _todo = __webpack_require__(455);
	
	var _todo2 = _interopRequireDefault(_todo);
	
	var _refundOrder = __webpack_require__(1126);
	
	var _refundOrder2 = _interopRequireDefault(_refundOrder);
	
	var _settleOrder = __webpack_require__(1128);
	
	var _settleOrder2 = _interopRequireDefault(_settleOrder);
	
	var _chargeOrder = __webpack_require__(1123);
	
	var _chargeOrder2 = _interopRequireDefault(_chargeOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['isHomePage'],
	    data: function data() {
	        return {
	            activeName: 'first',
	            carLoan: 'carLoan',
	            but_active: {
	                backgroundColor: "#337AB7",
	                color: "blanchedalmond"
	            },
	            but_style: {
	                padding: '15px 20px 15px',
	                fontSize: '16px'
	            },
	            tabs: [{ 'name': '车贷', show: true, component: 'carLoan', total: 0 }, { 'name': '扣款', show: false, component: 'charge', total: 0 }, { 'name': '退款', show: false, component: 'refund', total: 0 }, { 'name': '结清', show: false, component: 'settle', total: 0 }]
	
	        };
	    },
	
	    methods: {
	        changeTabs: function changeTabs(e, componentName, tabs) {
	            this.carLoan = componentName;
	            tabs.forEach(function (tab) {
	                if (tab.component !== componentName) tab.show = false;else tab.show = true;
	            });
	        },
	        getTotal: function getTotal(val, item) {
	            this.$set(item, 'total', val);
	        }
	    },
	    mounted: function mounted() {
	        if (this.isHomePage == true) {
	            this.tabs = [{ 'name': '放款', show: true, component: 'carLoan', total: 0 }, { 'name': '扣款', show: false, component: 'charge', total: 0 }, { 'name': '退款', show: false, component: 'refund', total: 0 }, { 'name': '结清', show: false, component: 'settle', total: 0 }];
	        }
	    },
	
	    components: { carLoan: _todo2.default, refund: _refundOrder2.default, settle: _settleOrder2.default, charge: _chargeOrder2.default }
	};

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = global.xwCommon,
	    pageTitle = "";
	
	exports.default = {
	  name: 'changelog',
	  data: function data() {
	    return { pageTitle: pageTitle };
	  },
	  mounted: function mounted() {
	
	    (0, _jquery2.default)(window).resize(function () {
	      var height = document.documentElement.clientHeight - 220;
	      (0, _jquery2.default)("#defaultImg").css("line-height", height + "px");
	    });
	    _p.setTitle(pageTitle);
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = global.xwCommon,
	    pageTitle = "常用功能",
	    methods = {
	    merchantBalance: function merchantBalance() {
	        var _this = this;
	
	        var url = _p.getApiUrl('finance/remain');
	        _jquery2.default.get(url, { 'role_oper_type': this.role_oper_type, 'depart_id': this.depart_id }, function (json) {
	            _this.remain = json.data;
	        });
	    },
	    creditStaticsPre: function creditStaticsPre() {
	        var _this2 = this;
	
	        var url = _p.getApiUrl("searchCredit/statics"),
	            month = new Date().getFullYear() + '-' + new Date().getMonth();
	        _jquery2.default.get(url, { 'role_oper_type': this.role_oper_type, 'depart_id': this.depart_id, 'month': month }, function (json) {
	            _this2.staticsDataPre = json.data.statics_data;
	            json.data.title.forEach(function (tl, index) {
	                if (index == 0) {
	                    _this2.tableHeadPre.push({ label: tl, prop: 'merchant_name' });
	                } else {
	                    _this2.tableHeadPre.push({ label: tl, prop: tl });
	                }
	            });
	        });
	    },
	    creditStaticsCur: function creditStaticsCur() {
	        var _this3 = this;
	
	        var url = _p.getApiUrl("searchCredit/statics"),
	            month = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
	        _jquery2.default.get(url, { 'role_oper_type': this.role_oper_type, 'depart_id': this.depart_id, 'month': month }, function (json) {
	            _this3.staticsDataCur = json.data.statics_data;
	            json.data.title.forEach(function (tl, index) {
	                if (index == 0) {
	                    _this3.tableHeadCur.push({ label: tl, prop: 'merchant_name' });
	                } else {
	                    _this3.tableHeadCur.push({ label: tl, prop: tl });
	                }
	            });
	        });
	    }
	};
	
	exports.default = {
	    methods: methods,
	    data: function data() {
	        return {
	            pageTitle: pageTitle,
	            auto_: "230px",
	            left: "left",
	            role_oper_type: "",
	            depart_id: "",
	
	            isWidth100: false,
	            remain: [],
	            tableHeadPre: [],
	            tableHeadCur: [],
	            staticsDataPre: [],
	            staticsDataCur: []
	        };
	    },
	    created: function created() {
	        document.documentElement.scrollTop = 0;
	    },
	
	    watch: {},
	    mounted: function mounted() {
	        var userinfo = _p.getStoredProp("staff/query");
	        this.role_oper_type = userinfo.role_oper_type;
	        this.depart_id = userinfo.depart_id;
	        this.merchantBalance();
	        this.creditStaticsPre();
	        this.creditStaticsCur();
	        window.xwStored.topCarTab.ref ? this.topCarTab = true : this.topCarTab = false;
	
	        if (document.body.clientWidth < 1595) {
	            this.isWidth100 = true;
	        } else {
	            this.isWidth100 = false;
	        }
	        var that = this;
	        window.onresize = function () {
	            return function () {
	                window.screenWidth = document.body.clientWidth;
	                that.screenWidth = window.screenWidth;
	            }();
	        };
	        _p.setTitle(pageTitle);
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _createWin = __webpack_require__(649);
	
	var _createWin2 = _interopRequireDefault(_createWin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    pageTitle = _createWin2.default.title,
	    name = _createWin2.default.name,
	    methods = {
	    citiesItemChange: function citiesItemChange(val, isUser) {
	        switch (val.length) {
	            case 2:
	                _createWin2.default.getDistrictList(this, val);
	
	                return;
	            case 1:
	                _createWin2.default.getCityList(this, val[0], 2);
	
	                return;
	            default:
	                this.$alert("无效的选项信息", pageTitle);
	                return;
	        }
	    },
	    idCardChange: function idCardChange(val) {
	        this.$set(this.orderForm, "idcard", val.toLocaleUpperCase());
	        var info = _p.getIDCardInfo(val);
	
	        if (info) {
	            this.$set(this.orderForm, "sex", info.sex);
	            this.$set(this.orderForm, "birthday", info.birthday);
	        }
	    },
	    syn: function syn() {
	        if (this.orderForm.car_num !== undefined && this.orderForm.car_num !== "") {
	            _createWin2.default.getCustomer(this, this.orderForm.car_num);
	        } else this.$alert("请输入车牌号后同步信息", this.pageTitle);
	    },
	    changeProductItem: function changeProductItem(val) {
	        var item = _lodash2.default.find(this.productSearchItem, function (o) {
	            return o.product_id == val;
	        });
	        if (item.business_type_id == 1) {
	            this.loanTypeOnly = true;
	            this.$set(this.orderForm, "car_load_type", 1);
	        } else {
	            this.loanTypeOnly = false;
	        }
	    },
	    submit: function submit() {
	        var _this2 = this;
	
	        _async2.default.waterfall([function (next) {
	            _this2.$refs["orderForm"].validate(function (valid) {
	                if (valid) next(null);else next(new Error("请修改表单错误后再提交！"));
	            });
	        }, function (next) {
	            _this2.submitLoading = true;
	            _this2.orderForm.is_check_car = _this2.is_check_car;
	            _createWin2.default.submit(_this2).then(function (data) {
	                return next(null, data);
	            }, function (err) {
	                return next(err);
	            });
	        }, function (data, next) {
	            _this2.showDialog = false;
	            _this2.$bus.emit('reloadTodo');
	            next(null);
	        }], function (err) {
	            _this2.submitLoading = false;
	            if (err) {
	                console.log(err);
	                _this2.$alert(err.message, _createWin2.default.title);
	            }
	        });
	    },
	    changeType: function changeType() {
	        var _ = this;
	        var order_type = _.orderForm.order_type;
	        if (order_type == 5) {
	            _.showCheckCar = true;
	        } else {
	            _.showCheckCar = false;
	        }
	    }
	};
	exports.default = {
	    name: name, methods: methods,
	    props: { "visible": { type: Boolean, default: false } },
	    data: function data() {
	        return {
	            pageTitle: pageTitle, treeLoading: false, showDialog: false, currDept: undefined, loanTypeOnly: false, submitLoading: false,
	            cities: { list: [], props: _p.getStoredProp("_/cities/props") },
	            productSearchProps: { "label": "product_name", "value": "product_id", "children": "childrens" },
	            userSexItem: _p.getStoredProp("_/default/sex"),
	            carLoadType: _p.getStoredProp("_/default/create/carLoadType"),
	            payType: _p.getStoredProp("_/default/car/payType"),
	            orderForm: {}, rules: _createWin2.default.rules, error: {}, productSearchItem: [], orderType: [], is_check_car: 1, showCheckCar: false
	        };
	    },
	    watch: {
	        visible: function visible(val) {
	            if (val) {
	                _createWin2.default.initWin(this);
	            } else this.showDialog = false;
	        },
	        showDialog: function showDialog(val) {
	            if (!val) this.$emit('closed');
	        }
	    },
	    mounted: function mounted() {}
	};

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _user = __webpack_require__(404);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    methods = {
	  loginSubmit: function loginSubmit(e) {
	    var _this2 = this;
	
	    this.$refs['form'].validate(function (valid) {
	      if (valid) {
	        _this2.$bus.emit("loading", true);
	        console.log(_this2.form);
	        _user2.default.userSignIn(_this2.form, _this2).then(function (json) {
	          _this2.$bus.emit("loading", false);
	          _this2.$bus.emit("loginOK", true);
	        }, function (json) {
	          console.log(json);
	          _this2.$bus.emit("loading", false);
	          var status = parseInt(json.status);
	          switch (status) {
	            case 1002:
	              json.data.forEach(function (desc) {
	                _this2.$set(_this2.error, desc.name, desc.error);
	              });
	              break;
	            case 2000:
	              _this2.$set(_this2.error, "verify_code", "验证码错误！");
	              _this2.$alert(json.msg, "用户登录");
	              break;
	            case 2001:
	              _this2.$alert(json.msg, "用户登录");
	              break;
	            default:
	              _p.promiseErrorChecker(_this2, json, "用户登录");
	              break;
	          }
	          _this2.form.verify_code = "";
	        });
	      } else {
	        return false;
	      }
	    });
	  },
	  changeImg: function changeImg(e) {
	    this.verifyImgUrl = _user2.default.getVerifyImg();
	  },
	  getVerifyImg: function getVerifyImg() {
	    return _p.getApiUrl("login/verifyCode", { "_t": _jquery2.default.now() });
	  }
	};
	
	exports.default = {
	  name: 'login', methods: methods,
	  data: function data() {
	    return {
	      news: "生命之灯因热情而点燃，生命之舟因拼搏而前行！",
	      form: {
	        username: "",
	        password: "",
	        verify_code: "",
	        remember: "no"
	      },
	      rules: {
	        username: [{ required: true, message: '请输入帐号', trigger: 'blur' }, { min: 2, max: 32, message: '帐号格式错误', trigger: 'blur' }],
	        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, max: 32, message: '密码格式错误', trigger: 'blur' }],
	        verify_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { min: 5, length: 5, message: '验证码格式错误', trigger: 'blur' }]
	      },
	      error: { username: "", password: "", verify_code: "", remember: "" },
	      verifyImgUrl: "",
	      isLoginBack: false
	    };
	  },
	  mounted: function mounted() {
	    this.isLoginBack = window.location.pathname == "/login";
	    (0, _jquery2.default)("title").html("HR融担平台");
	    _p.setStoredProp("isLoginBack", { "isLoginBack": this.isLoginBack });
	    (0, _jquery2.default)("#loginSection").css("background-image", "url(static/img/login_img_01.png)");
	    (0, _jquery2.default)("#logoArea span.logo").css("background-image", "url(static/img/login_logo.png)");
	    (0, _jquery2.default)('#loginSection').css('height', window.innerHeight + 'px');
	  }
	};

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _car = __webpack_require__(1055);
	
	var _car2 = _interopRequireDefault(_car);
	
	var _erp = __webpack_require__(1056);
	
	var _erp2 = _interopRequireDefault(_erp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = global.xwCommon;
	
	var items = {},
	    methods = {
		setArea: function setArea() {
			var _this = this;
	
			var cur = _p.getStoredProp("staff/currentQuery"),
			    menu = cur.menu,
			    area = this.sideparamas;
	
			if (!area) {
				area = "car";
			};
			if (area) {
				switch (area) {
					default:
						var tree = _lodash2.default.find(menu, function (o) {
							return o.ref == area;
						});
						if (tree.childrens) this.items = tree.childrens;else this.$alert("无子菜单,请联系管理员");
	
						break;
	
				}
			}
	
			this.$nextTick(function () {
				_this.setActive(_this.$route.name);
			});
		},
		setActive: function setActive(name) {
	
			var $item = (0, _jquery2.default)("#menuArea").find('[data-ref="' + name + '"]'),
			    pref = $item.data("pref");
	
	
			$item.siblings().removeClass("active");
			$item.addClass("active");
			if (pref) this.setActive(pref);
		}
	};
	
	exports.default = {
		name: 'menu', methods: methods,
		props: ['sideparamas'],
	
		data: function data() {
			return { items: items };
		},
	
		watch: {
			'$route': function $route(to) {
				this.setArea();
			},
			'area': function area() {
				this.setArea();
			}
		},
		mounted: function mounted() {
			this.setArea();
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(696);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cityChoser = __webpack_require__(62);
	
	var _cityChoser2 = _interopRequireDefault(_cityChoser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
	    title: "建档",
	    name: "createWin",
	    loadBaseNodes: function loadBaseNodes(vm) {
	        var func = function func(callback, reject) {
	            vm.$bus.emit("loading", true);
	            _async2.default.waterfall([function (next) {
	                _cityChoser2.default.getProvinceList(vm).then(function (data) {
	                    return next(null, data);
	                }, function (err) {
	                    return next(err);
	                });
	            }, function (provList, next) {
	                vm.cities.list = provList;
	
	                next(null);
	            }, function (next) {
	                var u = _p.getApiUrl("depart/getStoreByArea");
	                _jquery2.default.post(u).then(function (res) {
	                    var status = parseInt(res.status);
	                    if (status !== 200) {
	                        switch (status) {
	                            default:
	                                if (_p.checkAjaxStatus(vm, res, vm.title)) break;
	
	                                next(json.msg);
	                                break;
	                        }
	                        return;
	                    } else {
	                        var aData = res.data || [];
	                        aData.map(function (value) {
	                            value.name = value.province;
	                            value.children.map(function (value) {
	                                value.name = value.city;
	                                value.children.map(function (value) {
	                                    value.name = value.depart_name;
	                                });
	                            });
	                        });
	                        vm.StoreByArea = aData;
	                        next(null);
	                    }
	                });
	            }, function (next) {
	                var u = _p.getApiUrl('order/orderType');
	                _jquery2.default.post(u, { type: 'ph' }).then(function (res) {
	                    var status = parseInt(res.status);
	                    if (status !== 200) {
	                        switch (status) {
	                            default:
	                                if (_p.checkAjaxStatus(vm, res, vm.title)) break;
	
	                                next(json.msg);
	                                break;
	                        }
	                        return;
	                    } else {
	                        vm.orderType = res.data;
	                        next(null);
	                    }
	                });
	            }, function (next) {
	                var user = _p.getStoredProp("staff/query"),
	                    depart_type_id = _p.getStoredProp("staff/currentQuery").depart_type_id,
	                    data = { province_id: user.province_id, city_id: user.city_id, product_type: 2 },
	                    u = _p.getApiUrl("product/search");
	                _jquery2.default.post(u, data, function (json) {
	                    var status = parseInt(json.status);
	                    if (200 !== status) {
	                        switch (status) {
	                            default:
	                                if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg);
	                                break;
	                        }
	                        return;
	                    } else {
	                        var gData = _lodash2.default.groupBy(json.data, function (v) {
	                            return v.product_tpl_id;
	                        }),
	                            pData = [];
	                        gData = _lodash2.default.forEach(gData, function (childrens, k) {
	                            var tpl = childrens[0],
	                                product_id = tpl.product_tpl_id,
	                                product_name = tpl.name;
	                            if (tpl.product_type == 2) pData.push({ product_name: product_name, product_id: product_id, childrens: childrens });
	                        });
	                        vm.productSearchItem = pData;
	                        _lodash2.default.forEach(vm.productSearchItem, function (childrens, k) {
	                            _lodash2.default.forEach(childrens.childrens, function (j) {
	                                if (j.product_name == "小微速贷D11_OLD") {
	                                    j.disabled = true;
	                                }
	                            });
	                        });
	                        if (depart_type_id == 2) {
	                            _this.getCityList(vm, user.province_id, 2);
	                            _this.getDistrictList(vm, [user.province_id, user.city_id]);
	                        }
	                        next(null);
	                    }
	                }).then(function (data) {
	                    if (depart_type_id == 2) vm.$set(vm.fileForm, 'user_cityId', [user.province_id, user.city_id]);
	                });
	            }], function (err) {
	                vm.$bus.emit("loading", false);
	                if (err) return reject(err);else return callback();
	            });
	        };
	        return new _promise2.default(func);
	    },
	    initWin: function initWin(vm) {
	        _this.loadBaseNodes(vm).then(function () {
	            vm.fileForm = _this.getEmptyForm();
	            vm.showDialog = true;
	        });
	    },
	    getEmptyForm: function getEmptyForm() {
	        return {
	            order_type: 1
	        };
	    },
	    changeProductSearch: function changeProductSearch(vm) {
	        var u = _p.getApiUrl("product/search"),
	            cityId = _cityChoser2.default.parseCityId(vm.fileForm.cityId),
	            business_type_id = vm.fileForm.business_type_id,
	            pay_type_id = vm.fileForm.pay_type_id,
	            data = _jquery2.default.extend({ business_type_id: business_type_id, pay_type_id: pay_type_id }, cityId);
	        if (!(cityId.city_id % 1e4)) delete data.city_id;
	        _jquery2.default.post(u, data, function (json) {
	            var status = parseInt(json.status);
	            if (200 !== status) {
	                switch (status) {
	                    default:
	                        if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg);
	                        break;
	                }
	                return;
	            } else {
	                vm.productSearchItem = json.data;
	                vm.$set(vm.fileForm, "product_id", "");
	            }
	        });
	    },
	    submit: function submit(vm) {
	        var func = function func(callback, reject) {
	            var u = _p.getApiUrl("order/newOrder"),
	                obj = vm.fileForm,
	                data = _p.cleanProp(obj, ["cityId", "business_type_id", "pay_type_id", "user_cityId", "product_id"]);
	            if (obj.product_id.length > 1) {
	                data.product_id = obj.product_id[1];
	            }
	            vm.loading = true;
	            data.birthday = _p.date("yyyy-MM-dd", data.birthday);
	            data.resident_address = _cityChoser2.default.toCityName(vm, obj.user_cityId) + data.resident_address;
	            data.product_type = 2;
	            data.car_load_type = '';
	            _jquery2.default.post(u, data, function (json) {
	                var status = parseInt(json.status);
	                if (200 !== status) {
	                    switch (status) {
	                        default:
	                            if (_p.checkAjaxStatus(vm, json, _this.title)) break;else reject(new Error(json.msg));
	                            break;
	                    }
	                    return;
	                } else {
	                    vm.loading = false;
	                    vm.$notify({ title: _this.title, message: json.msg });
	                    vm.$bus.emit('reloadPuHuiTodo');
	                    callback(json.data);
	                }
	            }, "json");
	        };
	
	        return new _promise2.default(func);
	    },
	    getCustomer: function getCustomer(vm, car_num) {
	        var url = _p.getApiUrl("order/getSynOrderInfo");
	        _jquery2.default.post(url, { car_num: car_num }, function (json) {
	            var status = parseInt(json.status);
	            if (200 != status) {
	                switch (status) {
	                    default:
	                        if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg, _this.title);
	                        break;
	                }
	                return;
	            } else {
	                vm.fileForm.pay_type = String(json.data.pay_type);
	                vm.fileForm.mortgage_company = json.data.mortgage_company;
	                vm.fileForm.apply_purpose = json.data.apply_purpose;
	                vm.fileForm.apply_price = String(json.data.apply_price);
	                vm.fileForm.car_load_type = json.data.car_load_type;
	                _this.getBasicInfo(vm, json.data.order_id);
	            }
	        });
	    },
	    getBasicInfo: function getBasicInfo(vm, order_id) {
	        var url = _p.getApiUrl("order/getCustomerInfo");
	        _jquery2.default.post(url, { order_id: order_id }, function (json) {
	            var json = eval("(" + json + ")");
	            var status = parseInt(json.status);
	            if (200 != status) {
	                switch (status) {
	                    default:
	                        if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg, _this.title);
	                        break;
	                }
	                return;
	            } else {
	                vm.fileForm.name = json.data.name;
	                vm.fileForm.phone = json.data.phone;
	                vm.fileForm.idcard = json.data.idcard;
	                vm.fileForm.birthday = new Date(json.data.birthday);
	                vm.fileForm.sex = json.data.sex;
	                var addr = _cityChoser2.default.parseAddr(vm, json.data["resident_address"]);
	                vm.fileForm.resident_address = addr.addr;
	                vm.fileForm.user_cityId = addr.cityId || [];
	            }
	        });
	    },
	    getApplyPrice: function getApplyPrice(vm, val) {
	        var _val = (0, _slicedToArray3.default)(val, 3),
	            product_tpl_id = _val[0],
	            product_id = _val[1],
	            SearchItem = _val[2];
	
	        SearchItem = _lodash2.default.find(vm.productSearchItem, function (Pitem) {
	            return Pitem.product_id == product_tpl_id;
	        });
	        if (!SearchItem) return;
	        _lodash2.default.forEach(SearchItem.childrens, function (Sitem) {
	            if (Sitem.product_id == product_id) {
	                var price = Sitem.ph_apply_price + '' || "0";
	                vm.$set(vm.fileForm, "apply_price", price);
	                return;
	            }
	        });
	    },
	
	    rules: {
	        "product_id": [{ type: 'array', len: 2, required: true, message: '请选择产品', trigger: 'change' }],
	        "order_type": [{ type: 'integer', required: true, message: '请选择业务方式', trigger: 'change' }],
	        "car_load_type": [{ type: 'integer', required: true, message: '请选择估价方式', trigger: 'change' }],
	        "pay_type": [{ required: true, message: '请选择车辆按揭状态', trigger: 'blur' }],
	        "apply_price": [{ required: true, message: '请输入申请金额', trigger: 'blur' }, { min: 1, max: 32, message: '申请金额格式错误', trigger: 'blur' }],
	        "apply_purpose": [{ required: true, message: '请选择申请用途', trigger: 'change' }],
	        "name": [{ required: true, message: '请输入客户姓名', trigger: 'blur' }, { min: 2, max: 32, message: '客户姓名格式错误', trigger: 'blur' }],
	        "phone": [{ required: true, message: '请输入手机号码', trigger: 'blur' }, { min: 7, max: 13, message: '手机号码格式错误', trigger: 'blur' }, { validator: _p.validator.phone, message: '手机号码格式错误', trigger: 'blur' }],
	        "car_num": [{ required: true, message: '请输入车牌号', trigger: 'blur' }, { validator: _p.validator.carNum, message: '车牌号格式错误(不能存在空格符)', trigger: 'blur' }],
	        "idcard": [{ required: true, message: '请输入身份证号', trigger: 'blur' }, { len: 18, message: '身份证号格式错误', trigger: 'blur' }, { validator: _p.validator.idcard, message: '无效的身份证号', trigger: 'blur' }],
	        "birthday": [{ type: 'date', required: true, message: '请选择出生年月', trigger: 'change' }],
	        "sex": [{ type: 'integer', required: true, message: '请选择性别', trigger: 'change' }],
	        "resident_address": [{ required: true, message: '请输入户口所在地', trigger: 'blur' }, { min: 6, message: '户口所在地格式错误', trigger: 'blur' }],
	        "idcard_validity": [{ required: true, message: '请输入身份证有效期', trigger: 'blur' }]
	
	    },
	    getCityList: _cityChoser2.default.getCityList,
	    getDistrictList: _cityChoser2.default.getDistrictList
	};
	exports.default = _this;

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "门店复议",
		name: "storeReviewWin",
		initWin: function initWin(vm) {
			var order_id = vm.info.order_id,
			    order_node_id = vm.info.order_node_id,
			    func = function func(callback, reject) {
				_async2.default.waterfall([function (next) {
					var u = _p.getApiUrl("order/backlist");
					_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
						var status = parseInt(json.status);
						if (200 !== status) {
							switch (status) {
								default:
									if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
									next(json.msg);
									break;
							}
							return;
						} else {
							var data = json.data;
							if (data.length > 0) {
								vm.backNodeList = data;
								return next(null);
							} else {
								return next("当前节点不支持回退操作！");
							}
						}
					}, "JSON");
				}, function (next) {
					vm.reviewForm = _this.getEmptyForm();
					vm.reviewForm["order_id"] = order_id;
					vm.showDialog = true;
				}], function (err) {
					if (err) return reject(err);else return callback();
				});
			};
	
			return new _promise2.default(func);
		},
		getEmptyForm: function getEmptyForm() {
			return {
				"type": 2,
				"advicePrice": 0,
				"backNode": null,
				"mark": ""
			};
		},
		submit: function submit(vm) {
			var order_id = vm.info.order_id,
			    order_node_id = vm.info.order_node_id,
			    u = _p.getApiUrl("risk/storeReviev");
			vm.submitLoading = true;
			_async2.default.waterfall([function (next) {
				var form = _p.clone(vm.reviewForm);
				_jquery2.default.post(u, form, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							case 1002:
								json.data.forEach(function (desc) {
									vm.$set(vm.customerBasicError, desc.name, desc.error);
								});
								break;
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
								vm.$alert(json.msg, _this.title);
								break;
						}
						return;
					} else {
						vm.$notify({ title: _this.title, message: json.msg });
						next(null, form.type);
					}
				}, "JSON");
			}, function (type, next) {
				switch (type) {
					case 1:
						var arr = {
							order_node_id: order_node_id,
							back_node_id: vm.reviewForm["backNode"],
							last_msg: vm.reviewForm["mark"]
						};
						_this.sendBackTo(vm, arr).then(function () {
							next(null);
						}).catch(function (err) {
							return next(err);
						});
						break;
					case 2:
	
						_this.transition(vm, order_node_id).then(function () {
							next(null);
						}).catch(function (err) {
							return next(err);
						});
						break;
					case 3:
						next(null);
						break;
				}
			}], function (err) {
				if (err) {
					vm.$alert(err.toString(), _this.title);
					return;
				} else {
					vm.submitLoading = false;
					vm.showDialog = false;
					vm.$bus.emit('reloadTodo');
				}
			});
		},
		transition: function transition(vm, order_node_id) {
			var u = _p.getApiUrl("order/transition"),
			    func = function func(_callback, reject) {
				_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
								reject(new Error(json.msg));
								break;
						}
						return;
					} else {
						vm.$alert(json.msg, _this.title, {
							"callback": function callback(action) {
								_callback();
							}
						});
					}
				}, "JSON");
			};
	
			return new _promise2.default(func);
		},
		sendBackTo: function sendBackTo(vm, data) {
			var u = _p.getApiUrl("order/back"),
			    func = function func(callback, reject) {
				_jquery2.default.post(u, data, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
								reject(new Error(json.msg));
								break;
						}
						return;
					} else {
						vm.$notify({ title: _this.title, message: json.msg });
						callback();
					}
				}, "JSON");
			};
			return new _promise2.default(func);
		}
	};
	exports.default = _this;

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "弹窗",
		name: "popupWin",
		initWin: function initWin(vm) {
			var order_id = vm.info.order_id,
			    order_node_id = vm.info.order_node_id,
			    func = function func(callback, reject) {
				_async2.default.waterfall([function (next) {
					var u = _p.getApiUrl("table/list");
					_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
						var status = parseInt(json.status);
						if (200 !== status) {
							switch (status) {
								default:
									if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
									next(new Error(json.msg));
									break;
							}
							return;
						} else {
							next(null, json.data);
						}
					}, "JSON");
				}, function (data, next) {
					if (data.length != 1) {
						next(new Error("表单描述信息错误"));
					} else {
						next(null, data[0]);
					}
				}, function (data, next) {
					vm.popupItem = data;
				}], function (err) {
					if (err) return reject(err);else return callback();
				});
			};
	
			return new _promise2.default(func);
		}
	};
	exports.default = _this;

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "待办任务",
		name: "car_user_todo",
		readList: function readList(vm, p, s) {
			vm.loading = true;
			var url = _p.getApiUrl("ordernode/todo"),
			    page = p || vm.currentPage,
			    page_size = s || vm.pageSize,
			    product_type = 1;
			if (vm.isHomePageSub) {
				product_type = -1;
			} else {
				product_type = 1;
			}
			_jquery2.default.post(url, { page: page, page_size: page_size, back_state: 3, product_type: product_type }, function (json) {
				return _this.fillData(vm, json);
			});
		},
		fillData: function fillData(vm, json) {
			var status = parseInt(json.status);
			if (200 !== status) {
				switch (status) {
					default:
						if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
						break;
				}
				return;
			} else if (_p.isNull(json.data)) {
				vm.$nextTick(function () {
					vm.tableData = [];
					vm.currentPage = 1;
					vm.totalRow = 0;
					vm.pageSize = 20;
					vm.loading = false;
					vm.$emit("getTotal", vm.totalRow);
				});
			} else {
				vm.$nextTick(function () {
					var tableData = json.data.data || [];
					if (tableData.length > 0) {
						for (var key in tableData) {
							if (tableData[key].product_type == 1) {
								tableData[key].product_type = "车贷";
							} else if (tableData[key].product_type == 2) {
								tableData[key].product_type = "普惠";
							}
						}
					}
					vm.tableData = tableData;
					vm.currentPage = parseInt(json.data.current_page);
					vm.totalRow = parseInt(json.data.total);
					vm.pageSize = parseInt(json.data.per_page);
					vm.$emit("getTotal", vm.totalRow);
					vm.loading = false;
				});
			}
		},
		showChoiceWin: function showChoiceWin(vm, order_node_id) {
			_async2.default.waterfall([function (next) {
				_this.getChoiceStaff(order_node_id).then(function (data) {
					vm.staffChoiceList = data.map(function (o) {
						return {
							"name": _util2.default.format("%s - %s(待办任务 %s 件)", o.username, o.role_name, o.backlog),
							"staff_id": o.staff_id
						};
					});
					next(null);
				});
			}, function (next) {
				vm.choiceDialog["order_node_id"] = order_node_id;
				vm.choiceDialog["staff_id"] = null;
				vm.choiceDialog.visible = true;
				next(null);
			}], function (err) {
				if (err) {
					vm.$alert(err.toString(), _this.title);
				}
			});
		},
		getChoiceStaff: function getChoiceStaff(order_node_id) {
			var u = _p.getApiUrl("staff/distributing"),
			    func = function func(callback, reject) {
				_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
								reject(json);
								break;
						}
						return;
					} else {
						callback(json.data);
					}
				}, "JSON");
			};
	
			return new _promise2.default(func);
		},
		submitChoice: function submitChoice(vm, order_node_id, staff_id) {
			vm.loading = true;
			var u = _p.getApiUrl("ordernode/assign");
	
			_jquery2.default.post(u, { order_node_id: order_node_id, staff_id: staff_id }, function (json) {
				var status = parseInt(json.status);
				if (200 !== status) {
					switch (status) {
						case 1002:
							json.data.forEach(function (desc) {
								vm.$set(vm.customerBasicError, desc.name, desc.error);
							});
							break;
						default:
							if (_p.checkAjaxStatus(vm, json, _this.title)) break;
							vm.$alert(json.msg, _this.title);
							break;
					}
					return;
				} else {
					vm.$notify({ title: _this.title, message: json.msg });
					vm.choiceDialog.visible = false;
					_this.readList(vm);
				}
			}, "JSON");
		}
	};
	
	exports.default = _this;

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "待办任务",
		name: "car_user_todo",
		readList: function readList(vm, p, s) {
			vm.loading = true;
			var url = _p.getApiUrl("ordernode/todo"),
			    page = p || vm.currentPage,
			    page_size = s || vm.pageSize,
			    product_type = 1;
			if (vm.isHomePageSub) {
				product_type = -1;
			} else {
				product_type = 1;
			}
			_jquery2.default.post(url, { page: page, page_size: page_size, back_state: 2, product_type: product_type }, function (json) {
				return _this.fillData(vm, json);
			});
		},
		fillData: function fillData(vm, json) {
			var status = parseInt(json.status);
			if (200 !== status) {
				switch (status) {
					default:
						if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
						break;
				}
				return;
			} else if (_p.isNull(json.data)) {
				vm.$nextTick(function () {
					vm.tableData = [];
					vm.currentPage = 1;
					vm.totalRow = 0;
					vm.pageSize = 20;
					vm.loading = false;
					vm.$emit("getTotal", vm.totalRow);
				});
			} else {
				vm.$nextTick(function () {
					var tableData = json.data.data || [];
					if (tableData.length > 0) {
						for (var key in tableData) {
							if (tableData[key].product_type == 1) {
								tableData[key].product_type = "车贷";
							} else if (tableData[key].product_type == 2) {
								tableData[key].product_type = "普惠";
							}
						}
					}
	
					vm.tableData = tableData;
					vm.currentPage = parseInt(json.data.current_page);
					vm.totalRow = parseInt(json.data.total);
					vm.pageSize = parseInt(json.data.per_page);
					vm.loading = false, vm.$emit("getTotal", vm.totalRow);
				});
			}
		},
		showChoiceWin: function showChoiceWin(vm, order_node_id) {
			_async2.default.waterfall([function (next) {
				_this.getChoiceStaff(order_node_id).then(function (data) {
					vm.staffChoiceList = data.map(function (o) {
						return {
							"name": _util2.default.format("%s - %s(待办任务 %s 件)", o.username, o.role_name, o.backlog),
							"staff_id": o.staff_id
						};
					});
					next(null);
				});
			}, function (next) {
				vm.choiceDialog["order_node_id"] = order_node_id;
				vm.choiceDialog["staff_id"] = null;
				vm.choiceDialog.visible = true;
				next(null);
			}], function (err) {
				if (err) {
					vm.$alert(err.toString(), _this.title);
				}
			});
		},
		getChoiceStaff: function getChoiceStaff(order_node_id) {
			var u = _p.getApiUrl("staff/distributing"),
			    func = function func(callback, reject) {
				_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
								reject(json);
								break;
						}
						return;
					} else {
						callback(json.data);
					}
				}, "JSON");
			};
	
			return new _promise2.default(func);
		},
		submitChoice: function submitChoice(vm, order_node_id, staff_id) {
			vm.loading = true;
			var u = _p.getApiUrl("ordernode/assign");
	
			_jquery2.default.post(u, { order_node_id: order_node_id, staff_id: staff_id }, function (json) {
				var status = parseInt(json.status);
				if (200 !== status) {
					switch (status) {
						case 1002:
							json.data.forEach(function (desc) {
								vm.$set(vm.customerBasicError, desc.name, desc.error);
							});
							break;
						default:
							if (_p.checkAjaxStatus(vm, json, _this.title)) break;
							vm.$alert(json.msg, _this.title);
							break;
					}
					return;
				} else {
					vm.$notify({ title: _this.title, message: json.msg });
					vm.choiceDialog.visible = false;
					_this.readList(vm);
				}
			}, "JSON");
		}
	};
	
	exports.default = _this;

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "待办任务",
		name: "car_user_todo",
		readList: function readList(vm, p, s) {
			vm.loading = true;
			var url = _p.getApiUrl("ordernode/todo"),
			    page = p || vm.currentPage,
			    page_size = s || vm.pageSize,
			    product_type = 1;
			if (vm.isHomePageSub) {
				product_type = -1;
			} else if (vm.isFinancialSystem) {
				product_type = 2;
			} else {
				product_type = 1;
			};
			_jquery2.default.post(url, { page: page, page_size: page_size, back_state: 1, product_type: product_type }, function (json) {
				return _this.fillData(vm, json);
			});
		},
		fillData: function fillData(vm, json) {
			var status = parseInt(json.status);
			if (200 !== status) {
				switch (status) {
					default:
						if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
						break;
				}
				return;
			} else if (_p.isNull(json.data)) {
				vm.$nextTick(function () {
					vm.tableData = [];
					vm.currentPage = 1;
					vm.totalRow = 0;
					vm.pageSize = 20;
					vm.loading = false;
					vm.$emit("getTotal", vm.totalRow);
				});
			} else {
				vm.$nextTick(function () {
					var tableData = json.data.data || [];
					if (tableData.length > 0) {
						for (var key in tableData) {
							if (tableData[key].product_type == 1) {
								tableData[key].product_type = "车贷";
							} else if (tableData[key].product_type == 2) {
								tableData[key].product_type = "普惠";
							}
						}
					}
					vm.tableData = tableData;
					vm.currentPage = parseInt(json.data.current_page);
					vm.totalRow = parseInt(json.data.total);
					vm.pageSize = parseInt(json.data.per_page);
					vm.$emit("getTotal", vm.totalRow);
					vm.loading = false;
				});
			}
		},
		showChoiceWin: function showChoiceWin(vm, order_node_id) {
			_async2.default.waterfall([function (next) {
				_this.getChoiceStaff(order_node_id).then(function (data) {
					vm.staffChoiceList = data.map(function (o) {
						return {
							"name": _util2.default.format("%s - %s(待办任务 %s 件)", o.username, o.role_name, o.backlog),
							"staff_id": o.staff_id
						};
					});
					next(null);
				});
			}, function (next) {
				vm.choiceDialog["order_node_id"] = order_node_id;
				vm.choiceDialog["staff_id"] = null;
				vm.choiceDialog.visible = true;
				next(null);
			}], function (err) {
				if (err) {
					vm.$alert(err.toString(), _this.title);
				}
			});
		},
		getChoiceStaff: function getChoiceStaff(order_node_id) {
			var u = _p.getApiUrl("staff/distributing"),
			    func = function func(callback, reject) {
				_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
								reject(json);
								break;
						}
						return;
					} else {
						callback(json.data);
					}
				}, "JSON");
			};
	
			return new _promise2.default(func);
		},
		submitChoice: function submitChoice(vm, order_node_id, staff_id) {
			vm.loading = true;
			var u = _p.getApiUrl("ordernode/assign");
	
			_jquery2.default.post(u, { order_node_id: order_node_id, staff_id: staff_id }, function (json) {
				var status = parseInt(json.status);
				if (200 !== status) {
					switch (status) {
						case 1002:
							json.data.forEach(function (desc) {
								vm.$set(vm.customerBasicError, desc.name, desc.error);
							});
							break;
						default:
							if (_p.checkAjaxStatus(vm, json, _this.title)) break;
							vm.$alert(json.msg, _this.title);
							break;
					}
					return;
				} else {
					vm.$notify({ title: _this.title, message: json.msg });
					vm.choiceDialog.visible = false;
					_this.readList(vm);
				}
			}, "JSON");
		}
	};
	
	exports.default = _this;

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _util = __webpack_require__(10);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
		title: "待办任务",
		name: "car_user_todo",
		readList: function readList(vm, p, s) {
			vm.loading = true;
			var url = _p.getApiUrl("ordernode/todo"),
			    page = p || vm.currentPage,
			    page_size = s || vm.pageSize,
			    product_type = 1;
			if (vm.isHomePageSub) {
				product_type = -1;
			} else {
				product_type = 1;
			}
			_jquery2.default.post(url, { page: page, page_size: page_size, product_type: product_type }, function (json) {
				return _this.fillData(vm, json);
			});
		},
		fillData: function fillData(vm, json) {
			var status = parseInt(json.status);
			if (200 !== status) {
				switch (status) {
					default:
						if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
						break;
				}
				return;
			} else if (_p.isNull(json.data)) {
				vm.$nextTick(function () {
					vm.tableData = [];
					vm.currentPage = 1;
					vm.totalRow = 0;
					vm.pageSize = 20;
					vm.loading = false;
					vm.$emit("getTotal", vm.totalRow);
				});
			} else {
				vm.$nextTick(function () {
					var tableData = json.data.data || [];
					if (tableData.length > 0) {
						for (var key in tableData) {
							if (tableData[key].product_type == 1) {
								tableData[key].product_type = "车贷";
							} else if (tableData[key].product_type == 2) {
								tableData[key].product_type = "普惠";
							}
						}
					}
					vm.tableData = tableData;
					vm.currentPage = parseInt(json.data.current_page);
					vm.totalRow = parseInt(json.data.total);
					vm.pageSize = parseInt(json.data.per_page);
					vm.$emit("getTotal", vm.totalRow);
					vm.loading = false;
				});
			}
		},
		showChoiceWin: function showChoiceWin(vm, order_node_id) {
			_async2.default.waterfall([function (next) {
				_this.getChoiceStaff(order_node_id).then(function (data) {
					vm.staffChoiceList = data.map(function (o) {
						return {
							"name": _util2.default.format("%s - %s(待办任务 %s 件)", o.username, o.role_name, o.backlog),
							"staff_id": o.staff_id
						};
					});
					next(null);
				});
			}, function (next) {
				vm.choiceDialog["order_node_id"] = order_node_id;
				vm.choiceDialog["staff_id"] = null;
				vm.choiceDialog.visible = true;
				next(null);
			}], function (err) {
				if (err) {
					vm.$alert(err.toString(), _this.title);
				}
			});
		},
		getChoiceStaff: function getChoiceStaff(order_node_id) {
			var u = _p.getApiUrl("staff/distributing"),
			    func = function func(callback, reject) {
				_jquery2.default.post(u, { order_node_id: order_node_id }, function (json) {
					var status = parseInt(json.status);
					if (200 !== status) {
						switch (status) {
							default:
								if (_p.checkAjaxStatus(vm, json, _this.title)) break;
	
								reject(json);
								break;
						}
						return;
					} else {
						callback(json.data);
					}
				}, "JSON");
			};
	
			return new _promise2.default(func);
		},
		submitChoice: function submitChoice(vm, order_node_id, staff_id) {
			vm.loading = true;
			var u = _p.getApiUrl("ordernode/assign");
	
			_jquery2.default.post(u, { order_node_id: order_node_id, staff_id: staff_id }, function (json) {
				var status = parseInt(json.status);
				if (200 !== status) {
					switch (status) {
						case 1002:
							json.data.forEach(function (desc) {
								vm.$set(vm.customerBasicError, desc.name, desc.error);
							});
							break;
						default:
							if (_p.checkAjaxStatus(vm, json, _this.title)) break;
							vm.$alert(json.msg, _this.title);
							break;
					}
					return;
				} else {
					vm.$notify({ title: _this.title, message: json.msg });
					vm.choiceDialog.visible = false;
					_this.readList(vm);
				}
			}, "JSON");
		}
	};
	
	exports.default = _this;

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(8);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _async = __webpack_require__(2);
	
	var _async2 = _interopRequireDefault(_async);
	
	var _lodash = __webpack_require__(4);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cityChoser = __webpack_require__(62);
	
	var _cityChoser2 = _interopRequireDefault(_cityChoser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _p = window.xwCommon,
	    _this = {
	    title: "建档",
	    name: "createWin",
	    loadBaseNodes: function loadBaseNodes(vm) {
	        var func = function func(callback, reject) {
	            vm.$bus.emit("loading", true);
	            _async2.default.waterfall([function (next) {
	                _cityChoser2.default.getProvinceList(vm).then(function (data) {
	                    return next(null, data);
	                }, function (err) {
	                    return next(err);
	                });
	            }, function (provList, next) {
	                vm.cities.list = provList;
	
	                next(null);
	            }, function (next) {
	                _p.getStoredApiProp("order/orderType").then(function (data) {
	                    vm.orderType = data;
	                    next(null);
	                });
	            }, function (next) {
	                var user = _p.getStoredProp("staff/query"),
	                    depart_type_id = _p.getStoredProp("staff/currentQuery").depart_type_id,
	                    data = { province_id: user.province_id, city_id: user.city_id },
	                    u = _p.getApiUrl("product/search");
	                _jquery2.default.post(u, data, function (json) {
	                    var status = parseInt(json.status);
	                    if (200 !== status) {
	                        switch (status) {
	                            default:
	                                if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg);
	                                break;
	                        }
	                        return;
	                    } else {
	                        var gData = _lodash2.default.groupBy(json.data, function (v) {
	                            return v.product_tpl_id;
	                        }),
	                            pData = [];
	                        gData = _lodash2.default.forEach(gData, function (childrens, k) {
	                            var tpl = childrens[0],
	                                product_id = tpl.product_tpl_id,
	                                product_name = tpl.name;
	                            pData.push({ product_name: product_name, product_id: product_id, childrens: childrens });
	                        });
	                        console.log(pData);
	                        vm.productSearchItem = pData;
	                        if (depart_type_id == 2) {
	                            _this.getCityList(vm, user.province_id, 2);
	                            _this.getDistrictList(vm, [user.province_id, user.city_id]);
	                        }
	                        next(null);
	                    }
	                }).then(function (data) {
	                    if (depart_type_id == 2) vm.$set(vm.orderForm, 'user_cityId', [user.province_id, user.city_id]);
	                });
	            }], function (err) {
	                vm.$bus.emit("loading", false);
	                if (err) return reject(err);else return callback();
	            });
	        };
	        return new _promise2.default(func);
	    },
	    initWin: function initWin(vm) {
	        _this.loadBaseNodes(vm).then(function () {
	            vm.orderForm = _this.getEmptyForm();
	            vm.showDialog = true;
	        });
	    },
	    getEmptyForm: function getEmptyForm() {
	        return {
	            order_type: 1, productId: [], car_load_type: null,
	            sex: null, birthday: null, pay_type: null, mortgage_company: null
	        };
	    },
	    changeProductSearch: function changeProductSearch(vm) {
	        var u = _p.getApiUrl("product/search"),
	            cityId = _cityChoser2.default.parseCityId(vm.orderForm.cityId),
	            business_type_id = vm.orderForm.business_type_id,
	            pay_type_id = vm.orderForm.pay_type_id,
	            data = _jquery2.default.extend({ business_type_id: business_type_id, pay_type_id: pay_type_id }, cityId);
	        if (!(cityId.city_id % 1e4)) delete data.city_id;
	        _jquery2.default.post(u, data, function (json) {
	            var status = parseInt(json.status);
	            if (200 !== status) {
	                switch (status) {
	                    default:
	                        if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg);
	                        break;
	                }
	                return;
	            } else {
	                vm.productSearchItem = json.data;
	                vm.$set(vm.orderForm, "product_id", "");
	            }
	        });
	    },
	    submit: function submit(vm) {
	        var func = function func(callback, reject) {
	            var u = _p.getApiUrl("order/newOrder"),
	                obj = vm.orderForm,
	                data = _p.cleanProp(obj, ["cityId", "business_type_id", "pay_type_id", "user_cityId", "productId"]);
	            if (obj.productId.length > 1) {
	                data.product_id = obj.productId[1];
	            }
	
	            data.birthday = _p.date("yyyy-MM-dd", data.birthday);
	            data.resident_address = _cityChoser2.default.toCityName(vm, obj.user_cityId) + data.resident_address;
	            _jquery2.default.post(u, data, function (json) {
	                var status = parseInt(json.status);
	                if (200 !== status) {
	                    switch (status) {
	                        default:
	                            if (_p.checkAjaxStatus(vm, json, _this.title)) break;else reject(new Error(json.msg));
	                            break;
	                    }
	                    return;
	                } else {
	                    vm.$notify({ title: _this.title, message: json.msg });
	                    callback(json.data);
	                }
	            }, "json");
	        };
	
	        return new _promise2.default(func);
	    },
	    getCustomer: function getCustomer(vm, car_num) {
	        var url = _p.getApiUrl("order/getSynOrderInfo");
	        _jquery2.default.post(url, { car_num: car_num }, function (json) {
	            var status = parseInt(json.status);
	            if (200 != status) {
	                switch (status) {
	                    default:
	                        if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg, _this.title);
	                        break;
	                }
	                return;
	            } else {
	                vm.orderForm.pay_type = String(json.data.pay_type);
	                vm.orderForm.mortgage_company = json.data.mortgage_company;
	                vm.orderForm.apply_purpose = json.data.apply_purpose;
	                vm.orderForm.apply_price = String(json.data.apply_price);
	                vm.orderForm.car_load_type = json.data.car_load_type;
	                _this.getBasicInfo(vm, json.data.order_id);
	            }
	        });
	    },
	    getBasicInfo: function getBasicInfo(vm, order_id) {
	        var url = _p.getApiUrl("order/getCustomerInfo");
	        _jquery2.default.post(url, { order_id: order_id }, function (json) {
	            var json = eval("(" + json + ")");
	            var status = parseInt(json.status);
	            if (200 != status) {
	                switch (status) {
	                    default:
	                        if (_p.checkAjaxStatus(vm, json, _this.title)) break;else vm.$alert(json.msg, _this.title);
	                        break;
	                }
	                return;
	            } else {
	                vm.orderForm.name = json.data.name;
	                vm.orderForm.phone = json.data.phone;
	                vm.orderForm.idcard = json.data.idcard;
	                vm.orderForm.birthday = new Date(json.data.birthday);
	                vm.orderForm.sex = json.data.sex;
	                var addr = _cityChoser2.default.parseAddr(vm, json.data["resident_address"]);
	                vm.orderForm.resident_address = addr.addr;
	                vm.orderForm.user_cityId = addr.cityId || [];
	            }
	        });
	    },
	
	    rules: {
	        "productId": [{ type: 'array', len: 2, required: true, message: '请选择产品', trigger: 'change' }],
	        "order_type": [{ type: 'integer', required: true, message: '请选择业务方式', trigger: 'change' }],
	        "car_load_type": [{ type: 'integer', required: true, message: '请选择估价方式', trigger: 'change' }],
	        "pay_type": [{ required: true, message: '请选择车辆按揭状态', trigger: 'blur' }],
	        "apply_price": [{ required: true, message: '请输入申请金额', trigger: 'blur' }, { min: 2, max: 32, message: '申请金额格式错误', trigger: 'blur' }],
	        "apply_purpose": [{ required: true, message: '请输入申请用途', trigger: 'blur' }, { min: 1, message: '申请用途至少需要1个字', trigger: 'blur' }],
	        "name": [{ required: true, message: '请输入客户姓名', trigger: 'blur' }, { min: 2, max: 32, message: '客户姓名格式错误', trigger: 'blur' }],
	        "phone": [{ required: true, message: '请输入手机号码', trigger: 'blur' }, { min: 7, max: 13, message: '手机号码格式错误', trigger: 'blur' }, { validator: _p.validator.phone, message: '手机号码格式错误', trigger: 'blur' }],
	        "car_num": [{ required: true, message: '请输入车牌号', trigger: 'blur' }, { validator: _p.validator.carNum, message: '车牌号格式错误(不能存在空格符)', trigger: 'blur' }],
	        "car_price": [{ required: true, message: '请输入购车价' }, { validator: _p.validator.carPrice, message: '购车价格必须为数字' }],
	        "is_check_car": [],
	        "idcard": [{ required: true, message: '请输入身份证号', trigger: 'blur' }, { len: 18, message: '身份证号格式错误', trigger: 'blur' }, { validator: _p.validator.idcard, message: '无效的身份证号', trigger: 'blur' }],
	        "birthday": [{ type: 'date', required: true, message: '请选择出生年月', trigger: 'change' }],
	        "sex": [{ type: 'integer', required: true, message: '请选择性别', trigger: 'change' }],
	        "resident_address": [{ required: true, message: '请输入户口所在地', trigger: 'blur' }, { min: 6, message: '户口所在地格式错误', trigger: 'blur' }]
	
	    },
	    getCityList: _cityChoser2.default.getCityList,
	    getDistrictList: _cityChoser2.default.getDistrictList
	};
	exports.default = _this;

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_jquery2.default.AdminLTE = {}; /*! AdminLTE app.js
	                                 * ================
	                                 * Main JS application file for AdminLTE v2. This file
	                                 * should be included in all pages. It controls some layout
	                                 * options and implements exclusive AdminLTE plugins.
	                                 *
	                                 * @Author  Almsaeed Studio
	                                 * @Support <http://www.almsaeedstudio.com>
	                                 * @Email   <support@almsaeedstudio.com>
	                                 * @version 2.3.5
	                                 * @license MIT <http://opensource.org/licenses/MIT>
	                                 */
	
	_jquery2.default.AdminLTE.options = {
	  navbarMenuSlimscroll: true,
	  navbarMenuSlimscrollWidth: "3px",
	  navbarMenuHeight: "200px",
	  animationSpeed: 500,
	
	  sidebarToggleSelector: "[data-toggle='offcanvas']",
	
	  sidebarPushMenu: true,
	
	  sidebarSlimScroll: true,
	
	  sidebarExpandOnHover: false,
	
	  enableBoxRefresh: true,
	
	  enableBSToppltip: true,
	  BSTooltipSelector: "[data-toggle='tooltip']",
	
	  enableFastclick: false,
	
	  enableControlSidebar: true,
	  controlSidebarOptions: {
	    toggleBtnSelector: "[data-toggle='control-sidebar']",
	
	    selector: ".control-sidebar",
	
	    slide: true
	  },
	
	  enableBoxWidget: true,
	
	  boxWidgetOptions: {
	    boxWidgetIcons: {
	      collapse: 'fa-minus',
	
	      open: 'fa-plus',
	
	      remove: 'fa-times'
	    },
	    boxWidgetSelectors: {
	      remove: '[data-widget="remove"]',
	
	      collapse: '[data-widget="collapse"]'
	    }
	  },
	
	  directChat: {
	    enable: true,
	
	    contactToggleSelector: '[data-widget="chat-pane-toggle"]'
	  },
	
	  colors: {
	    lightBlue: "#3c8dbc",
	    red: "#f56954",
	    green: "#00a65a",
	    aqua: "#00c0ef",
	    yellow: "#f39c12",
	    blue: "#0073b7",
	    navy: "#001F3F",
	    teal: "#39CCCC",
	    olive: "#3D9970",
	    lime: "#01FF70",
	    orange: "#FF851B",
	    fuchsia: "#F012BE",
	    purple: "#8E24AA",
	    maroon: "#D81B60",
	    black: "#222222",
	    gray: "#d2d6de"
	  },
	
	  screenSizes: {
	    xs: 480,
	    sm: 768,
	    md: 992,
	    lg: 1200
	  }
	};
	
	(0, _jquery2.default)(function () {
	  "use strict";
	
	  (0, _jquery2.default)("body").removeClass("hold-transition");
	
	  if (typeof AdminLTEOptions !== "undefined") {
	    _jquery2.default.extend(true, _jquery2.default.AdminLTE.options, AdminLTEOptions);
	  }
	
	  var o = _jquery2.default.AdminLTE.options;
	
	  _init();
	
	  _jquery2.default.AdminLTE.layout.activate();
	
	  _jquery2.default.AdminLTE.tree('.sidebar');
	
	  if (o.enableControlSidebar) {
	    _jquery2.default.AdminLTE.controlSidebar.activate();
	  }
	
	  if (o.navbarMenuSlimscroll && typeof _jquery2.default.fn.slimscroll != 'undefined') {
	    (0, _jquery2.default)(".navbar .menu").slimscroll({
	      height: o.navbarMenuHeight,
	      alwaysVisible: false,
	      size: o.navbarMenuSlimscrollWidth
	    }).css("width", "100%");
	  }
	
	  if (o.sidebarPushMenu) {
	    _jquery2.default.AdminLTE.pushMenu.activate(o.sidebarToggleSelector);
	  }
	
	  if (o.enableBSToppltip) {
	    (0, _jquery2.default)('body').tooltip({
	      selector: o.BSTooltipSelector
	    });
	  }
	
	  if (o.enableBoxWidget) {
	    _jquery2.default.AdminLTE.boxWidget.activate();
	  }
	
	  if (o.enableFastclick && typeof FastClick != 'undefined') {
	    FastClick.attach(document.body);
	  }
	
	  if (o.directChat.enable) {
	    (0, _jquery2.default)(document).on('click', o.directChat.contactToggleSelector, function () {
	      var box = (0, _jquery2.default)(this).parents('.direct-chat').first();
	      box.toggleClass('direct-chat-contacts-open');
	    });
	  }
	
	  (0, _jquery2.default)('.btn-group[data-toggle="btn-toggle"]').each(function () {
	    var group = (0, _jquery2.default)(this);
	    (0, _jquery2.default)(this).find(".btn").on('click', function (e) {
	      group.find(".btn.active").removeClass("active");
	      (0, _jquery2.default)(this).addClass("active");
	      e.preventDefault();
	    });
	  });
	});
	
	function _init() {
	  'use strict';
	
	  _jquery2.default.AdminLTE.layout = {
	    activate: function activate() {
	      var _this = this;
	      _this.fix();
	      _this.fixSidebar();
	      (0, _jquery2.default)(window, ".wrapper").resize(function () {
	        _this.fix();
	        _this.fixSidebar();
	      });
	    },
	    fix: function fix() {
	      var neg = (0, _jquery2.default)('.main-header').outerHeight() + (0, _jquery2.default)('.main-footer').outerHeight();
	      var window_height = (0, _jquery2.default)(window).height();
	      var sidebar_height = (0, _jquery2.default)(".sidebar").height();
	
	      if ((0, _jquery2.default)("body").hasClass("fixed")) {
	        (0, _jquery2.default)(".content-wrapper, .right-side").css('min-height', window_height - (0, _jquery2.default)('.main-footer').outerHeight());
	      } else {
	        var postSetWidth;
	        if (window_height >= sidebar_height) {
	          (0, _jquery2.default)(".content-wrapper, .right-side").css('min-height', window_height - neg);
	          postSetWidth = window_height - neg;
	        } else {
	          (0, _jquery2.default)(".content-wrapper, .right-side").css('min-height', sidebar_height);
	          postSetWidth = sidebar_height;
	        }
	
	        var controlSidebar = (0, _jquery2.default)(_jquery2.default.AdminLTE.options.controlSidebarOptions.selector);
	        if (typeof controlSidebar !== "undefined") {
	          if (controlSidebar.height() > postSetWidth) (0, _jquery2.default)(".content-wrapper, .right-side").css('min-height', controlSidebar.height());
	        }
	      }
	    },
	    fixSidebar: function fixSidebar() {
	      if (!(0, _jquery2.default)("body").hasClass("fixed")) {
	        if (typeof _jquery2.default.fn.slimScroll != 'undefined') {
	          (0, _jquery2.default)(".sidebar").slimScroll({ destroy: true }).height("auto");
	        }
	        return;
	      } else if (typeof _jquery2.default.fn.slimScroll == 'undefined' && window.console) {
	        window.console.error("Error: the fixed layout requires the slimscroll plugin!");
	      }
	
	      if (_jquery2.default.AdminLTE.options.sidebarSlimScroll) {
	        if (typeof _jquery2.default.fn.slimScroll != 'undefined') {
	          (0, _jquery2.default)(".sidebar").slimScroll({ destroy: true }).height("auto");
	
	          (0, _jquery2.default)(".sidebar").slimscroll({
	            height: (0, _jquery2.default)(window).height() - (0, _jquery2.default)(".main-header").height() + "px",
	            color: "rgba(0,0,0,0.2)",
	            size: "3px"
	          });
	        }
	      }
	    }
	  };
	
	  _jquery2.default.AdminLTE.pushMenu = {
	    activate: function activate(toggleBtn) {
	      var screenSizes = _jquery2.default.AdminLTE.options.screenSizes;
	
	      (0, _jquery2.default)(document).on('click', toggleBtn, function (e) {
	        e.preventDefault();
	
	        if ((0, _jquery2.default)(window).width() > screenSizes.sm - 1) {
	          if ((0, _jquery2.default)("body").hasClass('sidebar-collapse')) {
	            (0, _jquery2.default)("body").removeClass('sidebar-collapse').trigger('expanded.pushMenu');
	          } else {
	            (0, _jquery2.default)("body").addClass('sidebar-collapse').trigger('collapsed.pushMenu');
	          }
	        } else {
	            if ((0, _jquery2.default)("body").hasClass('sidebar-open')) {
	              (0, _jquery2.default)("body").removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
	            } else {
	              (0, _jquery2.default)("body").addClass('sidebar-open').trigger('expanded.pushMenu');
	            }
	          }
	      });
	
	      (0, _jquery2.default)(".content-wrapper").click(function () {
	        if ((0, _jquery2.default)(window).width() <= screenSizes.sm - 1 && (0, _jquery2.default)("body").hasClass("sidebar-open")) {
	          (0, _jquery2.default)("body").removeClass('sidebar-open');
	        }
	      });
	
	      if (_jquery2.default.AdminLTE.options.sidebarExpandOnHover || (0, _jquery2.default)('body').hasClass('fixed') && (0, _jquery2.default)('body').hasClass('sidebar-mini')) {
	        this.expandOnHover();
	      }
	    },
	    expandOnHover: function expandOnHover() {
	      var _this = this;
	      var screenWidth = _jquery2.default.AdminLTE.options.screenSizes.sm - 1;
	
	      (0, _jquery2.default)('.main-sidebar').hover(function () {
	        if ((0, _jquery2.default)('body').hasClass('sidebar-mini') && (0, _jquery2.default)("body").hasClass('sidebar-collapse') && (0, _jquery2.default)(window).width() > screenWidth) {
	          _this.expand();
	        }
	      }, function () {
	        if ((0, _jquery2.default)('body').hasClass('sidebar-mini') && (0, _jquery2.default)('body').hasClass('sidebar-expanded-on-hover') && (0, _jquery2.default)(window).width() > screenWidth) {
	          _this.collapse();
	        }
	      });
	    },
	    expand: function expand() {
	      (0, _jquery2.default)("body").removeClass('sidebar-collapse').addClass('sidebar-expanded-on-hover');
	    },
	    collapse: function collapse() {
	      if ((0, _jquery2.default)('body').hasClass('sidebar-expanded-on-hover')) {
	        (0, _jquery2.default)('body').removeClass('sidebar-expanded-on-hover').addClass('sidebar-collapse');
	      }
	    }
	  };
	
	  _jquery2.default.AdminLTE.tree = function (menu) {
	    var _this = this;
	    var animationSpeed = _jquery2.default.AdminLTE.options.animationSpeed;
	    (0, _jquery2.default)(document).off('click', menu + ' li a').on('click', menu + ' li a', function (e) {
	      var $this = (0, _jquery2.default)(this);
	      var checkElement = $this.next();
	
	      if (checkElement.is('.treeview-menu') && checkElement.is(':visible') && !(0, _jquery2.default)('body').hasClass('sidebar-collapse')) {
	        checkElement.slideUp(animationSpeed, function () {
	          checkElement.removeClass('menu-open');
	        });
	        checkElement.parent("li").removeClass("active");
	      } else if (checkElement.is('.treeview-menu') && !checkElement.is(':visible')) {
	          var parent = $this.parents('ul').first();
	
	          var ul = parent.find('ul:visible').slideUp(animationSpeed);
	
	          ul.removeClass('menu-open');
	
	          var parent_li = $this.parent("li");
	
	          checkElement.slideDown(animationSpeed, function () {
	            checkElement.addClass('menu-open');
	            parent.find('li.active').removeClass('active');
	            parent_li.addClass('active');
	
	            _this.layout.fix();
	          });
	        }
	
	      if (checkElement.is('.treeview-menu')) {
	        e.preventDefault();
	      }
	    });
	  };
	
	  _jquery2.default.AdminLTE.controlSidebar = {
	    activate: function activate() {
	      var _this = this;
	
	      var o = _jquery2.default.AdminLTE.options.controlSidebarOptions;
	
	      var sidebar = (0, _jquery2.default)(o.selector);
	
	      var btn = (0, _jquery2.default)(o.toggleBtnSelector);
	
	      btn.on('click', function (e) {
	        e.preventDefault();
	
	        if (!sidebar.hasClass('control-sidebar-open') && !(0, _jquery2.default)('body').hasClass('control-sidebar-open')) {
	          _this.open(sidebar, o.slide);
	        } else {
	          _this.close(sidebar, o.slide);
	        }
	      });
	
	      var bg = (0, _jquery2.default)(".control-sidebar-bg");
	      _this._fix(bg);
	
	      if ((0, _jquery2.default)('body').hasClass('fixed')) {
	        _this._fixForFixed(sidebar);
	      } else {
	        if ((0, _jquery2.default)('.content-wrapper, .right-side').height() < sidebar.height()) {
	          _this._fixForContent(sidebar);
	        }
	      }
	    },
	
	    open: function open(sidebar, slide) {
	      if (slide) {
	        sidebar.addClass('control-sidebar-open');
	      } else {
	        (0, _jquery2.default)('body').addClass('control-sidebar-open');
	      }
	    },
	
	    close: function close(sidebar, slide) {
	      if (slide) {
	        sidebar.removeClass('control-sidebar-open');
	      } else {
	        (0, _jquery2.default)('body').removeClass('control-sidebar-open');
	      }
	    },
	    _fix: function _fix(sidebar) {
	      var _this = this;
	      if ((0, _jquery2.default)("body").hasClass('layout-boxed')) {
	        sidebar.css('position', 'absolute');
	        sidebar.height((0, _jquery2.default)(".wrapper").height());
	        if (_this.hasBindedResize) {
	          return;
	        }
	        (0, _jquery2.default)(window).resize(function () {
	          _this._fix(sidebar);
	        });
	        _this.hasBindedResize = true;
	      } else {
	        sidebar.css({
	          'position': 'fixed',
	          'height': 'auto'
	        });
	      }
	    },
	    _fixForFixed: function _fixForFixed(sidebar) {
	      sidebar.css({
	        'position': 'fixed',
	        'max-height': '100%',
	        'overflow': 'auto',
	        'padding-bottom': '50px'
	      });
	    },
	    _fixForContent: function _fixForContent(sidebar) {
	      (0, _jquery2.default)(".content-wrapper, .right-side").css('min-height', sidebar.height());
	    }
	  };
	
	  _jquery2.default.AdminLTE.boxWidget = {
	    selectors: _jquery2.default.AdminLTE.options.boxWidgetOptions.boxWidgetSelectors,
	    icons: _jquery2.default.AdminLTE.options.boxWidgetOptions.boxWidgetIcons,
	    animationSpeed: _jquery2.default.AdminLTE.options.animationSpeed,
	    activate: function activate(_box) {
	      var _this = this;
	      if (!_box) {
	        _box = document;
	      }
	
	      (0, _jquery2.default)(_box).on('click', _this.selectors.collapse, function (e) {
	        e.preventDefault();
	        _this.collapse((0, _jquery2.default)(this));
	      });
	
	      (0, _jquery2.default)(_box).on('click', _this.selectors.remove, function (e) {
	        e.preventDefault();
	        _this.remove((0, _jquery2.default)(this));
	      });
	    },
	    collapse: function collapse(element) {
	      var _this = this;
	
	      var box = element.parents(".box").first();
	
	      var box_content = box.find("> .box-body, > .box-footer, > form  >.box-body, > form > .box-footer");
	      if (!box.hasClass("collapsed-box")) {
	        element.children(":first").removeClass(_this.icons.collapse).addClass(_this.icons.open);
	
	        box_content.slideUp(_this.animationSpeed, function () {
	          box.addClass("collapsed-box").trigger("close.collapseBox.panel");
	        });
	      } else {
	        element.children(":first").removeClass(_this.icons.open).addClass(_this.icons.collapse);
	
	        box_content.slideDown(_this.animationSpeed, function () {
	          box.removeClass("collapsed-box").trigger("open.collapseBox.panel");
	        });
	      }
	    },
	    remove: function remove(element) {
	      var box = element.parents(".box").first();
	      box.slideUp(this.animationSpeed);
	    }
	  };
	}
	
	(function ($) {
	
	  "use strict";
	
	  $.fn.boxRefresh = function (options) {
	    var settings = $.extend({
	      trigger: ".refresh-btn",
	
	      source: "",
	
	      onLoadStart: function onLoadStart(box) {
	        return box;
	      },
	      onLoadDone: function onLoadDone(box) {
	        return box;
	      } }, options);
	
	    var overlay = $('<div class="overlay"><div class="fa fa-refresh fa-spin"></div></div>');
	
	    return this.each(function () {
	      if (settings.source === "") {
	        if (window.console) {
	          window.console.log("Please specify a source first - boxRefresh()");
	        }
	        return;
	      }
	
	      var box = $(this);
	
	      var rBtn = box.find(settings.trigger).first();
	
	      rBtn.on('click', function (e) {
	        e.preventDefault();
	
	        start(box);
	
	        box.find(".box-body").load(settings.source, function () {
	          done(box);
	        });
	      });
	    });
	
	    function start(box) {
	      box.append(overlay);
	
	      settings.onLoadStart.call(box);
	    }
	
	    function done(box) {
	      box.find(overlay).remove();
	
	      settings.onLoadDone.call(box);
	    }
	  };
	})(jQuery);
	
	(function ($) {
	
	  'use strict';
	
	  $.fn.activateBox = function () {
	    $.AdminLTE.boxWidget.activate(this);
	  };
	
	  $.fn.toggleBox = function () {
	    var button = $($.AdminLTE.boxWidget.selectors.collapse, this);
	    $.AdminLTE.boxWidget.collapse(button);
	  };
	
	  $.fn.removeBox = function () {
	    var button = $($.AdminLTE.boxWidget.selectors.remove, this);
	    $.AdminLTE.boxWidget.remove(button);
	  };
	})(jQuery);
	
	(function ($) {
	
	  'use strict';
	
	  $.fn.todolist = function (options) {
	    var settings = $.extend({
	      onCheck: function onCheck(ele) {
	        return ele;
	      },
	
	      onUncheck: function onUncheck(ele) {
	        return ele;
	      }
	    }, options);
	
	    return this.each(function () {
	
	      if (typeof $.fn.iCheck != 'undefined') {
	        $('input', this).on('ifChecked', function () {
	          var ele = $(this).parents("li").first();
	          ele.toggleClass("done");
	          settings.onCheck.call(ele);
	        });
	
	        $('input', this).on('ifUnchecked', function () {
	          var ele = $(this).parents("li").first();
	          ele.toggleClass("done");
	          settings.onUncheck.call(ele);
	        });
	      } else {
	        $('input', this).on('change', function () {
	          var ele = $(this).parents("li").first();
	          ele.toggleClass("done");
	          if ($('input', ele).is(":checked")) {
	            settings.onCheck.call(ele);
	          } else {
	            settings.onUncheck.call(ele);
	          }
	        });
	      }
	    });
	  };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _this = {
	    phone: function phone(rule, value, callback) {
	        var errors = [],
	            length = value.length,
	            mobile = /^\d{11}$/,
	            tel = /^(0\d{3,4}-?)?\d{7,8}$/g;
	        if (!tel.test(value)) {
	            if (length == 11) {
	                if (!mobile.test(value)) errors.push(new Error("手机号码格式错误"));
	            } else {
	                errors.push(new Error("手机号码格式错误"));
	            }
	        }
	
	        callback(errors);
	    },
	    carNum: function carNum(rule, value, callback) {
	        var errors = [],
	            carNum = /^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新使]{1}[A-Za-z]{1}[0-9a-zA-Z]{5,6}$/;
	        if (!carNum.test(value)) {
	            if (value.length != 7 && value.length != 8) {
	                errors.push(new Error("车牌号格式有误"));
	            } else {
	                errors.push(new Error("车牌号格式有误(不能存在空格)"));
	            }
	        }
	        callback(errors);
	    },
	    carPrice: function carPrice(rule, value, callback) {
	        var errors = [];
	        console.log(value);
	        if (isNaN(Number(value))) {
	            errors.push("购车价格必须为数字");
	        }
	        callback(errors);
	    },
	    carVin: function carVin(rule, value, callback) {
	        var errors = [],
	            carNum = /^\S{17}$/;
	        if (!carNum.test(value)) {
	            if (value.length != 17) {
	                errors.push(new Error("车架号格式有误"));
	            } else {
	                errors.push(new Error("车架号格式有误(不能存在空格)"));
	            }
	        }
	        callback(errors);
	    },
	    idcard: function idcard(rule, value, callback) {
	        var errors = [],
	            idcard = /^\d{17}[\d|xX]$/,
	            sum = 0,
	            checkArr = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
	            fixArr = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2],
	            checked = false;
	        if (value.length == 18 && idcard.test(value)) {
	            for (var i = 0; i < checkArr.length; i++) {
	                sum += parseInt(value[i]) * checkArr[i];
	            }
	
	            checked = value.substr(-1).toUpperCase() == fixArr[sum % fixArr.length];
	        }
	        if (!checked) {
	            errors.push(new Error("无效的身份证号"));
	        }
	        callback(errors);
	    },
	    money: function money(rule, value, callback) {
	        var errors = [],
	            str = _jquery2.default.isNumeric() ? value.toFixed(2) : value,
	            regexp = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([0-9]){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
	        if (!regexp.test(value)) {
	            errors.push(new Error("金额格式错误"));
	        }
	        callback(errors);
	    },
	    contract: function contract(rule, value, callback) {
	        var error = [],
	            contract = /^(\w){4,19}$/;
	        if (!contract.test(value)) {
	            console.log('falsd');
	            error.push(new Error('合同编号格式错误'));
	        }
	        callback(error);
	    },
	    isnum: function isnum(rule, value, callback) {
	        var error = [],
	            contract = /^[0-9]*[1-9][0-9]*$/;
	        if (!contract.test(value)) {
	            console.log('falsd');
	            error.push(new Error('请输入数字'));
	        }
	        callback(error);
	    },
	    normalNorm: function normalNorm(rule, value, callback) {
	        var error = [],
	            contract = /^\w{6,}$/;
	        if (!contract.test(value)) {
	            console.log('falsd');
	            error.push(new Error('请输入至少六位由字母数字下划线组成的账号'));
	        }
	        callback(error);
	    },
	    checkAjaxStatus: function checkAjaxStatus(rule, value, callback) {
	        var errors = [],
	            f = parseFloat(value);
	        if (f <= 0) {
	            errors.push(new Error("成数太小"));
	            console.log("bbb");
	        } else if (f > 10) {
	            errors.push(new Error("成数太大"));
	            console.log("ccc");
	        }
	        callback(errors);
	    }
	};
	
	exports.default = _this;

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _homePage = __webpack_require__(1148);
	
	var _homePage2 = _interopRequireDefault(_homePage);
	
	var _waitTask = __webpack_require__(1131);
	
	var _waitTask2 = _interopRequireDefault(_waitTask);
	
	var _defaultPage = __webpack_require__(1140);
	
	var _defaultPage2 = _interopRequireDefault(_defaultPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defRoute = function defRoute(resolve) {
	    return __webpack_require__.e/* nsure */(102, function () {
	        return resolve(__webpack_require__(1132));
	    });
	},
	    versionPage = function versionPage(resolve) {
	    return __webpack_require__.e/* nsure */(78, function () {
	        return resolve(__webpack_require__(1139));
	    });
	},
	    rolePage = function rolePage(resolve) {
	    return __webpack_require__.e/* nsure */(79, function () {
	        return resolve(__webpack_require__(1138));
	    });
	},
	    userDeptPage = function userDeptPage(resolve) {
	    return __webpack_require__.e/* nsure */(38, function () {
	        return resolve(__webpack_require__(1135));
	    });
	},
	    departChargePage = function departChargePage(resolve) {
	    return __webpack_require__.e/* nsure */(82, function () {
	        return resolve(__webpack_require__(1133));
	    });
	},
	    managementPage = function managementPage(resolve) {
	    return __webpack_require__.e/* nsure */(80, function () {
	        return resolve(__webpack_require__(1137));
	    });
	},
	    userListPage = function userListPage(resolve) {
	    return __webpack_require__.e/* nsure */(41, function () {
	        return resolve(__webpack_require__(1136));
	    });
	},
	    infoPage = function infoPage(resolve) {
	    return __webpack_require__.e/* nsure */(92, function () {
	        return resolve(__webpack_require__(1190));
	    });
	},
	    gpsBrandPage = function gpsBrandPage(resolve) {
	    return __webpack_require__.e/* nsure */(96, function () {
	        return resolve(__webpack_require__(1146));
	    });
	},
	    gpsManagePage = function gpsManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(74, function () {
	        return resolve(__webpack_require__(1147));
	    });
	},
	    productsManagePage = function productsManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(94, function () {
	        return resolve(__webpack_require__(1153));
	    });
	},
	    productDetailPage = function productDetailPage(resolve) {
	    return __webpack_require__.e/* nsure */(36, function () {
	        return resolve(__webpack_require__(1152));
	    });
	},
	    productFlowPage = function productFlowPage(resolve) {
	    return __webpack_require__.e/* nsure */(77, function () {
	        return resolve(__webpack_require__(1143));
	    });
	},
	    productFlowDetailPage = function productFlowDetailPage(resolve) {
	    return __webpack_require__.e/* nsure */(37, function () {
	        return resolve(__webpack_require__(1141));
	    });
	},
	    productFlowTransPage = function productFlowTransPage(resolve) {
	    return __webpack_require__.e/* nsure */(75, function () {
	        return resolve(__webpack_require__(1145));
	    });
	},
	    carTaskTodoPage = function carTaskTodoPage(resolve) {
	    return !/* require.ensure */(function () {
	        return resolve(__webpack_require__(455));
	    }(__webpack_require__));
	},
	    carTaskTrace = function carTaskTrace(resolve) {
	    return __webpack_require__.e/* nsure */(83, function () {
	        return resolve(__webpack_require__(1130));
	    });
	},
	    carTaskDonePage = function carTaskDonePage(resolve) {
	    return __webpack_require__.e/* nsure */(84, function () {
	        return resolve(__webpack_require__(361));
	    });
	},
	    carDeptTodoPage = function carDeptTodoPage(resolve) {
	    return __webpack_require__.e/* nsure */(90, function () {
	        return resolve(__webpack_require__(1095));
	    });
	},
	    carDeptDonePage = function carDeptDonePage(resolve) {
	    return __webpack_require__.e/* nsure */(101, function () {
	        return resolve(__webpack_require__(1094));
	    });
	},
	    carOrderPage = function carOrderPage(resolve) {
	    return __webpack_require__.e/* nsure */(2, function () {
	        return resolve(__webpack_require__(1112));
	    });
	},
	    carViewPage = function carViewPage(resolve) {
	    return __webpack_require__.e/* nsure */(1, function () {
	        return resolve(__webpack_require__(1121));
	    });
	},
	    productTablePage = function productTablePage(resolve) {
	    return __webpack_require__.e/* nsure */(76, function () {
	        return resolve(__webpack_require__(1144));
	    });
	},
	    productFormPage = function productFormPage(resolve) {
	    return __webpack_require__.e/* nsure */(97, function () {
	        return resolve(__webpack_require__(1142));
	    });
	},
	    msgPage = function msgPage(resolve) {
	    return __webpack_require__.e/* nsure */(91, function () {
	        return resolve(__webpack_require__(1191));
	    });
	},
	    orderManagePage = function orderManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(22, function () {
	        return resolve(__webpack_require__(1113));
	    });
	},
	    orderExportPage = function orderExportPage(resolve) {
	    return __webpack_require__.e/* nsure */(23, function () {
	        return resolve(__webpack_require__(1110));
	    });
	},
	    orderSettlePage = function orderSettlePage(resolve) {
	    return __webpack_require__.e/* nsure */(20, function () {
	        return resolve(__webpack_require__(1118));
	    });
	},
	    orderRefundPage = function orderRefundPage(resolve) {
	    return __webpack_require__.e/* nsure */(21, function () {
	        return resolve(__webpack_require__(1114));
	    });
	},
	    orderChargePage = function orderChargePage(resolve) {
	    return __webpack_require__.e/* nsure */(24, function () {
	        return resolve(__webpack_require__(1105));
	    });
	},
	    orderVindicatePage = function orderVindicatePage(resolve) {
	    return __webpack_require__.e/* nsure */(5, function () {
	        return resolve(__webpack_require__(1122));
	    });
	},
	    carModelManagePage = function carModelManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(99, function () {
	        return resolve(__webpack_require__(1102));
	    });
	},
	    carManagePage = function carManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(88, function () {
	        return resolve(__webpack_require__(1100));
	    });
	},
	    carPositionPage = function carPositionPage(resolve) {
	    return __webpack_require__.e/* nsure */(86, function () {
	        return resolve(__webpack_require__(1103));
	    });
	},
	    carGpsManagePage = function carGpsManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(87, function () {
	        return resolve(__webpack_require__(1101));
	    });
	},
	    carBrandManagePage = function carBrandManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(100, function () {
	        return resolve(__webpack_require__(1099));
	    });
	},
	    carSeriesManagePage = function carSeriesManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(98, function () {
	        return resolve(__webpack_require__(1104));
	    });
	},
	    fastDebitCustomerPage = function fastDebitCustomerPage(resolve) {
	    return __webpack_require__.e/* nsure */(40, function () {
	        return resolve(__webpack_require__(1157));
	    });
	},
	    fastDebitformalCustomerPage = function fastDebitformalCustomerPage(resolve) {
	    return __webpack_require__.e/* nsure */(71, function () {
	        return resolve(__webpack_require__(1158));
	    });
	},
	    fastDebitChannelPage = function fastDebitChannelPage(resolve) {
	    return __webpack_require__.e/* nsure */(34, function () {
	        return resolve(__webpack_require__(1156));
	    });
	},
	    productCapitalPage = function productCapitalPage(resolve) {
	    return __webpack_require__.e/* nsure */(95, function () {
	        return resolve(__webpack_require__(1151));
	    });
	},
	    MenuDistributePage = function MenuDistributePage(resolve) {
	    return __webpack_require__.e/* nsure */(73, function () {
	        return resolve(__webpack_require__(1149));
	    });
	},
	    MenuManagePage = function MenuManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(72, function () {
	        return resolve(__webpack_require__(1150));
	    });
	},
	    loanTable = function loanTable(resolve) {
	    return __webpack_require__.e/* nsure */(50, function () {
	        return resolve(__webpack_require__(1167));
	    });
	},
	    repaymentMoney = function repaymentMoney(resolve) {
	    return __webpack_require__.e/* nsure */(32, function () {
	        return resolve(__webpack_require__(1176));
	    });
	},
	    orderRepayPage = function orderRepayPage(resolve) {
	    return __webpack_require__.e/* nsure */(85, function () {
	        return resolve(__webpack_require__(1117));
	    });
	},
	    orderImport = function orderImport(resolve) {
	    return __webpack_require__.e/* nsure */(42, function () {
	        return resolve(__webpack_require__(1111));
	    });
	},
	    operLogPage = function operLogPage(resolve) {
	    return __webpack_require__.e/* nsure */(58, function () {
	        return resolve(__webpack_require__(1179));
	    });
	},
	    jcLoanPage = function jcLoanPage(resolve) {
	    return __webpack_require__.e/* nsure */(69, function () {
	        return resolve(__webpack_require__(1162));
	    });
	},
	    jcRepayPage = function jcRepayPage(resolve) {
	    return __webpack_require__.e/* nsure */(68, function () {
	        return resolve(__webpack_require__(1163));
	    });
	},
	    flowNode = function flowNode(resolve) {
	    return __webpack_require__.e/* nsure */(89, function () {
	        return resolve(__webpack_require__(120));
	    });
	},
	    loanDetailPage = function loanDetailPage(resolve) {
	    return __webpack_require__.e/* nsure */(51, function () {
	        return resolve(__webpack_require__(1166));
	    });
	},
	    repayDetailPage = function repayDetailPage(resolve) {
	    return __webpack_require__.e/* nsure */(48, function () {
	        return resolve(__webpack_require__(1175));
	    });
	},
	    repayCheckPage = function repayCheckPage(resolve) {
	    return __webpack_require__.e/* nsure */(49, function () {
	        return resolve(__webpack_require__(1174));
	    });
	},
	    earlySettle = function earlySettle(resolve) {
	    return __webpack_require__.e/* nsure */(33, function () {
	        return resolve(__webpack_require__(70));
	    });
	},
	    earlySettleForm = function earlySettleForm(resolve) {
	    return __webpack_require__.e/* nsure */(28, function () {
	        return resolve(__webpack_require__(1161));
	    });
	},
	    chargeForm = function chargeForm(resolve) {
	    return __webpack_require__.e/* nsure */(39, function () {
	        return resolve(__webpack_require__(1160));
	    });
	},
	    refundForm = function refundForm(resolve) {
	    return __webpack_require__.e/* nsure */(30, function () {
	        return resolve(__webpack_require__(1171));
	    });
	},
	    bankList = function bankList(resolve) {
	    return __webpack_require__.e/* nsure */(70, function () {
	        return resolve(__webpack_require__(1159));
	    });
	},
	    juxinliList = function juxinliList(resolve) {
	    return __webpack_require__.e/* nsure */(67, function () {
	        return resolve(__webpack_require__(1164));
	    });
	},
	    jxlbeeList = function jxlbeeList(resolve) {
	    return __webpack_require__.e/* nsure */(66, function () {
	        return resolve(__webpack_require__(1165));
	    });
	},
	    tongdunList = function tongdunList(resolve) {
	    return __webpack_require__.e/* nsure */(60, function () {
	        return resolve(__webpack_require__(1177));
	    });
	},
	    resourceList = function resourceList(resolve) {
	    return __webpack_require__.e/* nsure */(35, function () {
	        return resolve(__webpack_require__(1155));
	    });
	},
	    msgRecord = function msgRecord(resolve) {
	    return __webpack_require__.e/* nsure */(59, function () {
	        return resolve(__webpack_require__(1178));
	    });
	},
	    chesanbaiList = function chesanbaiList(resolve) {
	    return __webpack_require__.e/* nsure */(55, function () {
	        return resolve(__webpack_require__(1187));
	    });
	},
	    jinzhenguList = function jinzhenguList(resolve) {
	    return __webpack_require__.e/* nsure */(54, function () {
	        return resolve(__webpack_require__(1188));
	    });
	},
	    achievementsCount = function achievementsCount(resolve) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return resolve(__webpack_require__(1181));
	    });
	},
	    rankingList = function rankingList(resolve) {
	    return __webpack_require__.e/* nsure */(56, function () {
	        return resolve(__webpack_require__(1183));
	    });
	},
	    thirdManage = function thirdManage(resolve) {
	    return __webpack_require__.e/* nsure */(53, function () {
	        return resolve(__webpack_require__(1189));
	    });
	},
	    settleApply = function settleApply(resolve) {
	    return __webpack_require__.e/* nsure */(29, function () {
	        return resolve(__webpack_require__(181));
	    });
	},
	    chargeApply = function chargeApply(resolve) {
	    return __webpack_require__.e/* nsure */(65, function () {
	        return resolve(__webpack_require__(177));
	    });
	},
	    chargeCheck = function chargeCheck(resolve) {
	    return __webpack_require__.e/* nsure */(47, function () {
	        return resolve(__webpack_require__(178));
	    });
	},
	    chargeDetail = function chargeDetail(resolve) {
	    return __webpack_require__.e/* nsure */(46, function () {
	        return resolve(__webpack_require__(1168));
	    });
	},
	    refundApply = function refundApply(resolve) {
	    return __webpack_require__.e/* nsure */(44, function () {
	        return resolve(__webpack_require__(179));
	    });
	},
	    refundCheck = function refundCheck(resolve) {
	    return __webpack_require__.e/* nsure */(93, function () {
	        return resolve(__webpack_require__(180));
	    });
	},
	    refundDetail = function refundDetail(resolve) {
	    return __webpack_require__.e/* nsure */(45, function () {
	        return resolve(__webpack_require__(1169));
	    });
	},
	    settleDetail = function settleDetail(resolve) {
	    return __webpack_require__.e/* nsure */(31, function () {
	        return resolve(__webpack_require__(1170));
	    });
	},
	    settleCheck = function settleCheck(resolve) {
	    return __webpack_require__.e/* nsure */(64, function () {
	        return resolve(__webpack_require__(182));
	    });
	},
	    chargeFlow = function chargeFlow(resolve) {
	    return __webpack_require__.e/* nsure */(27, function () {
	        return resolve(__webpack_require__(1106));
	    });
	},
	    chargeView = function chargeView(resolve) {
	    return __webpack_require__.e/* nsure */(26, function () {
	        return resolve(__webpack_require__(1107));
	    });
	},
	    settleFlow = function settleFlow(resolve) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return resolve(__webpack_require__(1119));
	    });
	},
	    refundFlow = function refundFlow(resolve) {
	    return __webpack_require__.e/* nsure */(10, function () {
	        return resolve(__webpack_require__(1115));
	    });
	},
	    settleView = function settleView(resolve) {
	    return __webpack_require__.e/* nsure */(3, function () {
	        return resolve(__webpack_require__(1120));
	    });
	},
	    refundView = function refundView(resolve) {
	    return __webpack_require__.e/* nsure */(9, function () {
	        return resolve(__webpack_require__(1116));
	    });
	},
	    finishTask = function finishTask(resolve) {
	    return __webpack_require__.e/* nsure */(25, function () {
	        return resolve(__webpack_require__(1125));
	    });
	},
	    settleGps = function settleGps(resolve) {
	    return __webpack_require__.e/* nsure */(63, function () {
	        return resolve(__webpack_require__(183));
	    });
	},
	    bidManagePage = function bidManagePage(resolve) {
	    return __webpack_require__.e/* nsure */(52, function () {
	        return resolve(__webpack_require__(1093));
	    });
	},
	    repayBatchCheck = function repayBatchCheck(resolve) {
	    return __webpack_require__.e/* nsure */(61, function () {
	        return resolve(__webpack_require__(1173));
	    });
	},
	    repayBatchApply = function repayBatchApply(resolve) {
	    return __webpack_require__.e/* nsure */(62, function () {
	        return resolve(__webpack_require__(1172));
	    });
	},
	    orderDataExportPage = function orderDataExportPage(resolve) {
	    return __webpack_require__.e/* nsure */(43, function () {
	        return resolve(__webpack_require__(1182));
	    });
	},
	    systemConfiguration = function systemConfiguration(resolve) {
	    return __webpack_require__.e/* nsure */(81, function () {
	        return resolve(__webpack_require__(1134));
	    });
	},
	    systemlogPage = function systemlogPage(resolve) {
	    return __webpack_require__.e/* nsure */(57, function () {
	        return resolve(__webpack_require__(1180));
	    });
	};
	
	var merchant = function merchant(resolve) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return resolve(__webpack_require__(1085));
	    });
	},
	    merchantConf = function merchantConf(resolve) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return resolve(__webpack_require__(1086));
	    });
	},
	    creditRecord = function creditRecord(resolve) {
	    return __webpack_require__.e/* nsure */(7, function () {
	        return resolve(__webpack_require__(1082));
	    });
	},
	    propertyDetail = function propertyDetail(resolve) {
	    return __webpack_require__.e/* nsure */(16, function () {
	        return resolve(__webpack_require__(1088));
	    });
	},
	    finance = function finance(resolve) {
	    return __webpack_require__.e/* nsure */(18, function () {
	        return resolve(__webpack_require__(1083));
	    });
	},
	    potentialCus = function potentialCus(resolve) {
	    return __webpack_require__.e/* nsure */(17, function () {
	        return resolve(__webpack_require__(1087));
	    });
	},
	    jxSearchRecord = function jxSearchRecord(resolve) {
	    return __webpack_require__.e/* nsure */(14, function () {
	        return resolve(__webpack_require__(1092));
	    });
	},
	    zwSearchRecord = function zwSearchRecord(resolve) {
	    return __webpack_require__.e/* nsure */(11, function () {
	        return resolve(__webpack_require__(1194));
	    });
	},
	    httSearchRecord = function httSearchRecord(resolve) {
	    return __webpack_require__.e/* nsure */(15, function () {
	        return resolve(__webpack_require__(1091));
	    });
	},
	    sxjxSearchRecord = function sxjxSearchRecord(resolve) {
	    return __webpack_require__.e/* nsure */(13, function () {
	        return resolve(__webpack_require__(1192));
	    });
	},
	    searchRecord = function searchRecord(resolve) {
	    return __webpack_require__.e/* nsure */(12, function () {
	        return resolve(__webpack_require__(1193));
	    });
	},
	    asignContract = function asignContract(resolve) {
	    return __webpack_require__.e/* nsure */(19, function () {
	        return resolve(__webpack_require__(1080));
	    });
	};
	
	exports.default = [{ path: '/system/update', component: versionPage, name: "admin_update" }, { path: '/user/role', component: rolePage, name: "admin_role" }, { path: '/user/list', component: userListPage, name: "admin_list" }, { path: '/user/department', component: userDeptPage, name: "admin_department" }, { path: '/user/info', component: infoPage, name: "car_user_info" }, { path: '/user/msg', component: msgPage, name: "car_user_msg" }, { path: '/inventory/brand', component: gpsBrandPage, name: "admin_gps_brand" }, { path: '/inventory/manage', component: gpsManagePage, name: "admin_gps_manage" }, { path: '/products/manage', component: productsManagePage, name: "admin_products_manage" }, { path: '/products/detail/:id', component: productDetailPage, name: "admin_products_detail" }, { path: '/products/flow', component: productFlowPage, name: "admin_products_flow" }, { path: '/products/flow/detail/:id', component: productFlowDetailPage, name: "admin_products_flowDetail" }, { path: '/products/flow/trans/:id', component: productFlowTransPage, name: "admin_products_flowTransition" }, { path: '/products/table', component: productTablePage, name: "admin_products_table" }, { path: '/products/form', component: productFormPage, name: "admin_products_form" }, { path: '/user/taskTodo', component: _waitTask2.default, name: "car_user_todo" }, { path: '/user/taskList', component: finishTask, name: "car_user_task" }, { path: '/user/taskTrace', component: carTaskTrace, name: "car_user_taskTrace" }, { path: '/department/taskTodo', component: carDeptTodoPage, name: "car_department_todo" }, { path: '/department/taskDone', component: carDeptDonePage, name: "car_department_done" }, { path: '/car/order/:id/:node', component: carOrderPage, name: "car_order_page" }, { path: '/car/view/:id/:node', component: carViewPage, name: "car_view_page" }, { path: '/car/view/:id', component: carViewPage, name: "order_view_page" }, { path: '/car/vindicate/:id/:vindicate', component: carViewPage, name: "order_vindicate" }, { path: '/datacenter/order/query', component: orderManagePage, name: "car_order_manage" }, { path: '/datacenter/order/export', component: orderExportPage, name: "car_order_export" }, { path: '/datacenter/order/settle', component: orderSettlePage, name: "car_order_settle" }, { path: '/datacenter/order/refund', component: orderRefundPage, name: "car_order_refund" }, { path: '/datacenter/order/charge', component: orderChargePage, name: "car_order_charge" }, { path: '/datacenter/order/vindicate', component: orderVindicatePage, name: "car_order_vindicate" }, { path: '/datacenter/carmodel', component: carModelManagePage, name: "car_model_manage" }, { path: '/datacenter/carposition', component: carPositionPage, name: "car_position" }, { path: '/datacenter/carposition/:license_plate', component: carPositionPage, name: "car_position" }, { path: '/datacenter/car', component: carManagePage, name: "order_car_manage" }, { path: '/datacenter/cargps/:id/:sn', component: carGpsManagePage, name: "car_gps_manage" }, { path: '/datacenter/carmodel/:id', component: carBrandManagePage, name: "car_brand_manage" }, { path: '/datacenter/carmodel/:bid/:id', component: carSeriesManagePage, name: "car_series_manage" }, { path: '/csd/customer', component: fastDebitCustomerPage, name: "csd_customer_manage" }, { path: '/csd/formalCustomer', component: fastDebitformalCustomerPage, name: "csd_formalCustomer_manage" }, { path: '/csd/channel', component: fastDebitChannelPage, name: "csd_channel_manage" }, { path: '/products/capital', component: productCapitalPage, name: "admin_channel_capital" }, { path: '/menu/distribute/:id', component: MenuDistributePage, name: "admin_menu_distribute" }, { path: '/menu/manage/', component: MenuManagePage, name: "admin_menu_manage" }, { path: '*', component: defRoute, name: "404page" }, { path: '/financial/loanflow', component: loanTable, name: 'loanTable' }, { path: '/financial/repayflow', component: repaymentMoney, name: 'repaymentMoney' }, { path: '/order/repay/:id', component: orderRepayPage, name: 'car_order_repay' }, { path: '/datacenter/import', component: orderImport, name: 'orderImport' }, { path: '/user/charge', component: departChargePage, name: "admin_depart_charge" }, { path: '/user/management', component: managementPage, name: "admin_depart_management" }, { path: '/log/operlog', component: operLogPage, name: 'operation_log' }, { path: '/finance/jcloan', component: jcLoanPage, name: 'car_jcloan_list' }, { path: '/finance/jcrepay', component: jcRepayPage, name: 'car_jcrepay_list' }, { path: '/order/flownode', component: flowNode, name: 'order_flowNode' }, { path: '/finance/loanDetail/:id', component: loanDetailPage, name: 'car_loan_detail' }, { path: '/finance/repayDetail/:id/:period', component: repayDetailPage, name: 'car_repay_detail' }, { path: '/finance/repayCheck/:id/:period', component: repayCheckPage, name: 'car_repay_check' }, { path: '/order/earlySettle/:id', component: earlySettle, name: 'order_earlySettle' }, { path: '/finance/earlySettle', component: earlySettleForm, name: 'finance_earlySettle' }, { path: '/finance/chargeForm', component: chargeForm, name: "finance_chargeForm" }, { path: '/finance/chargeForm/:id', component: chargeForm, name: "finance_chargeForm" }, { path: '/finance/refundForm', component: refundForm, name: "finance_refundList" }, { path: '/finance/refundForm/:id', component: refundForm, name: "finance_refundForm" }, { path: '/finance/bankList', component: bankList, name: "bank_list" }, { path: '/finance/juxinliList', component: juxinliList, name: "juxinli_list" }, { path: '/finance/jxlbeeList', component: jxlbeeList, name: "jxlbee_list" }, { path: '/finance/tongdunList', component: tongdunList, name: "tongdun_list" }, { path: '/resource/resource', component: resourceList, name: "admin_resc" }, { path: '/log/msgrecord', component: msgRecord, name: "send_msg_record" }, { path: '/thirdWater/chesanbai', component: chesanbaiList, name: "chesanbai_list" }, { path: '/thirdWater/jinzhengu', component: jinzhenguList, name: "jinzhengu_list" }, { path: '/statistics/achievementsCount', component: achievementsCount, name: "statistics_achievementsCount" }, { path: '/statistics/rankingList', component: rankingList, name: "statistics_rankingList" }, { path: '/thirdWater/thirdManage', component: thirdManage, name: "third_manage" }, { path: '/finance/settleApply/:id', component: settleApply, name: 'finance_settleApply' }, { path: '/finance/chargeApply/:id', component: chargeApply, name: 'finance_chargeApply' }, { path: '/finance/chargeCheck', component: chargeCheck, name: 'finance_chargeCheck' }, { path: '/finance/chargeDetail', component: chargeDetail, name: 'finance_chargeDetail' }, { path: '/finance/refundApply/:id', component: refundApply, name: 'finance_refundApply' }, { path: '/finance/refundCheck', component: refundCheck, name: 'finance_refundCheck' }, { path: '/finance/refundDetail', component: refundDetail, name: 'finance_refundDetail' }, { path: '/finance/settleCheck', component: settleCheck, name: 'finance_settleCheck' }, { path: '/finance/settleDetail', component: settleDetail, name: 'finance_settleDetail' }, { path: '/task/waitTask', component: _waitTask2.default, name: 'task_waitTask' }, { path: '/order/chargeFlow/:id/:node', component: chargeFlow, name: 'order_chargeFlow' }, { path: '/order/settleFlow/:id/:node/:group', component: settleFlow, name: 'order_settleFlow' }, { path: '/order/settleView/:id/:group', component: settleView, name: 'order_settleView' }, { path: '/order/refundFlow/:id/:node/:group', component: refundFlow, name: 'order_refundFlow' }, { path: '/order/refundView/:id/:group', component: refundView, name: 'order_refundView' }, { path: '/order/chargeView/:id/:group', component: chargeView, name: 'order_chargeView' }, { path: '/repay/batchCheck', component: repayBatchCheck, name: 'repay_batch_check' }, { path: '/chedai/repay/batchApply', component: repayBatchApply, name: 'repay_batch_Apply' }, { path: '/settleGps', component: settleGps, name: 'settle_gps' }, { path: '/bid/manage', component: bidManagePage, name: 'order_bid_manage' }, { path: '/homePage', component: _homePage2.default, name: 'homePage' }, {
	    path: '/chedai/csd/formalCustomer',
	    component: fastDebitformalCustomerPage,
	    name: "chedai_csd_formalCustomer_manage"
	}, { path: '/chedai/csd/customer', component: fastDebitCustomerPage, name: "chedai_csd_customer_manage" }, { path: '/chedai/csd/channel', component: fastDebitChannelPage, name: "chedai_csd_channel_manage" }, { path: '/chedai/finance/juxinliList', component: juxinliList, name: "chedai_juxinli_list" }, { path: '/chedai/finance/tongdunList', component: tongdunList, name: "chedai_tongdun_list" }, { path: '/chedai/finance/jxlbeeList', component: jxlbeeList, name: "chedai_jxlbee_list" }, { path: '/chedai/taskTodo', component: _waitTask2.default, name: "chedai_user_todo" }, { path: '/chedai/taskList', component: finishTask, name: "chedai_user_task" }, { path: '/chedai/datacenter/order/query', component: orderManagePage, name: "chedai_car_order_manage" }, { path: '/chedai/datacenter/import', component: orderImport, name: 'chedai_orderImport' }, { path: '/chedai/datacenter/order/export', component: orderExportPage, name: "chedai_car_order_export" }, { path: '/chedai/datacenter/order/settle', component: orderSettlePage, name: "chedai_car_order_settle" }, { path: '/chedai/datacenter/order/refund', component: orderRefundPage, name: "chedai_car_order_refund" }, { path: '/chedai/datacenter/order/vindicate', component: orderVindicatePage, name: "chedai_car_order_vindicate" }, { path: '/chedai/bid/manage', component: bidManagePage, name: 'chedai_order_bid_manage' }, { path: '/chedai/datacenter/order/charge', component: orderChargePage, name: "chedai_car_order_charge" }, { path: '/chedai/financial/repayflow', component: repaymentMoney, name: 'chedai_repaymentMoney' }, { path: '/chedai/financial/loanflow', component: loanTable, name: 'chedai_loanTable' }, { path: '/chedai/finance/bankList', component: bankList, name: "chedai_bank_list" }, { path: '/chedai/finance/jcloan', component: jcLoanPage, name: 'chedai_car_jcloan_list' }, { path: '/chedai/finance/jcrepay', component: jcRepayPage, name: 'chedai_car_jcrepay_list' }, { path: '/chedai/repay/batchCheck', component: repayBatchCheck, name: 'chedai_repay_batch_check' }, { path: '/chedai/user/info', component: infoPage, name: "chedai_car_user_info" }, { path: '/chedai/user/msg', component: msgPage, name: "chedai_car_user_msg" }, { path: '/chedai/user/taskTrace', component: carTaskTrace, name: "chedai_car_user_taskTrace" }, { path: '/system/inventory/brand', component: gpsBrandPage, name: "chedai_admin_gps_brand" }, { path: '/system/inventory/manage', component: gpsManagePage, name: "chedai_admin_gps_manage" }, { path: '/system/products/flow', component: productFlowPage, name: "chedai_admin_products_flow" }, { path: '/system/products/form', component: productFormPage, name: "chedai_admin_products_form" }, { path: '/system/products/table', component: productTablePage, name: "chedai_admin_products_table" }, { path: '/system/log/operlog', component: operLogPage, name: 'chedai_operation_log' }, { path: '/system/resource/resource', component: resourceList, name: "chedai_admin_resc" }, { path: '/system/log/msgrecord', component: msgRecord, name: "chedai_send_msg_record" }, { path: '/system/thirdWater/thirdManage', component: thirdManage, name: "chedai_third_manage" }, { path: '/system/user/department', component: userDeptPage, name: "chedai_admin_department" }, { path: '/system/user/list', component: userListPage, name: "chedai_admin_list" }, { path: '/system/user/role', component: rolePage, name: "chedai_admin_role" }, { path: '/system/menu/distribute/:id', component: MenuDistributePage, name: "chedai_admin_menu_distribute" }, { path: '/system/menu/manage/', component: MenuManagePage, name: "chedai_admin_menu_manage" }, { path: '/system/user/charge', component: departChargePage, name: "chedai_admin_depart_charge" }, { path: '/system/user/management', component: managementPage, name: "chedai_admin_depart_management" }, { path: '/system/products/manage', component: productsManagePage, name: "chedai_admin_products_manage" }, { path: '/system/products/capital', component: productCapitalPage, name: "chedai_admin_channel_capital" }, {
	    path: '/system/statistics/achievementsCount',
	    component: achievementsCount,
	    name: "chedai_statistics_achievementsCount"
	}, { path: '/system/statistics/rankingList', component: rankingList, name: "chedai_statistics_rankingList" }, { path: '/system/datacenter/carmodel', component: carModelManagePage, name: "chedai_car_model_manage" }, { path: '/system/datacenter/carmodel/:id', component: carBrandManagePage, name: "chedai_car_brand_manage" }, { path: '/system/datacenter/carmodel/:bid/:id', component: carSeriesManagePage, name: "chedai_car_series_manage" }, { path: '/system/datacenter/car', component: carManagePage, name: "chedai_order_car_manage" }, { path: '/system/datacenter/cargps/:id/:sn', component: carGpsManagePage, name: "chedai_car_gps_manage" }, { path: '/system/thirdWater/chesanbai', component: chesanbaiList, name: "chedai_chesanbai_list" }, { path: '/system/thirdWater/jinzhengu', component: jinzhenguList, name: "chedai_jinzhengu_list" }, { path: '/system/products/detail/:id', component: productDetailPage, name: "chedai_admin_products_detail" }, { path: '/system/statistics/dataExport', component: orderDataExportPage, name: "chedai_dataExport" }, { path: '/system/update/1', component: _defaultPage2.default, name: "chedai_admin_update" }, { path: '/homePage/system', component: _homePage2.default, name: 'chedai_homePage' }, { path: '/system/products/flow/detail/:id', component: productFlowDetailPage, name: "chedai_products_flowDetail" }, { path: '/system/products/flow/trans/:id', component: productFlowTransPage, name: "chedai_products_flowTransition" }, { path: '/system/admin/configuration', component: systemConfiguration, name: "chedai_configuration" }, { path: '/system/log/systemlog', component: systemlogPage, name: 'chedai_system_log' }, { path: '/hcd/index', component: merchant, name: 'hcd_merchant' }, { path: '/hcd/config', component: merchantConf, name: 'hcd_merchant_conf' }, { path: '/hcd/creditRecord', component: creditRecord, name: 'hcd_merchant_credit_record' }, { path: '/hcd/finance', component: finance, name: 'hcd_finance' }, { path: '/hcd/propertyDetail', component: propertyDetail, name: 'hcd_property_detail' }, { path: '/hcd/potentialCus/:buss_type', component: potentialCus, name: 'hcd_potential_cus', props: true }, { path: '/yinhai/searchRecord', component: searchRecord, name: 'yinhai_search_record' }, { path: '/hcd/asignContract', component: asignContract, name: 'hcd_asign_contract' }, { path: '/jx/searchRecord', component: jxSearchRecord, name: 'junxin_search_record' }, { path: '/zw/searchRecord', component: zwSearchRecord, name: 'zhongwei_search_record' }, { path: '/htt/searchRecord', component: httSearchRecord, name: 'huatongtai_search_record' }, { path: '/sxjx/searchRecord', component: sxjxSearchRecord, name: 'shanxijingxie_search_record' }];

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 955:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 957:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 967:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 976:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 982:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

	module.exports = {"version":"1.2.20171120","verInfo":"1.2.0","testdate":"2017112015","api":"/web","upload":"/ImageApi.php","download":"/downLoad.php","checkTimer":60,"thirdUrl":"http://localhost:6680"}

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

	module.exports = {"_/cities/props":{"label":"name","value":"id","children":"childrens"},"_/default/table/privilege":[{"name":"无权限","value":0,"disabled":true},{"name":"读权限","value":1},{"name":"写权限","value":2,"disabled":true},{"name":"读写权限","value":3}],"_/default/sex":[{"name":"男","value":1},{"name":"女","value":2}],"_/default/CoopProperty":[{"id":1,"name":"配偶"},{"id":2,"name":"父母"},{"id":4,"name":"朋友"},{"id":6,"name":"子女"},{"id":5,"name":"其他"}],"_/default/CoopPropertyView":[{"id":1,"name":"配偶"},{"id":2,"name":"父母"},{"id":3,"name":"亲属","disabled":true},{"id":4,"name":"朋友"},{"id":5,"name":"其他"},{"id":6,"name":"子女"}],"_/default/marry":[{"name":"未婚","value":1},{"name":"已婚","value":2},{"name":"离婚","value":3}],"_/default/CoopMarry":[{"name":"未婚","value":1},{"name":"已婚","value":2},{"name":"离异后未婚","value":4},{"name":"丧偶后未婚","value":5}],"_/default/CoopMarryView":[{"name":"未婚","value":1},{"name":"已婚","value":2},{"name":"离婚","value":3,"disabled":true},{"name":"离异后未婚","value":4},{"name":"丧偶后未婚","value":5}],"_/default/education":[{"name":"小学","value":1},{"name":"初中","value":2},{"name":"技校","value":3},{"name":"高中","value":4},{"name":"大专","value":5},{"name":"本科及以上","value":6},{"name":"其他","value":7}],"_/default/liveYear":[{"name":"一年以下","value":1},{"name":"一年以上","value":2}],"_/default/create/orderType":[{"name":"新增订单","value":1}],"_/default/create/carLoadType":[{"name":"全款估价","value":1},{"name":"按揭估价","value":2}],"_/default/work/companyType":["有限责任公司","个体户","私营企业","合伙制企业","股份有限公司","组织/机关","国有企业"],"_/default/work/income":[{"name":"无收入","value":"0"},{"name":"1-5000元","value":"1"},{"name":"5001-10000元","value":"2"},{"name":"10001-15000元","value":"3"},{"name":"15001-20000元","value":"4"},{"name":"20000元以上","value":"5"}],"_/default/work/checkbox":[{"name":"无","value":"no"},{"name":"有","value":"yes"}],"_/default/work/employeeNum":[{"name":"未知","value":"1"},{"name":"0-50人","value":"2"},{"name":"51-100人","value":"3"},{"name":"101-150人","value":"4"},{"name":"150人以上","value":"5"}],"_/default/work/jobType":[{"value":"1","name":"国家机关、党群组织、企业、事业单位负责人"},{"value":"2","name":"专业技术人员"},{"value":"3","name":"办事人员和有关人员"},{"value":"4","name":"商业、服务业人员"},{"value":"5","name":"农、林、牧、渔、水利业生产人员"},{"value":"6","name":"生产、运输设备操作人员及有关人员"},{"value":"7","name":"其他"}],"_/default/work/department":[{"value":"1","name":"技术部"},{"value":"2","name":"财务部"},{"value":"3","name":"人力资源部"},{"value":"4","name":"市场部"},{"value":"5","name":"行政部"},{"value":"6","name":"销售部"},{"value":"7","name":"总经理办公室"},{"value":"8","name":"生产部"},{"value":"9","name":"项目部"},{"value":"10","name":"工程部"},{"value":"11","name":"监督保障部"},{"value":"12","name":"运营部"},{"value":"13","name":"后勤部"},{"value":"14","name":"安保"},{"value":"15","name":"采购部"},{"value":"16","name":"营业部"},{"value":"17","name":"其他部门"}],"_/default/work/mainBusiness":[{"value":"1","name":"农、林、牧、渔业"},{"value":"2","name":"采掘业"},{"value":"3","name":"制造业"},{"value":"4","name":"电力、燃气及水的生产和供应业"},{"value":"5","name":"建筑业"},{"value":"6","name":"交通运输、仓储和邮政业"},{"value":"7","name":"信息传输、计算机服务和软件业"},{"value":"8","name":"批发和零售业"},{"value":"9","name":"住宿和餐饮业"},{"value":"10","name":"金融业"},{"value":"11","name":"房地产业"},{"value":"12","name":"租赁和商务服务业"},{"value":"13","name":"科学研究、技术服务业和地质勘察业"},{"value":"14","name":"水利、环境和公共设施管理业"},{"value":"15","name":"居民服务和其他服务业"},{"value":"16","name":"教育"},{"value":"17","name":"卫生、社会保障和社会福利业"},{"value":"18","name":"文化、体育和娱乐业"},{"value":"19","name":"公共管理和社会组织"},{"value":"20","name":"国际组织"},{"value":"21","name":"未知"}],"_/default/house/propertyType":[{"value":"1","name":"本人产权"},{"value":"2","name":"配偶产权"},{"value":"3","name":"夫妻共有产权"},{"value":"4","name":"父母产权"},{"value":"5","name":"子女产权"},{"value":"6","name":"其他"}],"_/default/house/relationType":[{"value":"1","name":"本人"},{"value":"2","name":"夫妻"},{"value":"3","name":"父子"},{"value":"4","name":"父女"},{"value":"5","name":"母女"},{"value":"6","name":"母子"}],"_/default/contacts/relationType":[{"value":1,"name":"夫妻"},{"value":2,"name":"父母"},{"value":3,"name":"亲属"},{"value":4,"name":"朋友"},{"value":5,"name":"其他"}],"_/default/house/buyType":[{"value":"1","name":"全款"},{"value":"2","name":"按揭"}],"_/default/house/monthPrice":[{"value":"0","name":"无月供"},{"value":"1","name":"1-3000"},{"value":"2","name":"3001-6000"},{"value":"3","name":"6001-9000"},{"value":"4","name":"9001-12000"},{"value":"5","name":"12001-15000"},{"value":"6","name":"15001-20000"},{"value":"7","name":"2万以上"}],"_/default/house/buyPrice":[{"value":"1","name":"0-50万"},{"value":"2","name":"50-100万"},{"value":"3","name":"100-150万"},{"value":"4","name":"150-200万"},{"value":"5","name":"200-250万"},{"value":"6","name":"250-300万"},{"value":"7","name":"300-400万"},{"value":"8","name":"400-500万"},{"value":"9","name":"500-600万"},{"value":"10","name":"600-700万"},{"value":"11","name":"700-800万"},{"value":"12","name":"800-900万"},{"value":"13","name":"900-1000万"},{"value":"14","name":"1000万以上"}],"_/default/car/gearType":[{"name":"自动档","value":"1"},{"name":"手动档","value":"2"}],"_/default/car/payType":[{"name":"全款","value":"1"},{"name":"按揭","value":"2"}],"_/default/houseType":[{"name":"自有商品房","value":1},{"name":"亲属商品房","value":2},{"name":"配偶商品房","value":3},{"name":"自有自建房","value":4},{"name":"亲属自建房","value":5},{"name":"单位房","value":7},{"name":"租房","value":8},{"name":"其他","value":6}],"_/default/childrenNum":[{"name":"0个","value":0},{"name":"1个","value":1},{"name":"2个","value":2},{"name":"3个","value":3},{"name":"3个以上","value":4}],"_/gps/status":[{"name":"库存","value":1},{"name":"已安装","value":2},{"name":"已报废","value":3}],"_/gps/usable":[{"name":"正常","value":"normal"},{"name":"异常","value":"disable"}],"_/gps/testType":[{"name":"成功","value":1},{"name":"失败","value":2},{"name":"未测试","value":3}],"_/gps/installType":[{"name":"已安装","value":1},{"name":"未安装","value":2}],"_/default/judge/cutPriceType":[{"name":"通过","value":1},{"name":"拒绝","value":3}],"_/default/judge/judgeType":[{"name":"通过","value":1},{"name":"退回","value":2},{"name":"拒绝","value":3}],"_/default/judge/homeVisitType":[{"name":"家访","value":1},{"name":"不家访","value":2}],"_/default/judge/netCheckType":[{"name":"无异常","value":1},{"name":"有异常","value":2}],"_/default/judge/reviewType":[{"name":"复议","value":1},{"name":"不复议，通过","value":2},{"name":"不复议，撤销订单","value":3}],"_/default/judge/reviewCheckType":[{"name":"通过","value":1},{"name":"撤单","value":2}],"_/default/judge/reviewReasonType":[{"name":"估价偏低","value":1},{"name":"成数偏低","value":2}],"_/default/judge/materialBasicType":[{"name":"身份证","value":"26"},{"name":"行驶证","value":"30"},{"name":"驾驶证","value":"73"},{"name":"车辆登记证","value":"71"},{"name":"交强保险单","value":"81"},{"name":"居住证明","value":"42"},{"name":"商业保险单","value":"82"},{"name":"银行卡","value":"75"},{"name":"车辆备用钥匙","value":"69"}],"_/default/judge/materialType":[{"name":"结婚证","value":"90"},{"name":"购车发票","value":"83"},{"name":"完税证明","value":"96"},{"name":"房产证","value":"91"},{"name":"工资单","value":"89"},{"name":"营业执照","value":"85"},{"name":"营业场所租赁合同","value":"84"},{"name":"工作证","value":"87"},{"name":"征信报告","value":"58"},{"name":"租金发票/收据","value":"88"},{"name":"最近六个月对公/私人账户银行流水","value":"80"}],"_/default/judge/channelType":[{"name":"自有资金","value":"1"},{"name":"农商行","value":"2"},{"name":"海峡银行","value":"3"},{"name":"海通恒信","value":"4"},{"name":"鑫安汽车保险","value":"5"}],"_/judgeStep/assistant_evaluate":{"name":"副理审核","read":"approval/assistJudgeGet","save":"approval/assistJudgeSet","keyMap":{"en_home":"assist_judge_home_visit","percent":"assist_judge_percent","type":"assist_judge_audit","money":"assist_judge_price","mark":"assist_judge_summary","home_mark":"assist_judge_mark"}},"_/judgeStep/final_evaluate":{"name":"总部风控审核","read":"approval/finalJudgeGet","save":"approval/finalJudgeSet","keyMap":{"en_home":"final_judge_home_visit","percent":"final_judge_percent","type":"final_judge_audit","money":"final_judge_price","mark":"final_judge_summary","home_mark":"final_judge_mark"}},"_/judgeStep/prev_loan_evaluate":{"name":"贷前风控经理审核","read":"approval/loanBeforeRiskGet","save":"approval/loanBeforeRiskSet","keyMap":{"en_home":"risk_before_load_home_visit","percent":"risk_before_load_percent","type":"risk_before_load_audit","money":"risk_before_load_price","mark":"risk_before_load_summary","home_mark":"risk_before_load_mark"}},"_/judgeStep/risk_manager_evaluate":{"name":"风控总监审核","read":"approval/riskManagerJudgeGet","save":"approval/riskManagerJudgeSet","keyMap":{"en_home":"risk_manager_judge_home_visit","percent":"risk_manager_judge_percent","type":"risk_manager_judge_audit","money":"risk_manager_judge_price","mark":"risk_manager_judge_summary"}},"_/judgeStep/manager_evaluate":{"name":"总经理审核","read":"approval/generalManagerGet","save":"approval/generalManagerSet","keyMap":{"en_home":"general_manager_home_visit","percent":"general_manager_percent","type":"general_manager_audit","money":"general_manager_price","mark":"general_manager_summary"}},"_/judgeStep/chairman_evaluate":{"name":"董事长审核","read":"approval/chairmanJudgeGet","save":"approval/chairmanJudgeSet","keyMap":{"en_home":"chairman_judge_home_visit","percent":"chairman_judge_percent","type":"chairman_judge_audit","money":"chairman_judge_price","mark":"chairman_judge_summary"}},"_/judgeStep/loan_ass_check":{"name":"呈签副理确认","read":"order/getAss","save":"order/saveAss","keyMap":{"remark":"assistant_remark"}},"_/judgeStep/loan_mgr_check":{"name":"呈签经理确认","read":"order/getMgr","save":"order/saveMgr","keyMap":{"remark":"manager_remark"}},"_/judgeStep/gps_monitor":{"name":"gps监控","read":"approval/gpsMonitorGet","save":"approval/gpsMonitorInsert","keyMap":{"type":"gps_monitor_type","mark":"gps_monitor_mark"}},"_/photo/identify_photo":{"read":"order/getUploadCustomerRes","save":"order/uploadCustomerRes","ref":"identify_photo","file_type":"order","resource_type":1,"imgGroup":[{"name":"身份证正面照","value":"26"},{"name":"身份证反面照","value":"27"},{"name":"行驶证第一页","value":"30"},{"name":"行驶证第二页","value":"31"},{"name":"行驶证第三页","value":"119"}]},"_/photo/validate_car_photo":{"read":"gps/getServerInfoRes","save":"gps/serverInfoRes","ref":"validate_car_photo","file_type":"gps","resource_type":1,"imgGroup":[{"name":"前排座椅","value":"2"},{"name":"点火开关","value":"3"},{"name":"启动仪表","value":"4"},{"name":"后出风口","value":"5"},{"name":"中控台","value":"6"},{"name":"天窗","value":"7"},{"name":"轮胎型号","value":"8"},{"name":"右后45","value":"9"},{"name":"左前45","value":"10"},{"name":"引擎盖螺丝","value":"11"},{"name":"发动机舱","value":"12"},{"name":"叶子板螺丝","value":"13"},{"name":"铭牌","value":"35"},{"name":"人车合照","value":"285"}]},"_/photo/credit_photo":{"save":"res/fillCateImg","read":"com/getApprovalImages","ref":"credit_photo","file_type":"check","resource_type":1,"imgGroup":[{"value":"53","name":"人法网"},{"value":"54","name":"违章网1"},{"value":"263","name":"违章网2"},{"value":"264","name":"违章网3"},{"value":"55","name":"搜赖网"},{"value":"56","name":"百度信息"},{"value":"57","name":"企业审核"},{"value":"58","name":"征信照片"},{"value":"59","name":"其他"},{"value":"60","name":"同盾"},{"value":"61","name":"聚信立"}]},"_/photo/home_visit":{"save":"risk/homeVisit","read":"risk/getHomeVisit","ref":"home_visit","file_type":"check","resource_type":1,"imgGroup":[{"value":"42","name":"门牌"},{"value":"43","name":"大厅"},{"value":"44","name":"卧室"},{"value":"45","name":"卫生间"},{"value":"46","name":"厨房"},{"value":"47","name":"合影"},{"value":"48","name":"定位截图"},{"value":"360","name":"家访报告1"},{"value":"361","name":"家访报告2"}]},"_/photo/mortgage_register":{"save":"risk/mortgageRes","read":"risk/getMortgageRes","ref":"mortgage_register","file_type":"check","resource_type":1,"extArgs":{"mark":""},"imgGroup":[{"value":"37","name":"抵押页+身份证"},{"value":"38","name":"抵押登记"},{"value":"39","name":"业务受理凭证"},{"value":"52","name":"抵押页2+身份证"}]},"_/photo/gps_photo":{"save":"gps/gpsEquipmentImgSet","read":"gps/gpsEquipmentImgGet","ref":"gps_photo","file_type":"check","resource_type":1,"imgGroup":[{"value":"100","name":"GPS有线1"},{"value":"101","name":"GPS有线2"},{"value":"102","name":"GPS无线1"},{"value":"103","name":"GPS无线2"},{"value":"104","name":"GPS无线3"},{"value":"105","name":"GPS无线4"},{"value":"106","name":"GPS无线5"},{"value":"120","name":"GPS无线6"},{"value":"186","name":"GPS无线7"},{"value":"187","name":"GPS无线8"}]},"_/photo/loan_photo":{"save":"finance/makeLoanSet","read":"finance/makeLoanGet","ref":"loan_photo","file_type":"check","resource_type":1,"imgGroup":[{"value":"98","name":"放款图片"},{"value":"98","name":"放款图片2"},{"value":"98","name":"放款图片3"},{"value":"98","name":"放款图片4"},{"value":"98","name":"放款图片5"},{"value":"98","name":"放款图片6"},{"value":"98","name":"放款图片7"},{"value":"98","name":"放款图片8"},{"value":"98","name":"放款图片9"},{"value":"98","name":"放款图片10"},{"value":"98","name":"放款图片11"},{"value":"98","name":"放款图片12"},{"value":"98","name":"放款图片13"},{"value":"98","name":"放款图片14"},{"value":"98","name":"放款图片15"},{"value":"98","name":"放款图片16"},{"value":"98","name":"放款图片17"},{"value":"98","name":"放款图片18"},{"value":"98","name":"放款图片19"},{"value":"98","name":"放款图片20"}]},"_/photo/evaluate_third_photo":{"save":"res/fillCateImg","read":"approval/getThirdImages","ref":"evaluate_third_photo","file_type":"check","resource_type":1,"imgGroup":[{"value":"286","name":"参考价照片1"},{"value":"286","name":"参考价照片2"},{"value":"286","name":"参考价照片3"},{"value":"286","name":"参考价照片4"},{"value":"286","name":"参考价照片5"},{"value":"286","name":"参考价照片6"}]},"_/photo/photo_sign":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"photo_sign","file_type":"check","cate_id":33,"imgGroup":[{"value":"99","name":"签约图片","resource_type":1}]},"_/photo/photo_supple":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"credit_photo","file_type":"check","resource_type":1,"cate_id":67,"imgGroup":[{"value":"68","name":"身份证复印件"},{"value":"272","name":"行驶证复印件"},{"value":"69","name":"车辆备用钥匙"},{"value":"188","name":"申请表"},{"value":"189","name":"审核表"},{"value":"372","name":"查定表"},{"value":"190","name":"支付宝芝麻分"},{"value":"191","name":"还款流水1"},{"value":"192","name":"还款流水2"},{"value":"193","name":"还款流水3"},{"value":"194","name":"存管(带银行卡号)"},{"value":"70","name":"查档照片1"},{"value":"261","name":"查档照片2"},{"value":"262","name":"查档照片3"},{"value":"71","name":"车辆登记证第一页"},{"value":"72","name":"车辆登记证第二页"},{"value":"195","name":"车辆登记证第三页"},{"value":"196","name":"车辆登记证第四页"},{"value":"73","name":"驾驶证"},{"value":"74","name":"户口本第一页"},{"value":"197","name":"户口本第二页"},{"value":"198","name":"户口本第三页"},{"value":"75","name":"银行卡"},{"value":"76","name":"面签照"},{"value":"77","name":"车正照"},{"value":"78","name":"车后照"},{"value":"79","name":"人车照"},{"value":"80","name":"银行流水"},{"value":"81","name":"交强保险单"},{"value":"82","name":"商业保险单"},{"value":"83","name":"购车发票"},{"value":"84","name":"营业场所租赁合同"},{"value":"85","name":"营业执照"},{"value":"86","name":"社保卡"},{"value":"87","name":"工作证"},{"value":"88","name":"租金发票"},{"value":"89","name":"工资单"},{"value":"90","name":"结婚证"},{"value":"91","name":"房产证"},{"value":"92","name":"水费单据"},{"value":"93","name":"电费单据"},{"value":"94","name":"煤气单据"},{"value":"95","name":"有线闭路单据"},{"value":"96","name":"完税证明"},{"value":"116","name":"POS小票"},{"value":"117","name":"呈签单"},{"value":"118","name":"存款开通"},{"value":"377","name":"受益人保单变更"},{"value":"199","name":"其他"}]},"_/file/issuing_material":{"read":"order/getcontractEnclosure","save":"order/savecontractEnclosure","ref":"order_contractEnclosure","file_type":"file","resource_type":1,"fileGroup":[{"name":"发标材料(原件)","value":"274"},{"name":"发标材料(PS)","value":"275"}]},"_/file/contract_enclosure":{"read":"order/getcontract_enclosure","save":"order/savecontract_enclosure","ref":"order_contract_enclosure","file_type":"file","resource_type":1,"fileGroup":[{"name":"合同A档","value":"278"},{"name":"合同B档","value":"273"},{"name":"合同C档","value":"379"}]},"_/photo/ph_people_photo":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"person_photo","file_type":"puhui","resource_type":1,"cate_id":300,"imgGroup":[{"value":"304","name":"身份证正面","required":"true"},{"value":"305","name":"身份证反面","required":"true"},{"value":"306","name":"身份证验磁照","required":"true"},{"value":"307","name":"银行卡正面"},{"value":"308","name":"银行卡背面"},{"value":"481","name":"芝麻分1"},{"value":"482","name":"芝麻分2"},{"value":"309","name":"居住证明1"},{"value":"310","name":"居住证明2"},{"value":"370","name":"居住证明3"},{"value":"366","name":"关系证明1"},{"value":"367","name":"关系证明2"},{"value":"368","name":"关系证明3"},{"value":"369","name":"关系证明4"},{"value":"311","name":"社医保1"},{"value":"312","name":"社医保2"},{"value":"373","name":"社医保3"},{"value":"313","name":"公积金1"},{"value":"314","name":"公积金2"},{"value":"374","name":"公积金3"},{"value":"315","name":"车辆登记证1"},{"value":"316","name":"车辆登记证2"},{"value":"317","name":"行驶证1"},{"value":"318","name":"行驶证2"},{"value":"319","name":"行驶证3"},{"value":"320","name":"房产证"},{"value":"321","name":"回迁交房确认书"},{"value":"322","name":"购房合同1"},{"value":"323","name":"购房合同2"},{"value":"324","name":"购房合同3"},{"value":"325","name":"购房合同4"},{"value":"326","name":"购房合同5"},{"value":"362","name":"户口本1"},{"value":"363","name":"户口本2"},{"value":"364","name":"户口本3"},{"value":"365","name":"户口本4"}]},"_/photo/ph_network_photo":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"net_photo","file_type":"puhui","resource_type":1,"cate_id":301,"imgGroup":[{"value":"327","name":"执行网","required":"true"},{"value":"371","name":"工商红盾网截图1"},{"value":"331","name":"工商红盾网截图2"},{"value":"329","name":"百度搜索手机号","required":"true"},{"value":"330","name":"百度搜索身份证","required":"true"},{"value":"332","name":"芝麻信用1"},{"value":"333","name":"芝麻信用2"},{"value":"375","name":"其他1"},{"value":"376","name":"其他2"}]},"_/photo/ph_contract_photo":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"enclosure_photo","file_type":"file","resource_type":3,"cate_id":302,"imgGroup":[{"value":"504","name":"普惠合同照片"}]},"_/photo/wechat_photo":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"wechatPhoto","file_type":"puhui","resource_type":1,"cate_id":510,"imgGroup":[{"value":"511","name":"公众号绑定照片"}]},"_/photo/ph_home_photo":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"home_photo","file_type":"puhui","resource_type":1,"cate_id":303,"imgGroup":[{"value":"337","name":"签到定位截图"},{"value":"341","name":"打卡定位截图"},{"value":"346","name":"考勤安全防护"},{"value":"339","name":"小区号"},{"value":"340","name":"门牌号"},{"value":"342","name":"街道照片"},{"value":"338","name":"房屋外观全景"},{"value":"343","name":"室内1"},{"value":"344","name":"室内2"},{"value":"345","name":"室内3"},{"value":"347","name":"其他"}]},"_/photo/send_appearance":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"home_photo","file_type":"appearance","resource_type":1,"cate_id":380,"imgGroup":[{"value":"385","name":"车正照"},{"value":"386","name":"车后照"},{"value":"387","name":"中控台"},{"value":"388","name":"启动仪表"},{"value":"389","name":"铭牌"}]},"_/photo/send_check_car":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"home_photo","file_type":"puhui","resource_type":1,"cate_id":416,"imgGroup":[{"value":"427","name":"维修保养记录1"},{"value":"428","name":"维修保养记录2"},{"value":"429","name":"维修保养记录3"},{"value":"430","name":"维修保养记录4"},{"value":"431","name":"维修保养记录5"},{"value":"432","name":"验车照片1"},{"value":"433","name":"验车照片2"},{"value":"434","name":"验车照片3"},{"value":"435","name":"验车照片4"},{"value":"436","name":"验车照片5"},{"value":"437","name":"验车照片6"}]},"_/photo/send_property":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"home_photo","file_type":"puhui","resource_type":1,"cate_id":381,"imgGroup":[{"value":"401","name":"身份证正面"},{"value":"402","name":"身份证反面"},{"value":"403","name":"驾驶证1"},{"value":"404","name":"驾驶证2"},{"value":"405","name":"驾驶证3"},{"value":"417","name":"驾驶证4"},{"value":"418","name":"车辆登记证第一页"},{"value":"419","name":"车辆登记证第二页"},{"value":"420","name":"车辆登记证第三页"},{"value":"421","name":"车辆登记证第四页"}]},"_/photo/send_risk_photo":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"home_photo","file_type":"puhui","resource_type":1,"cate_id":382,"imgGroup":[{"value":"406","name":"审核表"},{"value":"407","name":"家访照1"},{"value":"408","name":"家访照2"},{"value":"409","name":"家访照3"},{"value":"410","name":"家访照4"},{"value":"422","name":"家访照5"},{"value":"423","name":"家访照6"},{"value":"424","name":"家访照7"}]},"_/photo/send_borrow":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"home_photo","file_type":"puhui","resource_type":1,"cate_id":384,"imgGroup":[{"value":"393","name":"电子确认书"},{"value":"394","name":"借据"},{"value":"395","name":"车辆转让协议书"},{"value":"396","name":"查定书"},{"value":"397","name":"续约协议1"},{"value":"398","name":"续约协议2"},{"value":"399","name":"续约协议3"},{"value":"400","name":"续约协议4"},{"value":"425","name":"续约协议5"},{"value":"426","name":"续约协议6"}]},"_/photo/ph_send_customer":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"enclosure_photo","file_type":"puhui","resource_type":1,"cate_id":454,"imgGroup":[{"value":"457","name":"身份证正面"},{"value":"458","name":"身份证反面"},{"value":"459","name":"客户签约照"},{"value":"460","name":"手持产品照"}]},"_/photo/ph_send_borrow":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"enclosure_photo","file_type":"puhui","resource_type":1,"cate_id":456,"imgGroup":[{"value":"473","name":"借款合同1"},{"value":"474","name":"电子合同确认书"},{"value":"475","name":"借据"}]},"_/photo/ph_send_approve":{"save":"res/fillCateImg","read":"res/getFillCate","ref":"enclosure_photo","file_type":"puhui","resource_type":1,"cate_id":455,"imgGroup":[{"value":"483","name":"续展协议1"},{"value":"484","name":"续展协议2"},{"value":"485","name":"续展协议3"},{"value":"486","name":"续展协议4"},{"value":"487","name":"续展协议5"},{"value":"488","name":"续展协议6"},{"value":"489","name":"续展协议7"},{"value":"490","name":"续展协议8"}]}}

/***/ }),

/***/ 1055:
/***/ (function(module, exports) {

	module.exports = {"user":{"name":"个人中心","icon":"fa fa-user","ref":"folder_user","childrens":{"normaltodo":{"name":"待办任务","href":"/user/taskTodo","ref":"car_user_todo","icon":"fa fa-calendar-o"},"normaldone":{"name":"已办任务","href":"/user/taskList","ref":"car_user_task","icon":"fa fa-calendar-check-o"},"personal":{"name":"个人资料","href":"/user/info","ref":"car_user_info","icon":"fa fa-user"}}}}

/***/ }),

/***/ 1056:
/***/ (function(module, exports) {

	module.exports = {"products":{"name":"产品管理","icon":"fa fa-shopping-bag","ref":"folder_products","childrens":{"manage":{"name":"产品管理","href":"/products/manage","ref":"admin_products_manage","icon":"fa fa-car"},"flow":{"name":"流程管理","href":"/products/flow","ref":"admin_products_flow","icon":"fa fa-sitemap"}}},"inventory":{"name":"库存管理","icon":"fa fa-cubes","ref":"folder_inventory","childrens":{"brand":{"name":"GPS供应商","href":"/inventory/brand","ref":"admin_gps_brand","icon":"fa fa-map-marker"},"gpsInventory":{"name":"GPS管理","href":"/inventory/manage","ref":"admin_gps_manage","icon":"fa fa-archive"}}},"admin":{"name":"系统管理","icon":"fa fa-cog","ref":"folder_admin","childrens":{"update":{"name":"版本更新信息","href":"/system/update","ref":"admin_update","icon":"fa fa-flag"},"dashboard":{"name":"组织机构管理","icon":"fa fa-dashboard","ref":"folder_dashboard","childrens":{"department":{"name":"部门管理","href":"/user/department","icon":"fa fa-building","ref":"admin_department"},"user":{"name":"用户管理","href":"/user/list","icon":"fa fa-users","ref":"admin_list"},"role":{"name":"角色与权限管理","href":"/user/role","icon":"fa fa-key","ref":"admin_role"}}}}}}

/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/banner.08dfde8.png";

/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAADJmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkQ3NTFGQkJDRTk5MTFFNzk4QTRDRTZEOUVCNDU3NzkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkQ3NTFGQkNDRTk5MTFFNzk4QTRDRTZEOUVCNDU3NzkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCRDc1MUZCOUNFOTkxMUU3OThBNENFNkQ5RUI0NTc3OSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCRDc1MUZCQUNFOTkxMUU3OThBNENFNkQ5RUI0NTc3OSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PsroOB4AAABRUExURf///4eFg4qIhvb29vDv76OioLq5uNHQ0IWDgYyKiNjX1t7d3aimpaGfntLR0evr6svKyfz8/KalpMzLypiWlKalo8/OzsrKyZmXldPS0YiGhN6sq3cAAABTSURBVCjPY2Bg5MQBpBgYGDhYGLACFg6IpJgwOxoQl4RLigixoQFRCbgkKzu6meysI1ySi08QpyQ3B4cATklmHl7+0eCjjiQwOzAyoWcFJpAoAwDh6whDslfJJAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAADJmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkUyMEZBNzFDRTk5MTFFNzk5NEVDQ0I1MzNBRDk0QjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkUyMEZBNzJDRTk5MTFFNzk5NEVDQ0I1MzNBRDk0QjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCRTIwRkE2RkNFOTkxMUU3OTk0RUNDQjUzM0FEOTRCMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCRTIwRkE3MENFOTkxMUU3OTk0RUNDQjUzM0FEOTRCMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Ppftb4kAAACTUExURf///46Ni+vr66CfneLi4YWDgfLy8pWTkYyKiIiGhImHhejo542LiYqIhra1tIeFg5eVlKWjovDv78DAv/n4+MnJyNnY1+Dg37Gwruno6Ofm5o6MisTDwr69vO/u7pGQjuPi4qyrqtTT04uJh6+urJWUkrq5uKSiobKxsJeVk7Gwr5uamOTj4+Tk47e2tZGPjaCenQf0ZRcAAACRSURBVCjP1ZK3DoNAEAXfHX4HnMGAc07gHP//68xR4IaltTzFNLNaaaUF2ujdAoE0Q0RfgER8EXcS+UGKZyLcSLEguJDijpjPpLje4id0jbOubPTXw0nZqFyrDEVde8oR+pHnhpUzPGVqDzjGf7FaSmV/RPkpAici8KV4JWwqxSeRJPdOI483kcU2bMTaV+slHwvCCDcI6JyNAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1017)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(503),
	  /* template */
	  __webpack_require__(1283),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(967)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(505),
	  /* template */
	  __webpack_require__(1220),
	  /* scopeId */
	  "data-v-2e4de408",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(526),
	  /* template */
	  __webpack_require__(1306),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(955)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(552),
	  /* template */
	  __webpack_require__(1206),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1038)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(555),
	  /* template */
	  __webpack_require__(1308),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1024)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(557),
	  /* template */
	  __webpack_require__(1291),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1001)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(561),
	  /* template */
	  __webpack_require__(1262),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(982)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(570),
	  /* template */
	  __webpack_require__(1239),
	  /* scopeId */
	  "data-v-464f784c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(975)
	__webpack_require__(976)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(578),
	  /* template */
	  __webpack_require__(1228),
	  /* scopeId */
	  "data-v-3628e63c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1007)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(614),
	  /* template */
	  __webpack_require__(1269),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1185:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(957)
	
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(615),
	  /* template */
	  __webpack_require__(1208),
	  /* scopeId */
	  "data-v-179959b1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1186:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(616),
	  /* template */
	  __webpack_require__(1209),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-body table-responsive no-padding"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "stripe": "",
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "60"
	    }
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "order_id_sn",
	      "label": "ID",
	      "width": "220"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "product_type",
	      "label": "业务种类",
	      "width": "120"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "customer",
	      "label": "客户姓名",
	      "width": "150"
	    }
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "res_prov",
	      "label": "省份"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "res_city",
	      "label": "城市"
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "depart_name",
	      "label": "归属部门"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "产品"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "differ",
	      "label": "等待时间"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(!_vm.red(scope.row.differ)) ? _c('span', {
	          staticStyle: {
	            "color": "red"
	          }
	        }, [_vm._v(_vm._s(scope.row.differ))]) : _vm._e(), _vm._v(" "), (_vm.red(scope.row.differ)) ? _c('span', [_vm._v(_vm._s(scope.row.differ))]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "label": "上一状态"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._l((scope.row.prev), function(o) {
	          return _c('span', {
	            staticClass: "label label-default"
	          }, [_vm._v(_vm._s(o.node_name))])
	        }), _vm._v("  \n                  ")]
	      }
	    }], null, false, 3340196871)
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "active_time",
	      "label": "最后处理时间"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "right",
	      "label": "操作",
	      "width": "250"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(0 == scope.row.staff_id) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showChoice', scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.node_name))]) : _c('el-button', {
	          attrs: {
	            "type": "success",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'goto', scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.node_name))]), _vm._v(" "), (2 == scope.row.last_transition_type) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showMsg', scope.row)
	            }
	          }
	        }, [_vm._v("退回原因")]) : _vm._e()]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer clearfix"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-sm-6 text-right"
	  }, [_c('el-pagination', {
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [20, 30, 50, 100],
	      "page-size": _vm.pageSize,
	      "total": _vm.totalRow,
	      "layout": "total, prev, pager, next, sizes, jumper"
	    },
	    on: {
	      "size-change": _vm.sizeChangeHandle,
	      "current-change": _vm.pageChangeHandle
	    }
	  })], 1)])])])])])]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.backMsgDialog.title,
	      "visible": _vm.backMsgDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.backMsgDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "backMsgForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "退回原因",
	      "prop": "last_msg",
	      "error": _vm.error.last_msg
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "textarea",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.backMsgDialog.last_msg),
	      callback: function($$v) {
	        _vm.$set(_vm.backMsgDialog, "last_msg", $$v)
	      },
	      expression: "backMsgDialog.last_msg"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.backMsgDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.choiceDialog.title,
	      "visible": _vm.choiceDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.choiceDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "choiceForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "分配给",
	      "prop": "staff_id",
	      "error": _vm.error.staff_id
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择",
	      "required": ""
	    },
	    model: {
	      value: (_vm.choiceDialog.staff_id),
	      callback: function($$v) {
	        _vm.$set(_vm.choiceDialog, "staff_id", $$v)
	      },
	      expression: "choiceDialog.staff_id"
	    }
	  }, _vm._l((_vm.staffChoiceList), function(item) {
	    return _c('el-option', {
	      key: item.staff_id,
	      attrs: {
	        "label": item.name,
	        "value": item.staff_id
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.choiceDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function (e) {
	        return _vm.pageActionHandle(e, 'choiceForm', _vm.choiceDialog)
	      }
	    }
	  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('popupWin', {
	    attrs: {
	      "visible": _vm.showPopupWin,
	      "info": _vm.popupWinInfo
	    },
	    on: {
	      "closed": function($event) {
	        _vm.showPopupWin = false
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1206:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-body table-responsive no-padding"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "stripe": "",
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "type": "selection",
	      "width": "55",
	      "align": "center"
	    }
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "prop": "order_id_sn",
	      "label": "ID",
	      "width": "240",
	      "align": "center"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "product_type",
	      "label": "业务种类",
	      "width": "120"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "customer",
	      "label": "客户姓名",
	      "width": "100",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "产品",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "扣款金额",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return (scope.row.postDebit) ? [_c('span', [_vm._v(_vm._s(scope.row.postDebit.total_amount))])] : undefined
	      }
	    }], null, true)
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "depart_name",
	      "label": "门店",
	      "align": "right"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "originator",
	      "label": "申请人",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "staff_name",
	      "label": "业务员",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "active_time",
	      "label": "最后处理时间",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "right",
	      "label": "操作",
	      "width": "250"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(0 == scope.row.staff_id) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showChoice', scope.row)
	            }
	          }
	        }, [_vm._v("\n                                        " + _vm._s(scope.row.node_name) + "\n                                    ")]) : _c('el-button', {
	          attrs: {
	            "type": "success",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'goto', scope.row)
	            }
	          }
	        }, [_vm._v("\n                                        " + _vm._s(scope.row.node_name) + "\n                                    ")]), _vm._v(" "), (2 == scope.row.last_transition_type) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showMsg', scope.row)
	            }
	          }
	        }, [_vm._v("\n                                        退回原因\n                                    ")]) : _vm._e()]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer clearfix"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-sm-6 text-right"
	  }, [_c('el-pagination', {
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [20, 30, 50, 100],
	      "page-size": _vm.pageSize,
	      "total": _vm.totalRow,
	      "layout": "total, prev, pager, next, sizes, jumper"
	    },
	    on: {
	      "size-change": _vm.sizeChangeHandle,
	      "current-change": _vm.pageChangeHandle
	    }
	  })], 1)])])])])])]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.chargeMsgDialog.title,
	      "visible": _vm.chargeMsgDialog.visible,
	      "stripe": ""
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.chargeMsgDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.chargeMsgDialog.data,
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "property": "title",
	      "label": "扣款类型"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "value",
	      "label": "扣款金额"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.backMsgDialog.title,
	      "visible": _vm.backMsgDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.backMsgDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "backMsgForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "退回原因",
	      "prop": "last_msg",
	      "error": _vm.error.last_msg
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "textarea",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.backMsgDialog.last_msg),
	      callback: function($$v) {
	        _vm.$set(_vm.backMsgDialog, "last_msg", $$v)
	      },
	      expression: "backMsgDialog.last_msg"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.backMsgDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.choiceDialog.title,
	      "visible": _vm.choiceDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.choiceDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "choiceForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "分配给",
	      "prop": "staff_id",
	      "error": _vm.error.staff_id
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择",
	      "required": ""
	    },
	    model: {
	      value: (_vm.choiceDialog.staff_id),
	      callback: function($$v) {
	        _vm.$set(_vm.choiceDialog, "staff_id", $$v)
	      },
	      expression: "choiceDialog.staff_id"
	    }
	  }, _vm._l((_vm.staffChoiceList), function(item) {
	    return _c('el-option', {
	      key: item.staff_id,
	      attrs: {
	        "label": item.name,
	        "value": item.staff_id
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.choiceDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function (e) {
	        return _vm.pageActionHandle(e, 'choiceForm', _vm.choiceDialog)
	      }
	    }
	  }, [_vm._v("保 存\n            ")])], 1)], 1), _vm._v(" "), _c('popupWin', {
	    attrs: {
	      "visible": _vm.showPopupWin,
	      "info": _vm.popupWinInfo
	    },
	    on: {
	      "closed": function($event) {
	        _vm.showPopupWin = false
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "container",
	    attrs: {
	      "id": "loginSection"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-5",
	    attrs: {
	      "id": "loginPanel"
	    }
	  }, [_c('el-popover', {
	    ref: "verifyImg",
	    attrs: {
	      "placement": "bottom-end",
	      "width": "170",
	      "trigger": "focus"
	    },
	    on: {
	      "show": _vm.changeImg
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "width": "150px"
	    },
	    attrs: {
	      "src": _vm.verifyImgUrl
	    }
	  })]), _vm._v(" "), _c('el-form', {
	    ref: "form",
	    attrs: {
	      "model": _vm.form,
	      "label-position": "top",
	      "label-width": "100px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "prop": "username",
	      "error": _vm.error.username
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "outline": "medium"
	    },
	    attrs: {
	      "placeholder": "请输入帐号/姓名/手机号",
	      "maxlength": 32
	    },
	    model: {
	      value: (_vm.form.username),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "username", $$v)
	      },
	      expression: "form.username"
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "18px",
	      "height": "18px"
	    },
	    attrs: {
	      "src": __webpack_require__(1067),
	      "alt": ""
	    }
	  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
	    ref: "password",
	    attrs: {
	      "prop": "password",
	      "error": _vm.error.password
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "placeholder": "请输入密码",
	      "maxlength": 32
	    },
	    model: {
	      value: (_vm.form.password),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "password", $$v)
	      },
	      expression: "form.password"
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "18px",
	      "height": "18px"
	    },
	    attrs: {
	      "src": __webpack_require__(1068),
	      "alt": ""
	    }
	  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
	    ref: "verify_code",
	    attrs: {
	      "prop": "verify_code",
	      "error": _vm.error.verify_code
	    }
	  }, [_c('el-input', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:verifyImg",
	      arg: "verifyImg"
	    }],
	    attrs: {
	      "placeholder": "请输入验证码",
	      "maxlength": 5
	    },
	    model: {
	      value: (_vm.form.verify_code),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "verify_code", $$v)
	      },
	      expression: "form.verify_code"
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_c('img', {
	    staticStyle: {
	      "width": "18px",
	      "height": "18px"
	    },
	    attrs: {
	      "src": __webpack_require__(1069),
	      "alt": ""
	    }
	  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label-width": "80px"
	    }
	  }, [_c('el-switch', {
	    attrs: {
	      "active-text": "",
	      "active-value": "yes",
	      "inactive-text": "",
	      "inactive-value": "no"
	    },
	    model: {
	      value: (_vm.form.remember),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "remember", $$v)
	      },
	      expression: "form.remember"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "row submitArea"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('el-button', {
	    staticClass: "btn-block",
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.loginSubmit
	    }
	  }, [_vm._v("登录")])], 1)])], 1)]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "logoArea"
	    }
	  }, [_c('label', {
	    staticClass: "loginLogoCss"
	  }, [_vm._v("HR融担平台")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "row loginFooter"
	  }, [_c('p', {
	    staticClass: "text-center loginfFooterText"
	  }, [_vm._v("版权所有：福州索弗企业管理咨询有限公司")])])
	}]}

/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "sidebar"
	  }, [_c('ul', {
	    staticClass: "sidebar-menu",
	    attrs: {
	      "id": "menuArea"
	    }
	  }, _vm._l((_vm.items), function(item) {
	    return _c('li', {
	      staticClass: "treeview",
	      attrs: {
	        "data-ref": item.ref
	      }
	    }, [_c('a', {
	      attrs: {
	        "href": "#"
	      }
	    }, [_c('i', {
	      class: item.icon
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), (item.childrens) ? _c('ul', {
	      staticClass: "treeview-menu"
	    }, _vm._l((item.childrens), function(subitem) {
	      return _c('li', {
	        class: subitem.childrens ? 'treeview-sub' : '',
	        attrs: {
	          "data-pref": item.ref,
	          "data-ref": subitem.ref
	        }
	      }, [(subitem.childrens) ? _c('a', {
	        attrs: {
	          "href": "#"
	        }
	      }, [_c('i', {
	        class: subitem.icon
	      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(subitem.name))]), _vm._v(" "), _vm._m(1, true)]) : _c('router-link', {
	        attrs: {
	          "to": subitem.href
	        }
	      }, [_c('i', {
	        class: subitem.icon
	      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(subitem.name))])]), _vm._v(" "), (subitem.childrens) ? _c('ul', {
	        staticClass: "treeview-menu"
	      }, _vm._l((subitem.childrens), function(childitem) {
	        return _c('li', {
	          class: childitem.childrens ? 'treeview-sub' : '',
	          attrs: {
	            "data-pref": subitem.ref,
	            "data-ref": childitem.ref
	          }
	        }, [(childitem.childrens) ? _c('a', {
	          attrs: {
	            "href": "#"
	          }
	        }, [_c('i', {
	          class: childitem.icon
	        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(childitem.name))]), _vm._v(" "), _vm._m(2, true)]) : _c('router-link', {
	          attrs: {
	            "to": childitem.href
	          }
	        }, [_c('i', {
	          class: childitem.icon
	        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(childitem.name))])])], 1)
	      }), 0) : _vm._e()], 1)
	    }), 0) : _vm._e()])
	  }), 0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-right-container"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left pull-right"
	  })])
	}]}

/***/ }),

/***/ 1220:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "visible": _vm.showDialog,
	      "show-close": false,
	      "top": "5%"
	    }
	  }, [_c('div', {
	    staticClass: "panel-collapse collapse in",
	    attrs: {
	      "aria-expanded": "true",
	      "id": "createFile"
	    }
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box box-default box-body"
	  }, [_c('el-form', {
	    ref: "fileForm",
	    staticClass: "has-disabledField",
	    attrs: {
	      "model": _vm.fileForm,
	      "rules": _vm.rules
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "订单类型",
	      "prop": "order_type"
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择"
	    },
	    on: {
	      "change": function (val) {
	        return _vm.disProduct(val, true)
	      }
	    },
	    model: {
	      value: (_vm.fileForm.order_type),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "order_type", $$v)
	      },
	      expression: "fileForm.order_type"
	    }
	  }, _vm._l((_vm.orderType), function(item) {
	    return _c('el-option', {
	      key: item.order_type,
	      attrs: {
	        "label": item.order_type_str,
	        "value": item.order_type
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "产品名称",
	      "prop": "product_id"
	    }
	  }, [_c('el-cascader', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "options": _vm.productSearchItem,
	      "props": _vm.productSearchProps
	    },
	    on: {
	      "change": function (val) {
	        return _vm.handleOptionData(val, true)
	      }
	    },
	    model: {
	      value: (_vm.fileForm.product_id),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "product_id", $$v)
	      },
	      expression: "fileForm.product_id"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "申请金额",
	      "prop": "apply_price"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.fileForm.apply_price),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "apply_price", $$v)
	      },
	      expression: "fileForm.apply_price"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "申请用途",
	      "prop": "apply_purpose"
	    }
	  }, _vm._l((_vm.applyPurpose), function(radio, key) {
	    return _c('el-radio', {
	      key: key,
	      attrs: {
	        "label": radio.value
	      },
	      model: {
	        value: (_vm.fileForm.apply_purpose),
	        callback: function($$v) {
	          _vm.$set(_vm.fileForm, "apply_purpose", $$v)
	        },
	        expression: "fileForm.apply_purpose"
	      }
	    }, [_vm._v(_vm._s(radio.label))])
	  }), 1)], 1)], 1), _vm._v(" "), _c('h4', {
	    staticClass: "dialog-item-title"
	  }, [_vm._v("客户信息")]), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "客户姓名",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.fileForm.name),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "name", $$v)
	      },
	      expression: "fileForm.name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "手机号1",
	      "prop": "phone"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.fileForm.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "phone", $$v)
	      },
	      expression: "fileForm.phone"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "手机号2",
	      "prop": "phone2"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.fileForm.phone2),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "phone2", $$v)
	      },
	      expression: "fileForm.phone2"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "身份证号",
	      "prop": "idcard"
	    }
	  }, [_c('el-input', {
	    on: {
	      "change": _vm.idCardChange
	    },
	    model: {
	      value: (_vm.fileForm.idcard),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "idcard", $$v)
	      },
	      expression: "fileForm.idcard"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "性别",
	      "prop": "sex"
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.fileForm.sex),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "sex", $$v)
	      },
	      expression: "fileForm.sex"
	    }
	  }, _vm._l((_vm.userSexItem), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.name,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "出生年月",
	      "prop": "birthday"
	    }
	  }, [_c('el-date-picker', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "date",
	      "placeholder": "选择日期"
	    },
	    model: {
	      value: (_vm.fileForm.birthday),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "birthday", $$v)
	      },
	      expression: "fileForm.birthday"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "身份证有效期",
	      "prop": "idcard_validity"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "输入'长期' 或 日期（格式：2000-01-01）"
	    },
	    model: {
	      value: (_vm.fileForm.idcard_validity),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "idcard_validity", $$v)
	      },
	      expression: "fileForm.idcard_validity"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "户口所在地",
	      "prop": "resident_address"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.fileForm.resident_address),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "resident_address", $$v)
	      },
	      expression: "fileForm.resident_address"
	    }
	  }, [_c('el-cascader', {
	    attrs: {
	      "slot": "prepend",
	      "options": _vm.cities.list,
	      "props": _vm.cities.props
	    },
	    on: {
	      "active-item-change": function (val) {
	        return _vm.citiesItemChange(val, true)
	      }
	    },
	    slot: "prepend",
	    model: {
	      value: (_vm.fileForm.user_cityId),
	      callback: function($$v) {
	        _vm.$set(_vm.fileForm, "user_cityId", $$v)
	      },
	      expression: "fileForm.user_cityId"
	    }
	  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer text-right",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.showDialog = false
	      }
	    }
	  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.submitLoading,
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("确 定")])], 1)], 1)])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1228:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
	    staticClass: "content",
	    staticStyle: {
	      "margin-top": "-30px"
	    }
	  }, [_c('div', {
	    staticClass: "defaultPage",
	    attrs: {
	      "id": "defaultPage"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "padding-left": "10px",
	      "padding-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h1', [_vm._v("预存剩余")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid-content bigCard"
	  }, [_c('el-table', {
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.remain,
	      "stripe": "",
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "商户",
	      "prop": "merchant_name",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "剩余笔数",
	      "prop": "search_amount",
	      "align": "center"
	    }
	  })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "padding-left": "10px",
	      "padding-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h1', [_vm._v("上月业绩")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid-content bigCard"
	  }, [_c('el-table', {
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.staticsDataPre,
	      "stripe": "",
	      "border": ""
	    }
	  }, _vm._l((_vm.tableHeadPre), function(item, index) {
	    return _c('el-table-column', {
	      key: index,
	      attrs: {
	        "label": item.label,
	        "prop": item.prop,
	        "show-overflow-tooltip": "",
	        "align": "center",
	        "fixed": item.prop == 'merchant_name' || item.prop == 'merchant_id'
	      }
	    })
	  }), 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    staticStyle: {
	      "padding-left": "10px",
	      "padding-right": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h1', [_vm._v("本月业绩")])]), _vm._v(" "), _c('div', {
	    staticClass: "grid-content bigCard"
	  }, [_c('el-table', {
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.staticsDataCur,
	      "stripe": "",
	      "border": ""
	    }
	  }, _vm._l((_vm.tableHeadCur), function(item, index) {
	    return _c('el-table-column', {
	      key: index,
	      attrs: {
	        "label": item.label,
	        "prop": item.prop,
	        "show-overflow-tooltip": "",
	        "align": "center",
	        "fixed": item.prop == 'merchant_name' || item.prop == 'merchant_id'
	      }
	    })
	  }), 1)], 1)])], 1)], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  })])
	}]}

/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v("   ")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "defaultImg"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1066)
	    }
	  })])])])
	}]}

/***/ }),

/***/ 1253:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.popupItem) ? _c(_vm.popupItem.identify, {
	    tag: "component",
	    attrs: {
	      "id": _vm.popupItem.identify,
	      "info": _vm.popupInfo,
	      "node": _vm.popupItem,
	      "visible": _vm.showDialog
	    },
	    on: {
	      "closed": _vm.closeWin
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "content-header"
	  }, [_c('h1', {
	    staticClass: "content-title"
	  }, [_vm._v("\n                 待办任务\n             ")]), _vm._v(" "), (!_vm.isHomePage) ? _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_vm._m(0), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("待办任务")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "box-defalut box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('ul', {
	    staticClass: "nav nav-pills carFormNav"
	  }, [_c('el-row', _vm._l((_vm.tabs), function(tab, index) {
	    return _c('el-badge', {
	      key: index,
	      staticClass: "item",
	      staticStyle: {
	        "marginRight": "20px"
	      },
	      attrs: {
	        "value": tab.total
	      }
	    }, [_c('el-button', {
	      style: ([tab.show ? _vm.but_active : '', _vm.but_style]),
	      attrs: {
	        "autofocus": tab.show
	      },
	      on: {
	        "click": function (e) {
	          return _vm.changeTabs(e, tab.component, _vm.tabs)
	        }
	      }
	    }, [_vm._v(_vm._s(tab.name))])], 1)
	  }), 1)], 1)])]), _vm._v(" "), _vm._l((_vm.tabs), function(tab, index) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (tab.show),
	        expression: "tab.show"
	      }],
	      key: index,
	      staticClass: "box-defalut box"
	    }, [_c(tab.component, {
	      tag: "component",
	      attrs: {
	        "isHomePageSub": _vm.isHomePage
	      },
	      on: {
	        "getTotal": function (val) {
	          return _vm.getTotal(val, tab)
	        }
	      }
	    })], 1)
	  })], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v("   首页")])])
	}]}

/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "visible": _vm.showDialog,
	      "show-close": false,
	      "top": "10%"
	    }
	  }, [_c('el-form', {
	    ref: "orderForm",
	    staticClass: "has-disabledField",
	    attrs: {
	      "model": _vm.orderForm,
	      "rules": _vm.rules
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "订单类型",
	      "prop": "order_type",
	      "error": _vm.error.order_type,
	      "required": ""
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择"
	    },
	    on: {
	      "change": _vm.changeType
	    },
	    model: {
	      value: (_vm.orderForm.order_type),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "order_type", $$v)
	      },
	      expression: "orderForm.order_type"
	    }
	  }, _vm._l((_vm.orderType), function(item) {
	    return _c('el-option', {
	      key: item.order_type,
	      attrs: {
	        "label": item.order_type_str,
	        "value": item.order_type
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "产品",
	      "prop": "productId",
	      "error": _vm.error.product_id
	    }
	  }, [_c('el-cascader', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "options": _vm.productSearchItem,
	      "props": _vm.productSearchProps
	    },
	    model: {
	      value: (_vm.orderForm.productId),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "productId", $$v)
	      },
	      expression: "orderForm.productId"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "车牌号",
	      "prop": "car_num",
	      "error": _vm.error.car_num
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.car_num),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "car_num", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "orderForm.car_num"
	    }
	  }, [(_vm.orderForm.order_type !== 1) ? _c('el-button', {
	    attrs: {
	      "slot": "append"
	    },
	    on: {
	      "click": _vm.syn
	    },
	    slot: "append"
	  }, [_vm._v("同步客户信息")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "购车价",
	      "prop": "car_price",
	      "error": _vm.error.car_price
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.car_price),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "car_price", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "orderForm.car_price"
	    }
	  }, [(_vm.orderForm.order_type !== 1) ? _c('el-button', {
	    attrs: {
	      "slot": "append"
	    },
	    on: {
	      "click": _vm.syn
	    },
	    slot: "append"
	  }, [_vm._v("同步客户信息")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "车辆按揭状态",
	      "prop": "pay_type",
	      "error": _vm.error.pay_type
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.orderForm.pay_type),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "pay_type", $$v)
	      },
	      expression: "orderForm.pay_type"
	    }
	  }, _vm._l((_vm.payType), function(o) {
	    return _c('el-option', {
	      key: o.value,
	      attrs: {
	        "label": o.name,
	        "value": o.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "按揭公司",
	      "prop": "mortgage_company",
	      "error": _vm.error.mortgage_company
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "disabled": 1 == _vm.orderForm.pay_type
	    },
	    model: {
	      value: (_vm.orderForm.mortgage_company),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "mortgage_company", $$v)
	      },
	      expression: "orderForm.mortgage_company"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "申请金额",
	      "prop": "apply_price",
	      "error": _vm.error.apply_price
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.apply_price),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "apply_price", $$v)
	      },
	      expression: "orderForm.apply_price"
	    }
	  }, [_c('template', {
	    slot: "append"
	  }, [_vm._v("元")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "申请用途",
	      "prop": "apply_purpose",
	      "error": _vm.error.apply_purpose
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.apply_purpose),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "apply_purpose", $$v)
	      },
	      expression: "orderForm.apply_purpose"
	    }
	  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("客户信息")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "客户姓名",
	      "prop": "name",
	      "error": _vm.error.name
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.name),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "name", $$v)
	      },
	      expression: "orderForm.name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "手机号码",
	      "prop": "phone",
	      "error": _vm.error.phone
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "phone", $$v)
	      },
	      expression: "orderForm.phone"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "手机号码2",
	      "prop": "phone2",
	      "error": _vm.error.phone2
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.phone2),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "phone2", $$v)
	      },
	      expression: "orderForm.phone2"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "身份证号",
	      "prop": "idcard",
	      "error": _vm.error.idcard
	    }
	  }, [_c('el-input', {
	    on: {
	      "change": _vm.idCardChange
	    },
	    model: {
	      value: (_vm.orderForm.idcard),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "idcard", $$v)
	      },
	      expression: "orderForm.idcard"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "出生年月",
	      "prop": "birthday",
	      "error": _vm.error.birthday
	    }
	  }, [_c('el-date-picker', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "date",
	      "placeholder": "选择日期"
	    },
	    model: {
	      value: (_vm.orderForm.birthday),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "birthday", $$v)
	      },
	      expression: "orderForm.birthday"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "性别",
	      "prop": "sex",
	      "error": _vm.error.sex
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.orderForm.sex),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "sex", $$v)
	      },
	      expression: "orderForm.sex"
	    }
	  }, _vm._l((_vm.userSexItem), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.name,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "户口所在地",
	      "prop": "resident_address",
	      "error": _vm.error.resident_address
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.orderForm.resident_address),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "resident_address", $$v)
	      },
	      expression: "orderForm.resident_address"
	    }
	  }, [_c('el-cascader', {
	    attrs: {
	      "slot": "prepend",
	      "options": _vm.cities.list,
	      "props": _vm.cities.props
	    },
	    on: {
	      "active-item-change": function (val) {
	        return _vm.citiesItemChange(val, true)
	      }
	    },
	    slot: "prepend",
	    model: {
	      value: (_vm.orderForm.user_cityId),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "user_cityId", $$v)
	      },
	      expression: "orderForm.user_cityId"
	    }
	  })], 1)], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-header"
	  }, [_c('h3', {
	    staticClass: "box-title"
	  }, [_vm._v("流程信息")])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body"
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [(_vm.showCheckCar) ? _c('el-col', {
	    attrs: {
	      "span": 20
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "position": "absolute",
	      "top": "10px",
	      "color": "red"
	    }
	  }, [_vm._v("*")]), _vm._v(" "), _c('el-form-item', {
	    staticStyle: {
	      "margin-left": "10px"
	    },
	    attrs: {
	      "label": "是否验车",
	      "prop": "is_check_car"
	    }
	  }, [_c('el-radio-group', {
	    model: {
	      value: (_vm.is_check_car),
	      callback: function($$v) {
	        _vm.is_check_car = $$v
	      },
	      expression: "is_check_car"
	    }
	  }, [_c('el-radio', {
	    attrs: {
	      "label": 1
	    }
	  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
	    attrs: {
	      "label": 0
	    }
	  }, [_vm._v("否")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "估价方式",
	      "prop": "car_load_type",
	      "error": _vm.error.car_load_type
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.orderForm.car_load_type),
	      callback: function($$v) {
	        _vm.$set(_vm.orderForm, "car_load_type", $$v)
	      },
	      expression: "orderForm.car_load_type"
	    }
	  }, _vm._l((_vm.carLoadType), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.name,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1)], 1)], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.showDialog = false
	      }
	    }
	  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("确 定")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }, {
	      name: "loading",
	      rawName: "v-loading.fullscreen.lock",
	      value: (_vm.fullscreenLoading),
	      expression: "fullscreenLoading",
	      modifiers: {
	        "fullscreen": true,
	        "lock": true
	      }
	    }],
	    attrs: {
	      "id": "page"
	    }
	  }, [(!_vm.login) ? _c('loginArea') : _vm._e(), _vm._v(" "), (_vm.login) ? _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "siteWrapper"
	    }
	  }, [_c('header', {
	    staticClass: "main-header"
	  }, [_c('a', {
	    staticClass: "logo",
	    attrs: {
	      "href": "/#"
	    }
	  }, [_vm._v("\n                    HR融担平台\n                ")]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar navbar-static-top"
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav hidden-xs"
	  }, [((_vm.role_oper_type == 2 || _vm.role_oper_type == 3)) ? _c('li', {
	    class: _vm.areaName == 'home' ? 'active' : ''
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/homePage"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-home"
	  }), _vm._v("  主页")])], 1) : _vm._e(), _vm._v(" "), (_vm.top_chedaiTab) ? _c('li', {
	    class: {
	      "active": (_vm.areaName == "chedai")
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.top_chedaiTab.href
	    }
	  }, [_c('i', {
	    class: _vm.top_chedaiTab.icon
	  }), _vm._v(" " + _vm._s(_vm.top_chedaiTab.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topAdminTab) ? _c('li', {
	    class: {
	      "active": (_vm.areaName == "erp")
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.topAdminTab.href
	    }
	  }, [_c('i', {
	    class: _vm.topAdminTab.icon
	  }), _vm._v("  " + _vm._s(_vm.topAdminTab.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topCarTab) ? _c('li', {
	    class: {
	      "active": (_vm.areaName == "car")
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.topCarTab.href
	    }
	  }, [_c('i', {
	    class: _vm.topCarTab.icon
	  }), _vm._v("  " + _vm._s(_vm.topCarTab.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topFastDebit) ? _c('li', {
	    class: {
	      "active": (_vm.areaName == "csd")
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.topFastDebit.href
	    }
	  }, [_c('i', {
	    class: _vm.topFastDebit.icon
	  }), _vm._v("  " + _vm._s(_vm.topFastDebit.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topBackTab) ? _c('li', [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [(_vm.topTodo) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": _vm.topTodo.href
	    }
	  }, [_vm._v("\n                                    " + _vm._s(_vm.topTodo.name) + "   "), _c('i', {
	    class: _vm.topTodo.icon
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.taskCount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.topMsg) ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": _vm.topMsg.href
	    }
	  }, [_vm._v("\n                                    " + _vm._s(_vm.topMsg.name) + "   "), _c('i', {
	    class: _vm.topMsg.icon
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-danger"
	  }, [_vm._v(_vm._s(_vm.msgCount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.topNotify) ? _c('li', {
	    attrs: {
	      "id": "infoCounter"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/user/taskNotify"
	    }
	  }, [_vm._v("\n                                    估价提醒   "), _c('i', {
	    staticClass: "fa fa-bell-o"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "label label-success"
	  }, [_vm._v(_vm._s(_vm.priceCount))])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "dropdown user user-menu"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('img', {
	    staticClass: "user-image",
	    attrs: {
	      "src": "static/img/avatar.png",
	      "alt": _vm.user.name
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "user-header"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "static/img/avatar.png",
	      "alt": _vm.user.name
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("\n                                            " + _vm._s(_vm.user.name) + "\n                                            "), _c('small', [_vm._v(_vm._s(_vm.user.depart_name) + " - " + _vm._s(_vm.user.role_name))])])]), _vm._v(" "), _c('li', {
	    staticClass: "user-footer"
	  }, [_c('div', {
	    staticClass: "pull-left"
	  }, [_c('router-link', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "to": "/user/info"
	    }
	  }, [_vm._v("个人资料\n                                            ")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('a', {
	    staticClass: "btn btn-default btn-flat",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.userSignOut.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("退出")])])])])])])])])]), _vm._v(" "), _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('sidebarArea', {
	    attrs: {
	      "sideparamas": _vm.areaName
	    }
	  })], 1), _vm._v(" "), _c('router-view', {
	    staticClass: "content-wrapper"
	  })], 1) : _vm._e(), _vm._v(" "), _c('createWin', {
	    attrs: {
	      "visible": _vm.showCreateWin
	    },
	    on: {
	      "closed": function($event) {
	        _vm.showCreateWin = false
	      }
	    }
	  }), _vm._v(" "), _c('createFile', {
	    attrs: {
	      "visible": _vm.showCreateFile
	    },
	    on: {
	      "closed": function($event) {
	        _vm.showCreateFile = false
	      }
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "sidebar-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "offcanvas",
	      "title": "展开边栏",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("展开边栏")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-reply"
	  }), _vm._v("  返回")])
	}]}

/***/ }),

/***/ 1291:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-body table-responsive no-padding"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "stripe": "",
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "type": "selection",
	      "width": "55",
	      "align": "center"
	    }
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "prop": "order_id_sn",
	      "label": "ID",
	      "width": "240",
	      "align": "center"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "product_type",
	      "label": "业务种类",
	      "width": "120"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "customer",
	      "label": "客户姓名",
	      "width": "100",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "产品",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "settle_type",
	      "label": "结清类型",
	      "align": "center",
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n                        " + _vm._s(scope.row.settle_type == 1 ? '正常结清' : scope.row.settle_type == 2 ? '拖车结清' : scope.row.settle_type == 3 ? '卖车结清' : '特殊结清') + "\n                     ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "total_settle",
	      "label": "结清金额",
	      "align": "center"
	    }
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "depart_name",
	      "label": "门店",
	      "align": "right"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "create_name",
	      "label": "申请人",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "staff_name",
	      "label": "业务员",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "active_time",
	      "label": "最后处理时间",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "right",
	      "label": "操作",
	      "width": "250"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(0 == scope.row.staff_id) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showChoice', scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.node_name))]) : _c('el-button', {
	          attrs: {
	            "type": "success",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'goto', scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.node_name))]), _vm._v(" "), (2 == scope.row.last_transition_type) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showMsg', scope.row)
	            }
	          }
	        }, [_vm._v("退回原因")]) : _vm._e()]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer clearfix"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-sm-6 text-right"
	  }, [_c('el-pagination', {
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [20, 30, 50, 100],
	      "page-size": _vm.pageSize,
	      "total": _vm.totalRow,
	      "layout": "total, prev, pager, next, sizes, jumper"
	    },
	    on: {
	      "size-change": _vm.sizeChangeHandle,
	      "current-change": _vm.pageChangeHandle
	    }
	  })], 1)])])])])])]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.backMsgDialog.title,
	      "visible": _vm.backMsgDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.backMsgDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "backMsgForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "退回原因",
	      "prop": "last_msg",
	      "error": _vm.error.last_msg
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "textarea",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.backMsgDialog.last_msg),
	      callback: function($$v) {
	        _vm.$set(_vm.backMsgDialog, "last_msg", $$v)
	      },
	      expression: "backMsgDialog.last_msg"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.backMsgDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.choiceDialog.title,
	      "visible": _vm.choiceDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.choiceDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "choiceForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "分配给",
	      "prop": "staff_id",
	      "error": _vm.error.staff_id
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择",
	      "required": ""
	    },
	    model: {
	      value: (_vm.choiceDialog.staff_id),
	      callback: function($$v) {
	        _vm.$set(_vm.choiceDialog, "staff_id", $$v)
	      },
	      expression: "choiceDialog.staff_id"
	    }
	  }, _vm._l((_vm.staffChoiceList), function(item) {
	    return _c('el-option', {
	      key: item.staff_id,
	      attrs: {
	        "label": item.name,
	        "value": item.staff_id
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.choiceDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function (e) {
	        return _vm.pageActionHandle(e, 'choiceForm', _vm.choiceDialog)
	      }
	    }
	  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('popupWin', {
	    attrs: {
	      "visible": _vm.showPopupWin,
	      "info": _vm.popupWinInfo
	    },
	    on: {
	      "closed": function($event) {
	        _vm.showPopupWin = false
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": _vm.pageTitle,
	      "visible": _vm.showDialog,
	      "show-close": false
	    }
	  }, [_c('el-form', {
	    ref: "reviewForm",
	    staticClass: "has-disabledField",
	    attrs: {
	      "model": _vm.reviewForm,
	      "rules": _vm.rules,
	      "label-width": "140px"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "是否复议",
	      "prop": "type",
	      "error": _vm.error.type,
	      "required": ""
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.reviewForm.type),
	      callback: function($$v) {
	        _vm.$set(_vm.reviewForm, "type", $$v)
	      },
	      expression: "reviewForm.type"
	    }
	  }, _vm._l((_vm.reviewType), function(o) {
	    return _c('el-option', {
	      key: o.value,
	      attrs: {
	        "label": o.name,
	        "value": o.value
	      }
	    })
	  }), 1)], 1), _vm._v(" "), (false) ? _c('el-form-item', {
	    attrs: {
	      "label": "建议金额",
	      "prop": "advicePrice",
	      "error": _vm.error.advicePrice,
	      "required": ""
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.reviewForm.advicePrice),
	      callback: function($$v) {
	        _vm.$set(_vm.reviewForm, "advicePrice", $$v)
	      },
	      expression: "reviewForm.advicePrice"
	    }
	  }, [_c('template', {
	    slot: "append"
	  }, [_vm._v("元")])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.reviewForm.type == 1) ? _c('el-form-item', {
	    attrs: {
	      "label": "退回节点",
	      "prop": "backNode",
	      "error": _vm.error.backNode,
	      "required": ""
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "placeholder": "请选择"
	    },
	    model: {
	      value: (_vm.reviewForm.backNode),
	      callback: function($$v) {
	        _vm.$set(_vm.reviewForm, "backNode", $$v)
	      },
	      expression: "reviewForm.backNode"
	    }
	  }, _vm._l((_vm.backNodeList), function(item) {
	    return _c('el-option', {
	      key: item.order_node_id,
	      attrs: {
	        "value": item.order_node_id,
	        "label": item.node_name
	      }
	    })
	  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.reviewForm.type == 1) ? _c('el-form-item', {
	    attrs: {
	      "label": "建议原因",
	      "prop": "mark",
	      "error": _vm.error.mark,
	      "required": ""
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "textarea"
	    },
	    model: {
	      value: (_vm.reviewForm.mark),
	      callback: function($$v) {
	        _vm.$set(_vm.reviewForm, "mark", $$v)
	      },
	      expression: "reviewForm.mark"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.showDialog = false
	      }
	    }
	  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.submitLoading
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("确 定")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1308:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "box box-default"
	  }, [_c('div', {
	    staticClass: "box-body table-responsive no-padding"
	  }, [_c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.body",
	      value: (_vm.loading),
	      expression: "loading",
	      modifiers: {
	        "body": true
	      }
	    }],
	    staticClass: "cd-todoTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "stripe": "",
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "type": "selection",
	      "width": "55",
	      "align": "center"
	    }
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "prop": "order_id_sn",
	      "label": "ID",
	      "width": "240",
	      "align": "center"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "product_type",
	      "label": "业务种类",
	      "width": "120"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "customer",
	      "label": "客户姓名",
	      "width": "100",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "产品",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "退款类型",
	      "align": "center",
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return (scope.row.orderRefund && scope.row.orderRefund.refund_item.length > 0) ? [_c('span', [_vm._v(_vm._s(scope.row.orderRefund.refund_item[0].title) + ":" + _vm._s(scope.row.orderRefund.refund_item[0].value))]), _c('br'), _vm._v(" "), (scope.row.orderRefund.refund_item) ? _c('el-button', {
	          attrs: {
	            "type": "text",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showChargeType', scope.row)
	            }
	          }
	        }, [_vm._v("查看更多")]) : _vm._e()] : undefined
	      }
	    }], null, true)
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "product_name",
	      "label": "退款金额",
	      "align": "center"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return (scope.row.orderRefund) ? [_c('span', [_vm._v(_vm._s(scope.row.orderRefund.total_amount))])] : undefined
	      }
	    }], null, true)
	  }), _vm._v(" "), (!_vm.isHomePageSub) ? _c('el-table-column', {
	    attrs: {
	      "prop": "depart_name",
	      "label": "门店",
	      "align": "right"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "originator",
	      "label": "申请人",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "staff_name",
	      "label": "业务员",
	      "align": "right"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "active_time",
	      "label": "最后处理时间",
	      "align": "center"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "right",
	      "label": "操作",
	      "width": "250"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(0 == scope.row.staff_id) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showChoice', scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.node_name))]) : _c('el-button', {
	          attrs: {
	            "type": "success",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'goto', scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.node_name))]), _vm._v(" "), (2 == scope.row.last_transition_type) ? _c('el-button', {
	          attrs: {
	            "type": "warning",
	            "size": "small"
	          },
	          on: {
	            "click": function (e) {
	              return _vm.rowActionHandle(e, 'showMsg', scope.row)
	            }
	          }
	        }, [_vm._v("退回原因")]) : _vm._e()]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer clearfix"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-sm-6"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8 col-sm-6 text-right"
	  }, [_c('el-pagination', {
	    attrs: {
	      "current-page": _vm.currentPage,
	      "page-sizes": [20, 30, 50, 100],
	      "page-size": _vm.pageSize,
	      "total": _vm.totalRow,
	      "layout": "total, prev, pager, next, sizes, jumper"
	    },
	    on: {
	      "size-change": _vm.sizeChangeHandle,
	      "current-change": _vm.pageChangeHandle
	    }
	  })], 1)])])])])])]), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.chargeMsgDialog.title,
	      "visible": _vm.chargeMsgDialog.visible,
	      "stripe": ""
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.chargeMsgDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.chargeMsgDialog.data,
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "property": "title",
	      "label": "退款类型"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "property": "value",
	      "label": "退款金额"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.backMsgDialog.title,
	      "visible": _vm.backMsgDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.backMsgDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "backMsgForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "退回原因",
	      "prop": "last_msg",
	      "error": _vm.error.last_msg
	    }
	  }, [_c('el-input', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "textarea",
	      "disabled": ""
	    },
	    model: {
	      value: (_vm.backMsgDialog.last_msg),
	      callback: function($$v) {
	        _vm.$set(_vm.backMsgDialog, "last_msg", $$v)
	      },
	      expression: "backMsgDialog.last_msg"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.backMsgDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.choiceDialog.title,
	      "visible": _vm.choiceDialog.visible,
	      "size": "tiny"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.choiceDialog, "visible", $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "choiceForm"
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "分配给",
	      "prop": "staff_id",
	      "error": _vm.error.staff_id
	    }
	  }, [_c('el-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "filterable": "",
	      "placeholder": "请选择",
	      "required": ""
	    },
	    model: {
	      value: (_vm.choiceDialog.staff_id),
	      callback: function($$v) {
	        _vm.$set(_vm.choiceDialog, "staff_id", $$v)
	      },
	      expression: "choiceDialog.staff_id"
	    }
	  }, _vm._l((_vm.staffChoiceList), function(item) {
	    return _c('el-option', {
	      key: item.staff_id,
	      attrs: {
	        "label": item.name,
	        "value": item.staff_id
	      }
	    })
	  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": function($event) {
	        _vm.choiceDialog.visible = false
	      }
	    }
	  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function (e) {
	        return _vm.pageActionHandle(e, 'choiceForm', _vm.choiceDialog)
	      }
	    }
	  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('popupWin', {
	    attrs: {
	      "visible": _vm.showPopupWin,
	      "info": _vm.popupWinInfo
	    },
	    on: {
	      "closed": function($event) {
	        _vm.showPopupWin = false
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.914651375e993930571a.js